// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/assets/images/webp/service-item-bg.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../public/assets/images/webp/meetings-bg.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../public/assets/images/webp/facts-bg.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../public/assets/images/webp/video-item-bg.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../public/assets/images/webp/heading-bg.webp", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../public/assets/images/webp/meetings-page-bg.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Poppins:100,200,300,400,500,600,700,800,900);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.app-container {
  font-family: Arial, sans-serif;
  background-color: #fff;
}

/* Dashboard CTA shown to logged-in users */
.dashboard-btn {
  background: linear-gradient(135deg, #06b6d4, #3c82ff);
  color: #fff;
  padding: 12px 28px;
  border-radius: 22px;
  border: none;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 6px 18px rgba(60,124,255,0.16);
}

.dashboard-btn:hover { transform: translateY(-2px); box-shadow: 0 8px 22px rgba(60,124,255,0.22); }


body {
  margin: 0;
  font-family: 'Roboto', sans-serif;
}


a.active {
  color: #007bff;
}

.featured-universities {
  padding: 40px 20px;
  background-color: #f9f9f9; 
  text-align: center;
}

.featured-universities h2 {
  font-size: 36px;
  font-weight: 700;
  color: #333;
  margin-bottom: 30px;
}


.featured-universities .university-slider {
  margin-top: 20px;
}



/* Templatemo-edu-meeting.css */
/*

TemplateMo 569 Edu Meeting

https://templatemo.com/tm-569-edu-meeting

*/

/* ---------------------------------------------
Table of contents
------------------------------------------------
01. font & reset css
02. reset
03. global styles
04. header
05. banner
06. features
07. testimonials
08. contact
09. footer
10. preloader
11. search
12. portfolio

--------------------------------------------- */
/* 
---------------------------------------------
font & reset css
--------------------------------------------- 
*/
/* 
---------------------------------------------
reset
--------------------------------------------- 
*/
html, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, div
pre, a, abbr, acronym, address, big, cite, code, del, dfn, em, font, img, ins, kbd, q,
s, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li,
figure, header, nav, section, article, aside, footer, figcaption {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
}

.clearfix:after {
  content: ".";
  display: block;
  clear: both;
  visibility: hidden;
  line-height: 0;
  height: 0;
}

.clearfix {
  display: inline-block;
}

html[xmlns] .clearfix {
  display: block;
}

* html .clearfix {
  height: 1%;
}

ul, li {
  padding: 0;
  margin: 0;
  list-style: none;
}

header, nav, section, article, aside, footer, hgroup {
  display: block;
}

* {
  box-sizing: border-box;
}

html, body {
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  background-color: #fff;
  font-size: 14px;
  -ms-text-size-adjust: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

a {
  text-decoration: none !important;
  color: #3CF;
}

a:hover {
	color: #FC3;
}

h1, h2, h3, h4, h5, h6 {
  margin-top: 0px;
  margin-bottom: 0px;
}

ul {
  margin-bottom: 0px;
}

p {
  font-size: 14px;
  line-height: 25px;
  color: #2a2a2a;
}

img {
  width: 100%;
  overflow: hidden;
}

/* 
---------------------------------------------
global styles
--------------------------------------------- 
*/
html,
body {
  background: #fff;
  font-family: 'Poppins', sans-serif;
}

::selection {
  background: #f5a425;
  color: #fff;
}

::-moz-selection {
  background: #f5a425;
  color: #fff;
}

@media (max-width: 991px) {
  html, body {
    overflow-x: hidden;
  }
  .mobile-top-fix {
    margin-top: 30px;
    margin-bottom: 0px;
  }
  .mobile-bottom-fix {
    margin-bottom: 30px;
  }
  .mobile-bottom-fix-big {
    margin-bottom: 60px;
  }
}

.main-button-red a {
  font-size: 13px;
  color: var(--text-color); /* #fff */
  background: linear-gradient(135deg, #2563eb, #3b82f6);/* dashboard-style gradient */
  padding: 12px 30px;
  display: inline-block;
  border-radius: 22px;
  font-weight: 500;
  font-family: var(--font-family);
  transition: all 0.3s ease;
  text-decoration: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.main-button-red a:hover {
  background-color: var(--text-color);
  color: var(--primary-bg);
  border: 1px solid var(--accent-color);
}


.read-more-button a {
  color: #2596be; /* or use var(--accent-color) */
  text-decoration: none; /* removes underline */
  font-weight: 500;
  font-size: 1rem;
  padding: 0;
  background: transparent;
}

.read-more-button a:hover {
  color: #1e88e5; /* optional: slightly darker on hover */
  text-decoration: none;
}


.main-button-yellow a {
  font-size: 13px;
  color: #fff;
  background-color: #ffffff;
  padding: 12px 30px;
  display: inline-block;
  border-radius: 22px;
  font-weight: 500;
  text-transform: uppercase;
  transition: all .3s;
}

.main-button-yellow a:hover {
  opacity: 0.9;
  background-color: #ffffff;
}

.section-heading h2 {
  line-height: 40px;
  margin-top: 0px;
  margin-bottom: 50px; 
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(250,250,250,0.15);
  font-size: 32px;
  font-weight: 700;
  /* text-transform: uppercase; */
  text-align: center;
  color: #fff;
}


/* 
---------------------------------------------
header
--------------------------------------------- 
*/

.sub-header {
  background-color: #1f272b;
  position: relative;
  z-index: 1111;
}

.sub-header .left-content p {
  color: #fff;
  padding: 8px 0px;
  font-size: 13px;
}

.sub-header .right-icons {
  text-align: right;
  padding: 8px 0px;
}

.sub-header .right-icons ul li {
  display: inline-block;
  margin-left: 15px;
}

.sub-header .right-icons ul li a {
  color: #fff;
  font-size: 14px;
  transition: all .3s;
}

.sub-header .right-icons ul li a:hover {
  color: #f5a425;
}

.sub-header .left-content p em {
   font-style: normal;
   color: #f5a425;
}

.background-header {
  background-color: #fff!important;
  height: 80px!important;
  position: fixed!important;
  top: 0!important;
  left: 0;
  right: 0;
  box-shadow: 0px 0px 10px rgba(0,0,0,0.15)!important;
}

.background-header .main-nav .nav li a {
  color: #1e1e1e!important;
}

.background-header .logo,
.background-header .main-nav .nav li a {
  color: #1e1e1e!important;
}

.background-header .main-nav .nav li:hover a {
  color: #fb5849!important;
}

.background-header .nav li a.active {
  color: #fb5849!important;
}

.header-area {
  background-color: rgba(250,250,250,0.15);
  position: absolute;
  top: 40px;
  left: 0;
  right: 0;
  z-index: 100;
  transition: all .5s ease 0s;
}

.header-area .main-nav {
  min-height: 80px;
  background: transparent;
}

.header-area .main-nav .logo {
  line-height: 100px;
  color: #fff;
  font-size: 28px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 2px;
  float: left;
  transition: all 0.3s ease 0s;
}

.background-header .main-nav .logo {
  line-height: 75px;
}

.background-header .nav {
  margin-top: 20px !important;
}

.header-area .main-nav .nav {
  float: right;
  margin-top: 30px;
  margin-right: 0px;
  background-color: transparent;
  transition: all 0.3s ease 0s;
  position: relative;
  z-index: 999;
}

.header-area .main-nav .nav li {
  padding-left: 15px;
  padding-right: 15px;
}

.header-area .main-nav .nav li:last-child {
  padding-right: 0px;
}

.header-area .main-nav .nav li a {
  display: block;
  font-weight: 500;
  font-size: 14px;
  text-transform: uppercase;
  color: #fff;
  transition: all 0.3s ease 0s;
  height: 40px;
  line-height: 40px;
  border: transparent;
  letter-spacing: 1px;
}

.header-area .main-nav .nav li:hover a,
.header-area .main-nav .nav li a.active {
  color: #f5a425!important;
}

.background-header .main-nav .nav li:hover a,
.background-header .main-nav .nav li a.active {
  color: #f5a425!important;
  opacity: 1;
}

.header-area .main-nav .nav li.has-sub {
  position: relative;
  padding-right: 15px;
}

.header-area .main-nav .nav li.has-sub:after {
  font-family: FontAwesome;
  content: "\\f107";
  font-size: 12px;
  color: #fff;
  position: absolute;
  right: 5px;
  top: 12px;
}

.background-header .main-nav .nav li.has-sub:after {
  color: #1e1e1e;
}

.header-area .main-nav .nav li.has-sub ul.sub-menu {
  position: absolute;
  width: 200px;
  box-shadow: 0 2px 28px 0 rgba(0, 0, 0, 0.06);
  overflow: hidden;
  top: 40px;
  opacity: 0;
  transition: all .3s;
  transform: translateY(+2em);
  visibility: hidden;
  z-index: -1;
}

.header-area .main-nav .nav li.has-sub ul.sub-menu li {
  margin-left: 0px;
  padding-left: 0px;
  padding-right: 0px;
}

.header-area .main-nav .nav li.has-sub ul.sub-menu li a {
  opacity: 1;
  display: block;
  background: #f7f7f7;
  color: #2a2a2a!important;
  padding-left: 20px;
  height: 40px;
  line-height: 40px;
  transition: all 0.3s ease 0s;
  position: relative;
  font-size: 13px;
  font-weight: 400;
  border-bottom: 1px solid #eee;
}

.header-area .main-nav .nav li.has-sub ul li a:hover {
  background: #fff;
  color: #f5a425!important;
  padding-left: 25px;
}

.header-area .main-nav .nav li.has-sub ul li a:hover:before {
  width: 3px;
}

.header-area .main-nav .nav li.has-sub:hover ul.sub-menu {
  visibility: visible;
  opacity: 1;
  z-index: 1;
  transform: translateY(0%);
  transition-delay: 0s, 0s, 0.3s;
}

.header-area .main-nav .menu-trigger {
  cursor: pointer;
  display: block;
  position: absolute;
  top: 33px;
  width: 32px;
  height: 40px;
  text-indent: -9999em;
  z-index: 99;
  right: 40px;
  display: none;
}

.background-header .main-nav .menu-trigger {
  top: 23px;
}

.header-area .main-nav .menu-trigger span,
.header-area .main-nav .menu-trigger span:before,
.header-area .main-nav .menu-trigger span:after {
  transition: all 0.4s;
  background-color: #1e1e1e;
  display: block;
  position: absolute;
  width: 30px;
  height: 2px;
  left: 0;
}

.background-header .main-nav .menu-trigger span,
.background-header .main-nav .menu-trigger span:before,
.background-header .main-nav .menu-trigger span:after {
  background-color: #1e1e1e;
}

.header-area .main-nav .menu-trigger span:before,
.header-area .main-nav .menu-trigger span:after {
  transition: all 0.4s;
  background-color: #1e1e1e;
  display: block;
  position: absolute;
  width: 30px;
  height: 2px;
  left: 0;
  width: 75%;
}

.background-header .main-nav .menu-trigger span:before,
.background-header .main-nav .menu-trigger span:after {
  background-color: #1e1e1e;
}

.header-area .main-nav .menu-trigger span:before,
.header-area .main-nav .menu-trigger span:after {
  content: "";
}

.header-area .main-nav .menu-trigger span {
  top: 16px;
}

.header-area .main-nav .menu-trigger span:before {
  transform-origin: 33% 100%;
  top: -10px;
  z-index: 10;
}

.header-area .main-nav .menu-trigger span:after {
  transform-origin: 33% 0;
  top: 10px;
}

.header-area .main-nav .menu-trigger.active span,
.header-area .main-nav .menu-trigger.active span:before,
.header-area .main-nav .menu-trigger.active span:after {
  background-color: transparent;
  width: 100%;
}

.header-area .main-nav .menu-trigger.active span:before {
  transform: translateY(6px) translateX(1px) rotate(45deg);
  background-color: #1e1e1e;
}

.background-header .main-nav .menu-trigger.active span:before {
  background-color: #1e1e1e;
}

.header-area .main-nav .menu-trigger.active span:after {
  transform: translateY(-6px) translateX(1px) rotate(-45deg);
  background-color: #1e1e1e;
}

.background-header .main-nav .menu-trigger.active span:after {
  background-color: #1e1e1e;
}

.header-area.header-sticky {
  min-height: 80px;
}

.header-area .nav {
  margin-top: 30px;
}

.header-area.header-sticky .nav li a.active {
  color: #f5a425;
}

@media (max-width: 1200px) {
  .header-area .main-nav .nav li {
    padding-left: 7px;
    padding-right: 7px;
  }
  .header-area .main-nav:before {
    display: none;
  }
}

@media (max-width: 767px) {
  .header-area .main-nav .logo {
    color: #1e1e1e;
  }
  .header-area.header-sticky .nav li a:hover,
  .header-area.header-sticky .nav li a.active {
    color: #f5a425!important;
    opacity: 1;
  }
  .header-area.header-sticky .nav li.search-icon a {
    width: 100%;
  }
  .header-area {
    background-color: #f7f7f7;
    padding: 0px 15px;
    height: 100px;
    box-shadow: none;
    text-align: center;
  }
  .header-area .container {
    padding: 0px;
  }
  .header-area .logo {
    margin-left: 30px;
  }
  .header-area .menu-trigger {
    display: block !important;
  }
  .header-area .main-nav {
    overflow: hidden;
  }
  .header-area .main-nav .nav {
    float: none;
    width: 100%;
    display: none;
    transition: all 0s ease 0s;
    margin-left: 0px;
  }
  .header-area .main-nav .nav li:first-child {
    border-top: 1px solid #eee;
  }
  .header-area.header-sticky .nav {
    margin-top: 100px !important;
  }
  .header-area .main-nav .nav li {
    width: 100%;
    background: #fff;
    border-bottom: 1px solid #eee;
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .header-area .main-nav .nav li a {
    height: 50px !important;
    line-height: 50px !important;
    padding: 0px !important;
    border: none !important;
    background: #f7f7f7 !important;
    color: #191a20 !important;
  }
  .header-area .main-nav .nav li a:hover {
    background: #eee !important;
    color: #f5a425!important;
  }
  .header-area .main-nav .nav li.has-sub ul.sub-menu {
    position: relative;
    visibility: inherit;
    opacity: 1;
    z-index: 1;
    transform: translateY(0%);
    top: 0px;
    width: 100%;
    box-shadow: none;
    height: 0px;
    transition: all 0s;
  }
  .header-area .main-nav .nav li.submenu ul li a {
    font-size: 12px;
    font-weight: 400;
  }
  .header-area .main-nav .nav li.submenu ul li a:hover:before {
    width: 0px;
  }
  .header-area .main-nav .nav li.has-sub ul.sub-menu {
    height: auto;
  }
  .header-area .main-nav .nav li.has-sub:after {
    color: #3B566E;
    right: 30px;
    font-size: 14px;
    top: 15px;
  }
  .header-area .main-nav .nav li.submenu:hover ul, .header-area .main-nav .nav li.submenu:focus ul {
    height: 0px;
  }
}

@media (min-width: 767px) {
  .header-area .main-nav .nav {
    display: flex !important;
  }
}


/* 
---------------------------------------------
banner
--------------------------------------------- 
*/

.main-banner {
  position: relative;
  max-height: 100%;
  overflow: hidden;
  margin-bottom: -7px;
}

#bg-video {
    min-width: 100%;
    min-height: 100vh;
    max-width: 100%;
    max-height: 100vh;
    object-fit: cover;
    z-index: -1;
}

#bg-video::-webkit-media-controls {
    display: none !important;
}

.video-overlay {
    position: absolute;
    background-color: rgba(31,39,43,0.75);
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
}

.main-banner .caption {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.main-banner .caption h6 {
  margin-top: 0px;
  font-size: 18px;
  /* text-transform: uppercase; */
  font-weight: 600;
  color: #fff;
  letter-spacing: 1px;
}

.main-banner .caption h1 {
  margin-top: 20px;
  margin-bottom: 20px;
  font-size: 50px;
  /* text-transform: uppercase; */
  font-weight: 600;
  color: #fff;
  letter-spacing: 1px;
}

.main-banner .caption h1 em {
  font-style: normal;
  color: #f5a425;
  font-weight: 900;
}

.main-banner .caption p {
  color: #fff;
  font-size: 16px;
  max-width: 570px;
}

.main-banner .caption .main-button-red {
  margin-top: 30px;
}

@media screen and (max-width: 767px) {

  .main-banner .caption h6 {
    font-weight: 500;
  }

  .main-banner .caption h1 {
    font-size: 36px;
  }

}


/*
---------------------------------------------
services
---------------------------------------------
*/

.services {
  margin-top: -135px;
  position: absolute;
  width: 100%;
}

.services .item {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  border-radius: 20px;
  text-align: center;
  color: #fff;
  padding: 40px;
}

.services .item .icon {
  max-width: 60px;
  margin: 0 auto;
}

.services .item h4 {
  margin-top: 25px;
  margin-bottom: 15px;
  font-size: 18px;
  font-weight: 600;
}

.services .item p {
  color: #fff;
  font-size: 13px;
}

.services .owl-nav {
  display: inline-block !important;
  text-align: center;
  position: absolute;
  width: 100%;
  top: 50%;
  transform: translateY(-25px);
}
    
.services .owl-nav .owl-prev{
  margin-right: 10px;
  outline: none;
  position: absolute;
  left: -80px;
}

.services .owl-nav .owl-prev span,
.services .owl-nav .owl-next span {
  opacity: 0;
}

.services .owl-nav .owl-prev:before {
  display: inline-block;
  font-family: 'FontAwesome';
  color: #1e1e1e;
  font-size: 25px;
  font-weight: 700;
  content: '\\f104';
  background-color: #fff;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  line-height: 50px;
}

.services .owl-nav .owl-prev {
  opacity: 1;
  transition: all .5s;
}

.services .owl-nav .owl-prev:hover {
  opacity: 0.9;
}

.services .owl-nav .owl-next {
  opacity: 1;
  transition: all .5s;
}

.services .owl-nav .owl-next:hover {
  opacity: 0.9;
}

.services .owl-nav .owl-next{
  margin-left: 10px;
  outline: none;
  position: absolute;
  right: -85px;
}

.services .owl-nav .owl-next:before {
  display: inline-block;
  font-family: 'FontAwesome';
  color: #1e1e1e;
  font-size: 25px;
  font-weight: 700;
  content: '\\f105';
  background-color: #fff;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  line-height: 50px;
}


/*
---------------------------------------------
upcoming meetings
---------------------------------------------
*/

section.upcoming-meetings {
  /* background-image: url(../public/assets/images/webp/meetings-bg.webp); */
  background-color: #2596be;
  background-position: center center;
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;
  padding-top: 100px;
  padding-bottom: 100px;
}

section.upcoming-meetings .section-heading {
  text-align: center;
}

section.upcoming-meetings .categories {
  background-color: #fff;
  border-radius: 20px;
  padding: 40px;
  margin-right: 45px;
}

section.upcoming-meetings .categories h4 {
  font-size: 18px;
  font-weight: 600;
  color: #1f272b;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}

section.upcoming-meetings .categories ul li {
  display: inline-block;
  margin-bottom: 15px;
}

section.upcoming-meetings .categories ul li a {
  font-size: 15px;
  color: #1f272b;
  font-weight: 500;
  transition: all .3s;
}

section.upcoming-meetings .categories ul li a:hover {
  color: #2596be;
}

section.upcoming-meetings .categories .main-button-red {
  border-top: 1px solid #eee;
  padding-top: 30px;
  margin-top: 15px;
}

section.upcoming-meetings .categories .main-button-red a {
  width: 100%;
  text-align: center;
}

.meeting-item {
  margin-bottom: 30px;
}

.meeting-item .thumb {
  position: relative;
}

.meeting-item .thumb img {
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
}

.meeting-item .thumb .price {
  position: absolute;
  left: 20px;
  top: 20px;
}

.meeting-item .thumb .price span {
  font-size: 16px;
  color: #1f272b;
  font-weight: 600;
  background-color: rgba(250,250,250,0.9);
  padding: 7px 12px;
  border-radius: 10px;
}

.meeting-item .down-content {
  background-color: #fff;
  padding: 30px;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
}

.meeting-item .down-content .date {
  float: left;
  text-align: center;
  display: inline-block;
  margin-right: 20px;
}

.meeting-item .down-content .date h6 {
  font-size: 13px;
  text-transform: uppercase;
  font-weight: 600;
  color: #2596be;
}

.meeting-item .down-content .date span {
  display: block;
  color: #1f272b;
  font-size: 22px;
  margin-top: 7px;
}

.meeting-item .down-content h4 {
  font-size: 18px;
  color: #1f272b;
  font-weight: 600;
  display: inline-block;
  margin-bottom: 15px;
}

.meeting-item .down-content p {
  margin-left: 50px;
  color: #1f272b;
  font-size: 14px;
}



/*
---------------------------------------------
apply now
---------------------------------------------
*/

section.apply-now {
  /* background-image: url(../public/assets/images/webp/apply-bg.webp); */
  background-position: center center;
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;
  padding: 140px 0px;
}

section.apply-now .item {
  background-color: rgba(250,250,250,0.15);
  padding: 40px;
  margin-bottom: 30px;
  text-align: center;
  height: 395px;
}

section.apply-now .item h3 {
  color: #fff;
  text-transform: uppercase;
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 20px;
}

section.apply-now .item p {
  color: #fff;
  margin-bottom: 20px;
}

.accordions {
  border-radius: 20px;
  padding: 40px;
  background-color: #fff;
  margin-left: 45px;
}
.accordions .accordion {
  border-bottom: 1px solid #eee;
}
.accordions .last-accordion {
  border-bottom: none;
}
.accordion-head {
  padding: 20px;  
  font-size: 18px;
  font-weight: 700;
  color: #1f272b;
  cursor: pointer;
  transition: color 200ms ease-in-out;
  border-bottom: 1px solid #fff;
}
@media screen and (min-width: 768px) {
  .accordion-head {
    padding: 1rem;
    font-size: 1.2rem;
  }
}
.accordion-head .icon {
  float: right;
  transition: transform 200ms ease-in-out;
}
.accordion-head.is-open {
  color: #f5a425;
  border-bottom: none;
}
.accordion-head.is-open .icon {
  transform: rotate(45deg);
}
.accordion-body {
  overflow: hidden;
  height: 0;
  transition: height 300ms ease-in-out;
  border-bottom: 1px solid #fff;
}
.accordion-body > .content {
  padding: 20px;
  padding-top: 0;
}


/* 
---------------------------------------------
courses
--------------------------------------------- 
*/
#courses {
  background: #f6f6f6 !important;
  background-image: none !important;
}
section.our-courses {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position: center center;
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;
  padding-top: 100px;
  padding-bottom: 120px;
}

.our-courses .item .down-content {
  background-color: #ffffff;
}

.our-courses .item .down-content h4 {
  padding: 25px;
  font-size: 18px;
  color: #1f272b;
  text-align: center; 
  border-bottom: 1px solid #eee;
}

.our-courses .item .down-content .info {
  padding: 25px;
}

.our-courses .item .down-content .info ul li {
  display: inline-block;
  margin-right: 1px;
}

.our-courses .item .down-content .info ul li i {
  color: #f5a425;
  font-size: 14px;
}

.our-courses .item .down-content .info span {
  color: white;
  font-size: 15px;
  font-weight: 600;
  text-align: right;
  display: inline-block;
  width: 100%;
}

.our-courses .owl-nav {
  text-align: center;
  position: absolute;
  width: 100%;
  top: 50%;
  transform: translateY(-45px);
}

.our-courses .owl-dots {
  display: inline-block;
  text-align: center;
  width: 100%;
  margin-top: 40px;
}

.our-courses .owl-dots .owl-dot {
  transition: all .5s;
  width: 7px;
  height: 7px;
  background-color: #fff;
  margin: 0px 5px;
  border-radius: 50%;
  outline: none;
}

.our-courses .owl-dots .active {
  width: 24px;
  height: 8px;
  border-radius: 4px;
}
    
.our-courses .owl-nav .owl-prev{
  margin-right: 10px;
  outline: none;
  position: absolute;
  left: -80px;
}

.our-courses .owl-nav .owl-prev span,
.our-courses .owl-nav .owl-next span {
  opacity: 0;
}

.our-courses .owl-nav .owl-prev:before {
  display: inline-block;
  font-family: 'FontAwesome';
  color: #1e1e1e;
  font-size: 25px;
  font-weight: 700;
  content: '\\f104';
  background-color: #fff;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  line-height: 50px;
}

.our-courses .owl-nav .owl-prev {
  opacity: 1;
  transition: all .5s;
}

.our-courses .owl-nav .owl-prev:hover {
  opacity: 0.9;
}

.our-courses .owl-nav .owl-next {
  opacity: 1;
  transition: all .5s;
}

.our-courses .owl-nav .owl-next:hover {
  opacity: 0.9;
}

.our-courses .owl-nav .owl-next{
  margin-left: 10px;
  outline: none;
  position: absolute;
  right: -85px;
}

.our-courses .owl-nav .owl-next:before {
  display: inline-block;
  font-family: 'FontAwesome';
  color: #1e1e1e;
  font-size: 25px;
  font-weight: 700;
  content: '\\f105';
  background-color: #fff;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  line-height: 50px;
}


/*
---------------------------------------------
our facts
---------------------------------------------
*/

section.our-facts {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-position: center center;
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;
  padding: 140px 0px 125px 0px;
}

section.our-facts h2 {
  font-size: 38px;
  color: #fff;
  line-height: 50px;
  font-weight: 700;
  letter-spacing: 0.5px;
  margin-bottom: 50px;
}

.count-area-content {
  text-align: center;
  background-color: rgba(250,250,250,0.15);
  border-radius: 20px;
  padding: 25px 30px 35px 30px;
  margin: 15px 0px;
}

.percentage .count-digit:after {
  content: '%';
  margin-left: 3px;
}

.count-digit {
    margin: 5px 0px;
    color: #f5a425;
    font-weight: 700;
    font-size: 36px;
}
.count-title {
    font-size: 18px;
    font-weight: 500;
    color: #fff;
    letter-spacing: 0.5px;
}

.new-students {
  margin-top: 45px;
}

section.our-facts .video {
  text-align: center;
  margin-left: 70px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  border-radius: 20px;
}

section.our-facts .video img {
  padding: 170px 0px;
  max-width: 56px;
}


/* 
---------------------------------------------
contact us
--------------------------------------------- 
*/

section.contact-us {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position: center center;
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;
  padding: 140px 0px 0px 0px;
}
.contact-form{
  background-color: rgba(250,250,250,0.15);
  border-radius: 20px;
  background: #2bb8dd;
  padding: 1px;
}
section.contact-us #contact {
  background-color: #111827;
  border-color: #2bb8dd;
  border-radius: 20px;
  padding: 119px;
}

section.contact-us #contact h2 {
  text-transform: uppercase;
  color: #2bb8dd;
  border-bottom: 1px solid #eee;
  margin-bottom: 40px;
  padding-bottom: 20px;
  font-size: 22px;
  font-weight: 700;
}
.section-divider {
  height: 2px;
  width: 100%;
  background: linear-gradient(to right, #1e90ff, #3b82f6, #1e90ff);
  box-shadow: 0 0 10px rgba(59, 130, 246, 0.6);
  margin: 0;
  padding: 0;
}
section.contact-us #contact input {
  width: 100%;
  height: 40px;
  border-radius: 20px;
  background-color: #f7f7f7;
  outline: none;
  border: none;
  box-shadow: none;
  font-size: 13px;
  font-weight: 500;
  color: #7a7a7a;
  padding: 0px 15px;
  margin-bottom: 30px;
}

section.contact-us #contact textarea {
  width: 100%;
  min-height: 140px;
  max-height: 180px;
  border-radius: 20px;
  background-color: #f7f7f7;
  outline: none;
  border: none;
  box-shadow: none;
  font-size: 13px;
  font-weight: 500;
  color: #7a7a7a;
  padding: 15px;
  margin-bottom: 30px;
}

section.contact-us #contact button {
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, #2563eb, #3b82f6); /* Matching blue gradient */
  padding: 12px 30px;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
  font-family: var(--font-family);
  transition: all 0.3s ease;
}

section.contact-us #contact button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(37, 99, 235, 0.4);
  background: linear-gradient(135deg, #1d4ed8, #2563eb); /* Slight hover variation */
}

section.contact-us #contact button:hover {
  opacity: 0.9;
}

.contact-us .right-info {
  background: linear-gradient(135deg, #2596be, #1f2937); /* Gradient border */
  border-radius: 22px; /* Slightly larger for outer radius */
  padding: 2px; /* Thin border effect */
}

.contact-us .right-info > * {
  background-color: #111827;
  border-radius: 20px; /* Inner content radius */
  padding: 40px;
}


section.contact-us .right-info ul li {
  display: inline-block;
  border-bottom: 1px solid rgba(250,250,250,0.15);
  margin-bottom: 30px;
  padding-bottom: 30px;
}

section.contact-us .right-info ul li:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

section.contact-us .right-info ul li h6 {
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 10px;
}

section.contact-us .right-info ul li span {
  display: block;
  font-size: 16px;
  color: #fff;
  font-weight: 500;
}

.footer {
  /* text-align: center; */
  margin-top: 140px;
  border-top: 1px solid rgba(250,250,250,0.15);
  padding: 50px 0px;
}
.footer p {
  /* text-transform: uppercase; */
  font-size: 14px;
  color: #fff;
}

.footer p a {
  color: #f5a425;
}


/*
---------------------------------------------
heading page
---------------------------------------------
*/

section.heading-page {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  padding-top: 230px;
  padding-bottom: 110px;
  text-align: center;
}

section.heading-page h6 {
  margin-top: 0px;
  font-size: 15px;
  text-transform: uppercase;
  font-weight: 600;
  color: #fff;
  letter-spacing: 1px;
}

section.heading-page h2 {
  margin-top: 20px;
  margin-bottom: 20px;
  font-size: 36px;
  text-transform: uppercase;
  font-weight: 800;
  color: #fff;
  letter-spacing: 1px;
}


/*
---------------------------------------------
upcoming meetings page
---------------------------------------------
*/

section.meetings-page {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-position: center center;
  background-attachment: fixed;
  background-repeat: no-repeat;
  background-size: cover;
  padding-top: 140px;
  padding-bottom: 0px;
}

section.meetings-page .filters {
  text-align: center;
  margin-bottom: 60px;
}

section.meetings-page .filters li {
  font-size: 13px;
  color: #2596be;
  background-color: #fff;
  padding: 11px 30px;
  display: inline-block;
  border-radius: 22px;
  font-weight: 600;
  text-transform: uppercase;
  transition: all .3s;
  cursor: pointer;
  margin: 0px 3px;
}

section.meetings-page .filters ul li.active,
section.meetings-page .filters ul li:hover {
  background-color: #2596be;
  color: #fff;
}

section.meetings-page .pagination {
  text-align: center;
  width: 100%;
  margin-top: 30px;
  display: inline-block;
}

section.meetings-page .pagination ul li {
  display: inline-block;
}

section.meetings-page .pagination ul li a {
  width: 40px;
  height: 40px;
  background-color: #fff;
  border-radius: 10px;
  color: #1f272b;
  display: inline-block;
  text-align: center;
  line-height: 40px;
  font-weight: 600;
  font-size: 15px;
  transition: all .3s;
}

section.meetings-page .main-button-red {
  text-align: center;
}

section.meetings-page .main-button-red a {
  padding: 12px 60px;
  text-align: center;
  margin-top: 30px;
}

section.meetings-page .pagination ul li.active a,
section.meetings-page .pagination ul li a:hover {
  background-color: #2596be;
  color: #fff;
}

.meeting-single-item .thumb {
  position: relative;
}

.meeting-single-item .thumb img {
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
}

.meeting-single-item .thumb .price {
  position: absolute;
  left: 20px;
  top: 20px;
}

.meeting-single-item .thumb .price span {
  font-size: 16px;
  color: #1f272b;
  font-weight: 600;
  background-color: rgba(250,250,250,0.9);
  padding: 7px 12px;
  border-radius: 10px;
}

.meeting-single-item .down-content {
  background-color: #fff;
  padding: 40px;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
}

.meeting-single-item .thumb .date {
  position: absolute;
  background-color: rgba(250,250,250,0.9);
  width: 80px;
  height: 80px;
  text-align: center;
  padding: 15px 0px;
  border-radius: 10px;
  right: 20px;
  top: 20px;
}

.meeting-single-item .thumb .date h6 {
  font-size: 13px;
  text-transform: uppercase;
  font-weight: 600;
  color: #2596be;
}

.meeting-single-item .thumb .date span {
  display: block;
  color: #1f272b;
  font-size: 22px;
  margin-top: 7px;
}

.meeting-single-item .down-content h4 {
  font-size: 22px;
  color: #1f272b;
  font-weight: 600;
  display: inline-block;
  margin-bottom: 15px;
}

.meeting-single-item .down-content h5 {
  font-size: 18px;
  color: #1f272b;
  font-weight: 700;
  display: inline-block;
  margin-bottom: 15px;
}

.meeting-single-item .down-content p {
  color: #1f272b;
  font-size: 14px;
}

.meeting-single-item .down-content p.description {
  margin-top: 40px;
  padding-top: 40px;
  border-top: 1px solid #eee;
  margin-bottom: 40px;
  padding-bottom: 40px;
  border-bottom: 1px solid #eee;
}

.meeting-single-item .down-content .share {
  margin-top: 40px;
  padding-top: 40px;
  border-top: 1px solid #eee;
}

.meeting-single-item .down-content .share h5 {
  float: left;
  margin-right: 10px;
  margin-bottom: 0px;
}

.meeting-single-item .down-content .share ul li {
  display: inline;
}

.meeting-single-item .down-content .share ul li a {
  font-size: 14px;
  color: #1f272b;
  transition: all .3s;
}

.meeting-single-item .down-content .share ul li a:hover {
  color: #f5a425;
}

/* Meeting item column */
.templatemo-item-col {
	width: 31%;
}

@media (max-width: 992px) {
	.templatemo-item-col {
		width: 45%;
	}
}

@media (max-width: 767px) {
	.templatemo-item-col {
		width: 100%;
	}
}

/* 
---------------------------------------------
responsive
--------------------------------------------- 
*/

@media (max-width: 1300px) {
  .services .owl-nav .owl-next{
    right: -30px;
  }
  .services .owl-nav .owl-prev{
    left: -25px;
  }
  .our-courses .owl-nav .owl-next{
    right: -30px;
  }
  .our-courses .owl-nav .owl-prev{
    left: -25px;
  }
}

@media (max-width: 1200px) {
  .services .owl-nav .owl-next{
    right: -70px;
  }
  .services .owl-nav .owl-prev{
    left: -65px;
  }
  .our-courses .owl-nav .owl-next{
    right: -70px;
  }
  .our-courses .owl-nav .owl-prev{
    left: -65px;
  }
}

@media (max-width: 1085px) {
  .services .owl-nav .owl-next{
    right: -30px;
  }
  .services .owl-nav .owl-prev{
    left: -25px;
  }
  .our-courses .owl-nav .owl-next{
    right: -30px;
  }
  .our-courses .owl-nav .owl-prev{
    left: -25px;
  }
}

@media (max-width: 1005px) {
  .services .owl-nav .owl-next{
    display: none;
  }
  .services .owl-nav .owl-prev{
    display: none;
  }
  .our-courses .owl-nav .owl-next{
    display: none;
  }
  .our-courses .owl-nav .owl-prev{
    display: none;
  }
}

@media (max-width: 992px) {

  .main-banner .caption {
    top: 60%;
  }

  .main-banner .caption h1 {
    margin-top: 10px;
    margin-bottom: 10px;
    font-size: 22px;
  }

  .main-banner .caption .main-button-red {
    margin-top: 15px;
  }

  .services {
    margin-top: 60px;
  }

  section.upcoming-meetings {
    padding-top: 400px;
  }

  section.upcoming-meetings .categories {
    margin-right: 0px;
    margin-bottom: 30px;
  }

  .accordions {
    margin-left: 0px;
  }

  .new-students {
    margin-top: 15px;
  }

  section.our-facts .video {
    margin-left: 0px;
    margin-top: 15px;
  }



}

@media (max-width: 767px) {

  .sub-header .left-content p {
    display: none;
  }

  .sub-header .right-icons {
    text-align: center;
  }

  .main-nav .nav .sub-menu {
    display: none;
  }

  .header-area .main-nav .nav li ul.sub-menu li a {
    color: #1f272b;
  }

}

.learn-more-btn {
  background: transparent !important;
  border: 2px solid #ffffff;
}
.learn-more-btn:hover{
  background: #FC3 !important;
    border-color: #FC3 !important;
}

.slick-dots {
  bottom: -50px;
}

.howitworks-content{
  padding: 50px;
    /* background: #ffffff; */
    height: 350px;
    margin-bottom: 25px;
    flex: 0 0 350px;
  background: #0D1324;
  border-radius: 20px;
  overflow: hidden;
  border: 1px solid #2a2a2a;
  transition: all 0.3s ease;
  position: relative;
}
.howitworks-content:hover{
  transform: translateY(-10px);
    border-color: white;
    box-shadow: 0 15px 40px rgba(43, 184, 221, 0.2);
}
.howitworks-content h4, .howitworks-content p {
  color: #2bb8dd !important;
  text-align: left;
}
.howitworks-content p {
  color: #ffffff !important;
  text-align: left;
}
.howitworks-content:before {
  content: '';
}
.howitworks_numbers{
  font-size: 20px;
    color: #ffffff;
    display: inline-block;
    width: 45px;
    height: 45px;
    background: #2596be;
    border-radius: 50%;
    vertical-align: middle;
    padding-top: 7px;
    text-align: center;
    margin-bottom: 20px;
}

/* Footer styling */
.footer {
  background-color: #111827;
  color: white;
  padding: 2rem 1rem;
  font-family: Arial, sans-serif;
}

.footer-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.footer-column {
  flex: 1 1;
  min-width: 200px;
}

.footer-logo img {
  max-width: 150px;
}

.footer h4 {
  font-size: 1.25rem;
  margin-bottom: 1rem;
}

.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-links li {
  margin-bottom: 0.5rem;
}

.footer-links a {
  text-decoration: none;
  color: white;
  font-size: 1rem;
  transition: color 0.3s;
}

.footer-links a:hover {
  color: #f0f0f0;
}

.footer-social-icons {
  display: flex;
  gap: 0.5rem;
  margin-top: 1rem;
  margin-left: 5rem;

}

.social-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: white;
  color: #2596be;
  border-radius: 50%;
  font-size: 1.25rem;
  transition: all 0.3s;
  text-decoration: none;
}

.social-icon:hover {
  background-color: #20789c;
  color: white;
}

.footer-copyright {
  border-top: 1px solid rgba(250,250,250,0.15);
  text-align: center;
  margin-top: 2rem;
  font-size: 0.875rem;
  /* background-color: #20789c; */
  padding: 1rem;
}

section.apply-now .item .social-icon {
  
  margin: auto;
  margin-bottom: 20px;
  width: 70px;
  height: 70px;
}
/* existing */
#englishtest { background:#0A0F1C; }
#englishtest h2 { color:#ffffff !important; }
#englishtest h3 { color:#2bb8dd !important; margin-bottom:15px; }
#englishtest p  { color:#ffffff !important; }

/* additions for the new look */
#englishtest { padding:60px 0; }
#englishtest .et-header { margin-bottom:24px; }
#englishtest .et-subtitle { color:#9aa3b1; margin:8px 0 16px; }

/* tabs */
#englishtest .et-tabs {
  display:inline-flex; gap:8px; padding:6px;
  border:1px solid #2c3a5f; border-radius:999px;
  background:linear-gradient(180deg,#0f172a,#0b1324);
  box-shadow:0 10px 30px rgba(0,0,0,.35), inset 0 1px 0 rgba(255,255,255,.03);
}
#englishtest .et-tab {
  border:0; padding:10px 16px; border-radius:999px; cursor:pointer;
  color:#a3acc2; font-weight:700; background:transparent;
}
#englishtest .et-tab.active {
  color:#fff; background:linear-gradient(180deg,#1e293b,#0f172a);
  box-shadow: inset 0 0 0 1px #2c3a5f, 0 4px 16px rgba(0,0,0,.35);
}

/* cards */
#englishtest .et-card {
  background:#0f172aee; border:1px solid #2c3a5f; border-radius:18px;
  padding:22px; position:relative; height:100%;
  box-shadow:0 10px 30px rgba(0,0,0,.35), inset 0 1px 0 rgba(255,255,255,.03);
}
#englishtest .et-badge{
  position:absolute; top:18px; left:250px;
  background:rgba(59,130,246,.15); color:#cfe1ff;
  border:1px solid rgba(59,130,246,.35);
  padding:4px 5px; border-radius:999px; font-size:12px; font-weight:800;
}
#englishtest .et-card-header{
  display:flex; align-items:center; gap:12px; margin-bottom:8px;
}
/* icon pill */
#englishtest .et-icon{
  width:44px; height:44px; border-radius:12px; display:grid; place-items:center;
  background:rgba(255,255,255,.06); border:1px solid #2c3a5f; font-size:22px;
}
/* make card titles white like screenshot */
#englishtest .et-card h3 { color:#ffffff !important; margin:0; }

/* body text muted for readability */
#englishtest .et-text { color:#cbd5e1 !important; line-height:1.6; }

/* meta list */
#englishtest .et-meta{
  list-style:none; padding-left:0; margin:12px 0 0;
  border-top:1px dashed rgba(163,172,194,.25); padding-top:10px;
  color:#c7d0e6; font-size:14px; display:grid; gap:6px;
}
#englishtest .et-meta b{ color:#e9eefc; }

/* links under cards */
#englishtest .et-link{
  display:inline-block; margin-top:10px; margin-right:12px;
  color:#9ec1ff; font-weight:700; text-decoration:none;
}
#englishtest .et-link:hover{ text-decoration:underline; }


/* existing + new look already applied above */

/* responsive tweaks */
@media (max-width: 992px) {
  #englishtest {
    padding: 40px 16px;
  }

  #englishtest .et-tabs {
    flex-wrap: wrap;
    justify-content: center;
  }

  #englishtest .et-card {
    padding: 18px;
    text-align: center; /* center content */
  }

  #englishtest .et-badge {
    left: auto;
    right: 16px; /* keep inside card on smaller screens */
    top: 12px;
    font-size: 11px;
  }

  #englishtest .et-icon {
    width: 40px;
    height: 40px;
    font-size: 20px;
    margin: 0 auto; /* center horizontally */
    display: flex;
    align-items: center;
    justify-content: center;
  }

  #englishtest h2 {
    font-size: 24px;
    text-align: center;
  }

  #englishtest h3 {
    font-size: 18px;
  }

  #englishtest p,
  #englishtest .et-text {
    font-size: 14px;
  }
}

@media (max-width: 576px) {
  #englishtest {
    padding: 30px 12px;
  }

  #englishtest .et-tabs {
    gap: 4px;
  }

  #englishtest .et-tab {
    padding: 8px 12px;
    font-size: 13px;
  }

  #englishtest .et-card {
    border-radius: 12px;
    padding: 16px;
    text-align: center; /* keep everything centered */
  }

  #englishtest .et-badge {
    position: static;
    display: inline-block;
    margin-top: 8px;
  }

  #englishtest .et-card-header {
    flex-direction: column;
    align-items: center; /* center children */
    gap: 8px;
  }

  #englishtest .et-icon {
    margin: 0 auto; /* ensure icon stays in center */
  }

  #englishtest h2 {
    font-size: 20px;
  }

  #englishtest h3 {
    font-size: 16px;
  }
}


/* #englishtest {
  background: #0A0F1C;
}
#englishtest h2 {
  color: #ffffff !important;
}

#englishtest h3 {
  color: #2bb8dd !important;
  margin-bottom: 15px;
}
#englishtest p {
  color: #ffffff !important;
} */


#aboutus, #studentservices, #courses {
  background: #111827!important;
}
#aboutus p{
  text-align: center;
  padding: 0 20%;
  color: #ffffff;
  text-align: justify;
  margin-bottom: 20px;
}
p{
  font-size: 14px !important;
}

.main-heading {
  text-align: center;
  font-size: 2.5rem;
  color: #2c3e50;
  margin-bottom: 50px;
  position: relative;
}

.main-heading::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 100px;
  height: 4px;
  background: #3498db;
  border-radius: 2px;
}

.timeline {
  position: relative;
  padding: 20px 0;
}

.timeline::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 6px;
  height: 100%;
  background: #ddd;
  border-radius: 3px;
}

.timeline-item {
  position: relative;
  margin: 20px 0;
}

.timeline-item:nth-child(odd) {
  text-align: left;
  padding-right: 50px;
}

.timeline-item:nth-child(even) {
  text-align: right;
  padding-left: 50px;
}

.timeline-item::after {
  content: '';
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  background: #3498db;
  border: 3px solid #f8f9fa;
  border-radius: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.timeline-item-content {
  display: inline-block;
  width: 45%;
  background: #fff;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  position: relative;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  flex: 0 0 350px;
  background: linear-gradient(135deg, #0f0f0f 0%, #1a1a1a 100%);
  border-radius: 20px;
  overflow: hidden;
  border: 1px solid #2a2a2a;
  transition: all 0.3s ease;
  position: relative;
}


.timeline-item-content:hover {
  transform: translateY(-10px);
    border-color: #2bb8dd;
    box-shadow: 0 15px 40px rgba(43, 184, 221, 0.2);
}

.timeline-item:nth-child(odd) .timeline-item-content {
  margin-right: auto;
}

.timeline-item:nth-child(even) .timeline-item-content {
  margin-left: auto;
}

.timeline-item h3 {
  margin: 0;
  font-size: 1.5rem;
  color: #2bb8dd ;
}

.timeline-item p {
  font-size: 1rem;
  color: #ffffff;
  margin: 10px 0 0;
  line-height: 1.6;
}

.timeline-item .icon {
  font-size: 2.5rem;
  color: #3498db;
  margin-bottom: 10px;
}

.additional-feature {
  margin-top: 50px;
  background: linear-gradient(135deg, #000000 0%, #1a1a1a 50%, #000000 100%);
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  flex: 0 0 350px;
  background: linear-gradient(135deg, #0f0f0f 0%, #1a1a1a 100%);
  border-radius: 20px;
  overflow: hidden;
  border: 1px solid #2a2a2a;
  transition: all 0.3s ease;
  position: relative;
}
.additional-feature:hover {
  transform: translateY(-8px);
  border-color: #2bb8dd;
  box-shadow: 0 15px 40px rgba(43, 184, 221, 0.2);
}

.additional-feature h3 {
  text-align: center;
  color: #2bb8dd ;
  margin-bottom: 20px;
}

.additional-feature ul {
  list-style: none;
  padding: 0;
}

.additional-feature ul li {
  margin-bottom: 10px;
  font-size: 1rem;
  color: #ffffff;
}

.additional-feature ul li i {
  margin-right: 10px;
  color: #3498db;
}


/* CEO Section Card Layout */
.ceo-section {
  display: flex;
  flex-direction: column;
  color: var(--section-text) !important; 

  align-items: center;
  background: #111827;
  border: 1px solid #2a2a2a;
  border-radius: 20px;
  padding: 30px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
}

/* Hover Effect */
.ceo-section:hover {
  transform: translateY(-8px);
  border-color: white;
  box-shadow: 0 15px 40px rgba(43, 184, 221, 0.2);
}

/* CEO Image Styling */
.ceo-image {
  margin-bottom: 20px;
}

.ceo-image img {
  width: 160px;
  height: 160px;
  object-fit: cover;
  border-radius: 50%;
  border: 3px solid #ddd;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* CEO Content */
.ceo-content {
  text-align: center;
  padding: 0 10px;
  
}

.ceo-content h2 {
  font-size: 2rem;
  color: #2bb8dd;
  margin-bottom: 10px;
}

.ceo-content h3 {
  font-size: 1.2rem;
  color: #2bb8dd;
  margin-bottom: 20px;
  font-weight: normal;
}

.ceo-content p {
  font-size: 1rem;
  color: #ffffff;
  line-height: 1.6;
  margin-bottom: 20px;
}




.quote {
  font-style: italic;
  color: #777;
  font-size: 1.1rem;
  margin-top: 20px;
  position: relative;
}

.quote::before,
.quote::after {
  content: '"';
  font-size: 2rem;
  color: #3498db;
  position: absolute;
}

.quote::before {
  top: -10px;
  left: -10px;
}

.quote::after {
  bottom: -10px;
  right: -10px;
}

.ceo-signature {
  display: flex;
  align-items: center;
  margin-top: 20px;
}

.ceo-signature img {
  width: 80px;
  height: auto;
  margin-right: 20px;
}

@media (max-width: 768px) {
  section.contact-us #contact {
    padding: 30px;
      background-color: #111827;
      border-color: #2bb8dd;
      border-radius: 20px;
   
  }
  .ceo-section {
      flex-direction: column;
      text-align: center;
  }

  .ceo-image, .ceo-content {
      flex: 1 1 100%;
  }

  .ceo-content {
      padding: 0;
  }

  /* for mobile responsiveness */
  .header{
    padding: 0 10px;
  }
  .logo-text, .timeline::before, .timeline-item::after {
    display: none !important;
  }
  .navbar {
    position: absolute;
    right: 0;
    backdrop-filter: unset !important;
  }
  .hamburger {
    position: absolute;
    right: 15px;
  }
  .auth-controls {
    margin-right: 50px;
  }
  .logo-section {
    margin-left: 15px !important;
  }
  #bg-video {
    min-height: 70vh !important;
  }
  .timeline-item {
    padding: 0 !important;
  }
  .timeline-item-content {
    width: 100% !important;
  }
  #englishtest, .howitworks-content, .howitworks-content p, .howitworks-content h4, .timeline-item-content, .footer, .footer-social-icons,
  .section.contact-us .right-info, #contact, .video-overlay, #aboutus p {
    text-align: center !important;
    justify-content: center !important;
  }
  #aboutus p {
    padding: 0 15px !important;
  }
  .logo-img {
    height: 32px !important;
    width: auto !important;
  }
  .auth-controls {
    z-index: 9999 !important
  }
  .slick-slide {
    padding: 15px;
  }
}



/* WhatsApp Icon */
.whatsapp-float {
  position: fixed;
  right: 30px;
  bottom: 100px; 
  background-color: #25d366;
  color: white;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 26px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
   z-index: 1001; 
  transition: all 0.3s ease;
  cursor: pointer;
}


/* ===== Base (desktop/tablet stays the same) ===== */
.feature-strip {
  position: relative;
  background: #0c1826;
  padding: 2rem 0;
}
.feature-strip::before,
.feature-strip::after {
  content: "";
  display: block;
  height: 1px;
  width: 100%;
  background: #1b314a;
  position: absolute;
  left: 0;
}
.feature-strip::before { top: 0; }
.feature-strip::after  { bottom: 0; }

.feature-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: .6rem;
  padding: .5rem 1rem;
  min-height: 110px;
}
.feature-box i {
  font-size: 2.4rem;
  line-height: 1;
  color: #1ea2ff;
}
.feature-label {
  font-size: 1rem;
  font-weight: 600;
  color: #fff;
}

/* desktop vertical separators between columns */
@media (min-width: 992px) {
  .feature-strip .col-md-4:not(:last-child) .feature-box {
    border-right: 1px solid #1b314a;
  }
}

/* ===== Tablet (≤ 991.98px) ===== */
@media (max-width: 991.98px) {
  .feature-strip { padding: 1.6rem 0; }
  .feature-box i { font-size: 2.1rem; }
  .feature-label { font-size: .98rem; }
  /* remove desktop right borders when not 3-up */
  .feature-strip .feature-box { border-right: 0; }
}

/* ===== Phones (≤ 575.98px) ===== */
@media (max-width: 575.98px) {
  /* section padding a bit tighter */
  #about { padding: 2rem 0; }

  /* bigger touch targets & comfy spacing */
  .feature-box {
    padding: 1rem 0;
    min-height: 0;
  }
  .feature-box i { font-size: 2rem; }
  .feature-label { font-size: .95rem; }

  /* thin horizontal divider between stacked items */
  .feature-strip .col-12 + .col-12 .feature-box {
    border-top: 1px solid #1b314a;
    margin-top: .75rem;
    padding-top: 1.25rem;
  }
}






.whatsapp-float:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.3);
}

.whatsapp-float i {
  color: white;
  transition: color 0.3s ease;
}

.whatsapp-float:hover i {
  color: white;
}


/* Root Variables */
:root {
  
  --primary-bg: #111827;           /* Darkest background */
  --secondary-bg: #1F2937;         /* Slightly lighter background */
  --accent-color: #2596be;         /* Brand blue */
  --text-color: #ffffff;           /* Primary text (white) */
  --secondary-text: #9ca3af;       /* Muted text */

  --font-family: 'Poppins', sans-serif;

  /* Optional enhancements */
  --button-radius: 22px;
  --button-hover-bg: #ffffff;
  --button-hover-text: #111827;

  --border-color: rgba(255, 255, 255, 0.1);
  --shadow-md: 0 4px 12px rgba(0, 0, 0, 0.15);
  --shadow-lg: 0 6px 20px rgba(0, 0, 0, 0.2);


}

/* Global Styles */
body {
  background-color: var(--primary-bg);
  color: var(--text-color);
  font-family: var(--font-family);
  margin: 0;
  padding: 0;
}

/* Hero Section */
.hero-section {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6rem 2rem;
  min-height: 400px;
  /* background-image: url('../src/assets/images/webp/students_lib.webp'); adjust path if needed */
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  text-align: center;
  color: white;
  overflow: hidden;
}

.hero-section::before {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: rgba(17, 24, 39, 0.8); /* #111827 with opacity */
  z-index: 1;
}

.hero-content {
  position: relative;
  z-index: 2;
  max-width: 800px;
}

.hero-content h1 {
  font-size: 2.5rem;
  color: #ffffff;
  margin-bottom: 1rem;
}

.hero-content p {
  font-size: 1.1rem;
  color: #ffffff;
  margin-bottom: 2rem;
}

.hero-btn {
  background-color: transparent;
  border: 2px solid #ffffff;
  color: #ffffff;
  padding: 0.75rem 1.5rem;
  border-radius: 999px;
  font-weight: 600;
  text-decoration: none;
  transition: background-color 0.3s ease, color 0.3s ease;
}

.hero-btn:hover {
  background-color: #ffffff;
  color: #111827;
}

/* OPTIONAL: Remove this if you no longer use the direct image */
.hero-image img {
  display: none;
}

/* Recent Articles */
.recent-articles {
  background-color: var(--secondary-bg);
  padding: 4rem 2rem;
}

.recent-articles h2 {
  font-size: 2rem;
  text-align: center;
  margin-bottom: 2rem;
  color: var(--text-color);
}

.articles-wrapper {
  display: flex;
  gap: 2rem;
  overflow-x: auto;
  padding-bottom: 1rem;
}

.article-card {
  background-color: var(--primary-bg);
  padding: 1.5rem;
  border-radius: 12px;
  min-width: 300px;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.1);
  color: var(--text-color);
}

.article-card h3 {
  margin: 0.5rem 0;
}

.article-card p {
  font-size: 0.95rem;
  color: var(--secondary-text);
}

.article-btn {
  display: inline-block;
  margin-top: 1rem;
  color: var(--accent-color);
  font-weight: 600;
  text-decoration: none;
}

.article-btn:hover {
  text-decoration: underline;
}

/* Blog Grid */
.blog-section {
  padding: 4rem 2rem;
  background-color: var(--primary-bg);
}

.blog-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 2rem;
}

.blog-post-card {
  background-color: var(--secondary-bg);
  border-radius: 12px;
  overflow: hidden;
  transition: transform 0.3s ease;
  color: var(--text-color);
  display: flex;
  flex-direction: column;
}

.blog-post-card:hover {
  transform: translateY(-6px);
}

.post-card-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
}

.post-card-body {
  padding: 1.5rem;
  flex-grow: 1;
}

.post-category {
  font-size: 0.75rem;
  color: var(--secondary-text);
  text-transform: uppercase;
  margin-bottom: 0.5rem;
}

.post-title {
  font-size: 1.25rem;
  margin: 0.5rem 0;
}

.post-excerpt {
  font-size: 0.95rem;
  color: var(--secondary-text);
}

.read-more-btn {
  display: inline-block;
  margin-top: 1rem;
  color: var(--accent-color);
  font-weight: 600;
  text-decoration: none;
}

.read-more-btn:hover {
  text-decoration: underline;
}

/* Footer */
.footer {
  background-color: var(--secondary-bg);
  color: var(--text-color);
  padding: 2rem;
  text-align: center;
}

.footer a {
  color: var(--accent-color);
  text-decoration: none;
  margin: 0 0.5rem;
}

.footer a:hover {
  text-decoration: underline;
}
/* Main Admin Container */
.blog-wrapper {
  padding: 40px 20px;
  background-color: #ffffff;
  min-height: 100vh;
  font-family: 'Poppins', sans-serif;
  color: #1f272b;
}

/* Heading */
.blog-wrapper h1 {
  font-size: 32px;
  margin-bottom: 30px;
  font-weight: 700;
  color: #2c3e50;
}

/* Create Button */
.blog-btn {
  display: inline-block;
  background-color: #2596be;
  color: #ffffff;
  padding: 10px 20px;
  border-radius: 25px;
  text-decoration: none;
  font-weight: 600;
  margin-bottom: 20px;
  transition: background 0.3s ease;
}

.blog-btn:hover {
  background-color: #20789c;
}

/* Each Post Entry */
.blog-admin-post {
  background: #f9f9f9;
  border: 1px solid #eee;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Post Title + Category */
.blog-admin-post h3 {
  font-size: 20px;
  margin-bottom: 8px;
  color:#fff;
}

.blog-admin-post p {
  font-size: 14px;
  color: #555;
  margin: 0;
}

/* Button Group on Right */
.blog-admin-post .blog-btn {
  margin-left: 10px;
  font-size: 14px;
  padding: 8px 16px;
}

/* Optional: style Draft label */
.blog-admin-post h3 span {
  font-size: 14px;
  color: #f39c12;
  margin-left: 10px;
}

/* Admin Dashboard Wrapper */
.blog-custom-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  min-height: 100vh;
  padding: 40px 20px;
  background-color: #111827; /* Matches your dark theme */
  color: #ffffff;
  font-family: 'Poppins', sans-serif;
}

/* Heading */
.blog-custom-container h1 {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 30px;
  color: #ffffff;
}

/* Create New Post Button */
.blog-btn {
  display: inline-block;
  background-color: #2596be;
  color: #ffffff;
  padding: 10px 20px;
  border-radius: 25px;
  font-weight: 600;
  text-decoration: none;
  margin: 10px 5px;
  transition: background-color 0.3s ease;
}

.blog-btn:hover {
  background-color: #20789c;
}

/* Admin Post Container */
.blog-admin-post {
  width: 100%;
  max-width: 800px;
  background-color: #1f2937;
  border: 1px solid #374151;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #ffffff;
}

/* Post title */
.blog-admin-post h3 {
  font-size: 20px;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
  gap: 10px;
}

/* Post category */
.blog-admin-post p {
  font-size: 14px;
  color: #d1d5db;
  margin: 0;
}

/* Optional: style Draft label */
.blog-admin-post h3 span {
  font-size: 14px;
  color: #f59e0b; /* orange */
}

/* Make it responsive */
@media (max-width: 768px) {
  .blog-admin-post {
    flex-direction: column;
    align-items: flex-start;
  }

  .blog-admin-post > div:last-child {
    margin-top: 10px;
  }

  .blog-btn {
    width: 100%;
    text-align: center;
  }
}

.blog-admin-login-container {
  background-color: #111827;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  padding: 2rem;
}

.blog-admin-login-container h1 {
  font-size: 2rem;
  margin-bottom: 1.5rem;
  color: #ffffff;
}

.blog-admin-login-form {
  background-color: #1F2937;
  padding: 2rem;
  border-radius: 12px;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
}

.blog-admin-login-form input {
  width: 100%;
  padding: 12px 15px;
  margin-bottom: 1rem;
  border-radius: 8px;
  border: 1px solid #374151;
  background-color: #111827;
  color: #ffffff;
  font-size: 16px;
}

.blog-admin-login-form input::placeholder {
  color: #9CA3AF;
}

.blog-error-message {
  color: #f87171;
  margin-top: 0.5rem;
  font-size: 14px;
}




.blog-container {
  background-color: #111827;
  min-height: 100vh;
  padding: 40px 20px;
  color: #ffffff;
  font-family: 'Poppins', sans-serif;
}

.blog-container h1 {
  font-size: 2rem;
  margin-bottom: 1.5rem;
  color: #ffffff;
  text-align: center;
}

.blog-form {
  background-color: #1F2937;
  padding: 2rem;
  border-radius: 12px;
  max-width: 800px;
  margin: 0 auto;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.4);
}

.blog-form input[type="text"],
.blog-form input[type="file"] {
  width: 100%;
  padding: 0.75rem;
  margin-bottom: 1rem;
  background-color: #111827;
  color: #ffffff;
  border: 1px solid #374151;
  border-radius: 8px;
  font-size: 16px;
}

.blog-form input::placeholder {
  color: #9CA3AF;
}

.ql-toolbar,
.ql-container {
  background-color: #1F2937;
  color: #ffffff;
  border-color: #374151;
}

.form-actions {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 1.5rem;
}

.form-actions button {
  background-color: #2596be;
  color: #ffffff;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.form-actions button:hover {
  background-color: #1e7ea5;
}












/* Layout & Dark Mode Fix */
.blog-post-layout {
  display: flex;
  flex-direction: column;
  background-color: #111827;
  color: white;
  padding-top: 80px;
}

.blog-main {
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
  color: white;
}

.single-post-hero {
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #333;
  text-align: center;
}

.post-title {
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
  color: white;
}

.post-date,
.post-author {
  font-size: 0.95rem;
  color: #ccc;
  margin-bottom: 0.2rem;
}


/* Media Styling */
.blog-post-media {
  max-width: 100%;
  height: auto;
  border-radius: 10px;
  margin: 2rem 0;
}

/* Post Content - Rich Text White */
.post-content,
.post-content p,
.post-content span,
.post-content li,
.post-content ul,
.post-content h1,
.post-content h2,
.post-content h3 {
  color: white !important;
  font-size: 1.1rem;
  line-height: 1.8;
}

/* === Full Box for Enquiry Section === */
.enquiry-box-container {
  background-color: #1f2937;
  border: 2px solid #2bb8dd;
  border-radius: 12px;
  padding: 2.5rem;
  margin: 3rem auto;
  max-width: 800px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.25);
  color: white;
  text-align: center;
}

/* === Section Heading === */
.enquiry-title {
  font-size: 1.75rem;
  margin-bottom: 2rem;
  color: white;
}

/* === Input Fields === */
.enquiry-form input,
.enquiry-form textarea {
  width: 100%;
  padding: 14px 20px;
  margin-bottom: 1rem;
  border-radius: 25px;
  background-color: #111827;
  border: 1px solid #2bb8dd;
  color: white;
  font-size: 1rem;
  display: block;
}

.enquiry-form input::placeholder,
.enquiry-form textarea::placeholder {
  color: #aaa;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.enquiry-form textarea {
  resize: none;
  border-radius: 20px;
}

/* === Submit Button === */
.blog-btn.send-message {
  padding: 12px 28px;
  border-radius: 25px;
  background-color: #2bb8dd;
  color: white;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  border: none;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);
  transition: background-color 0.3s ease, transform 0.2s ease;
  margin-top: 1.5rem;
}

.blog-btn.send-message:hover {
  background-color: #2399ba;
  transform: translateY(-2px);
}

/* === Responsive Padding for Mobile === */
@media (max-width: 768px) {
  .enquiry-box-container {
    padding: 2rem 1rem;
  }
}









/* Journey Ad */
.start-journey-ad {
  border: 2px solid #2bb8dd;
  border-radius: 10px;
  padding: 2rem;
  background-color: #1f2937;
  color: white;
  text-align: center;
}

.start-journey-ad h4 {
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
  color: white;
}

.start-journey-ad p {
  color: white;
}

/* Responsive Fix */
@media (max-width: 768px) {
  .phone-group {
    flex-direction: column;
  }
}









.comment-section {
  display: flex;
  justify-content: center;
  padding: 3rem 1rem;
  background: transparent;
}

.comment-box {
  background-color: #1f2937;
  border: 2px solid #2bb8dd;
  border-radius: 12px;
  padding: 2.5rem;
  width: 100%;
  max-width: 800px;
  color: white;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
  transition: box-shadow 0.3s ease;
}

.comment-box h2 {
  font-size: 1.75rem;
  margin-bottom: 1.5rem;
  text-align: center;
  color: white;
}

/* Inputs and textarea */
.comment-box input,
.comment-box textarea {
  width: 100%;
  padding: 12px 14px;
  margin-bottom: 1.2rem;
  border: 1px solid #2bb8dd;
  border-radius: 8px;
  background-color: #111827;
  color: white;
  font-size: 1rem;
  transition: border-color 0.3s, background-color 0.3s;
}

.comment-box input:focus,
.comment-box textarea:focus {
  outline: none;
  border-color: #40d9ff;
  background-color: #1e293b;
}

/* Submit Button */
.comment-box button {
  background-color: #2bb8dd;
  color: white;
  padding: 10px 22px;
  font-size: 1rem;
  border: none;
  border-radius: 25px;
  cursor: pointer;
  font-weight: bold;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  transition: background-color 0.3s ease, transform 0.2s ease;
  display: block;
  margin: 0 auto; /* ✅ Center the button */
}

.comment-box button:hover {
  background-color: #2399ba;
  transform: translateY(-2px);
}











/* Section container */
.recent-articles {
  background-color: #1f2937;
  border: 2px solid #2bb8dd;
  border-radius: 10px;
  padding: 2rem;
  margin-top: 3rem;
  text-align: center;
  position: relative;
}

/* Title */
.recent-articles h2 {
  font-size: 2rem;
  margin-bottom: 1.5rem;
  color: white;
}

/* Article scroll wrapper */
.articles-wrapper {
  display: flex;
  gap: 1rem;
  overflow-x: auto;
  scroll-behavior: smooth;
  padding: 1rem 0;
  scrollbar-width: none;
}

.articles-wrapper::-webkit-scrollbar {
  display: none;
}

/* Article card */
.article-card {
  flex: 0 0 250px;
  background-color: #111827;
  border-radius: 10px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.25);
  padding: 1.2rem;
  color: white;
  text-align: left;
  transition: transform 0.3s ease;
}

.article-card:hover {
  transform: translateY(-5px);
}

.article-btn {
  display: inline-block;
  margin-top: 1rem;
  color: #2bb8dd;
  font-weight: bold;
  text-decoration: none;
}

/* Carousel controls */
.carousel-controls {
  display: flex;
  justify-content: center;
  margin-top: 1.5rem;
  gap: 1rem;
}

.carousel-controls button {
  background-color: #2bb8dd;
  color: white;
  padding: 10px 16px;
  font-size: 1.1rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.3);
  transition: background-color 0.2s ease;
}

.carousel-controls button:hover {
  background-color: #2399ba;
}



















/* 🔷 Featured Blog Section */
.featured-blog {
  background-color: #1f2937;
  padding: 3rem 2rem;
  color: white !important;
  text-align: center;
}

.featured-blog h2 {
  font-size: 2rem;
  margin-bottom: 2rem;
  color: white;
}

.featured-blog .article-card {
  max-width: 700px;
  margin: 0 auto;
  background-color: #111827 !important;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
  text-align: left;
}

.featured-blog .article-card h3 {
  font-size: 1.5rem;
  color: white;
  margin-bottom: 0.5rem;
}

.featured-blog .article-card p {
  color: white !important;
  font-size: 1rem;
  line-height: 1.6;
}


/* Optional: fading effect if clipped */
.featured-blog .article-card p::after {
  content: '';
  display: block;
  height: 1rem;
  background: linear-gradient(to bottom, rgba(17,24,39,0) 0%, rgba(17,24,39,1) 100%);
  margin-top: -1rem;
}

/* Button */
.featured-blog .article-btn {
  margin-top: 1rem;
  display: inline-block;
  background-color: #2bb8dd;
  color: white;
  padding: 10px 20px;
  border-radius: 25px;
  font-weight: bold;
  text-decoration: none;
}

.featured-blog .article-btn:hover {
  background-color: #2399ba;
}

/* 🔷 Recent Articles Section */
.recent-articles {
  background-color: #1f2937;
  border: 2px solid #2bb8dd;
  border-radius: 10px;
  padding: 2rem;
  margin: 3rem auto;
  text-align: center;
  position: relative;
  max-width: 1100px;
}

.recent-articles h2 {
  font-size: 2rem;
  margin-bottom: 1.5rem;
  color: white;
}

.articles-wrapper {
  display: flex;
  gap: 1rem;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  padding: 1rem 0;
  scrollbar-width: none;
}

.articles-wrapper::-webkit-scrollbar {
  display: none;
}

.article-card {
  flex: 0 0 300px;
  scroll-snap-align: start;
  background-color: #111827;
  border-radius: 10px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.25);
  padding: 1.5rem;
  color: white;
  text-align: left;
  transition: transform 0.3s ease;
  min-width: 250px; /* important for slider feel */
}

.article-card:hover {
  transform: translateY(-5px);
}


.article-card h3 {
  font-size: 1.3rem;
  margin-bottom: 0.5rem;
  color: white;
}

.article-card p {
  color: #ccc;
  font-size: 0.95rem;
  line-height: 1.5;
}

.article-btn {
  display: inline-block;
  margin-top: 1rem;
  color: #2bb8dd;
  font-weight: bold;
  text-decoration: none;
}

/* Responsive tweaks */
@media screen and (max-width: 768px) {
  .articles-wrapper {
    flex-direction: column;
    align-items: center;
  }

  .featured-blog .article-card {
    padding: 1.5rem;
  }
}
.featured-blog, 
.featured-blog * {
  color: white !important;
}

.featured-blog p {
  margin-bottom: 1rem;
}

/* 🌐 Responsive blog main layout */
@media screen and (max-width: 768px) {
  .blog-main {
    padding: 1.5rem 1rem;
  }

  .post-title {
    font-size: 1.8rem;
  }

  .single-post-hero {
    padding-bottom: 0.5rem;
  }

  .post-date,
  .post-author {
    font-size: 0.85rem;
  }
}

/* 📦 Featured Blog responsive layout */
@media screen and (max-width: 768px) {
  .featured-blog {
    padding: 2rem 1rem;
  }

  .featured-blog .article-card {
    padding: 1.5rem;
  }

  .featured-blog h2 {
    font-size: 1.6rem;
  }
}

/* 📝 Enquiry form responsiveness */
@media screen and (max-width: 768px) {
  .enquiry-form input,
  .enquiry-form textarea {
    padding: 12px 16px;
    font-size: 0.95rem;
  }

  .blog-btn.send-message {
    font-size: 0.95rem;
    padding: 10px 20px;
  }
}


@media screen and (max-width: 768px) {
  .comment-box {
    padding: 2rem 1rem;
  }

  .comment-box h2 {
    font-size: 1.5rem;
  }

  .comment-box input,
  .comment-box textarea {
    font-size: 0.95rem;
    padding: 10px 12px;
  }

  .comment-box button {
    font-size: 0.95rem;
    padding: 10px 18px;
  }
}


@media screen and (max-width: 768px) {
  .carousel-controls {
    gap: 0.5rem;
    margin-top: 1rem;
  }

  .carousel-controls button {
    font-size: 1rem;
    padding: 8px 14px;
  }
}

@media screen and (max-width: 768px) {
  .articles-wrapper {
    flex-wrap: nowrap;
  }

  .article-card {
    flex: 0 0 80%;
    max-width: 80%;
  }

  .carousel-controls {
    flex-direction: column;
    gap: 0.5rem;
  }

  .carousel-controls button {
    font-size: 0.9rem;
    padding: 8px 12px;
    width: 48%;
    margin: 0 auto;
  }
}

@media screen and (max-width: 500px) {
  .article-card {
    flex: 0 0 90%;
    max-width: 90%;
  }
}
/* Hide carousel buttons on small screens */
@media screen and (max-width: 768px) {
  .carousel-controls {
    display: none;
  }
}
@media screen and (min-width: 769px) {
  .carousel-controls {
    display: flex;
    justify-content: center;
    gap: 1rem;
    margin-top: 1.5rem;
  }

  .carousel-controls button {
    background-color: #2bb8dd;
    color: white;
    padding: 10px 16px;
    font-size: 1.1rem;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.3);
    transition: background-color 0.2s ease;
  }

  .carousel-controls button:hover {
    background-color: #2399ba;
  }
}














.ql-editor,
.ql-editor * {
  color: #ffffff !important;
  background-color: #1f2937 !important;
}


.ql-editor.ql-blank::before {
  color: #aaa !important;
}

/* Toolbar styling */
.ql-toolbar {
  background-color: #111827 !important;
  border-color: #2bb8dd !important;
}

.ql-toolbar button {
  color: #ccc !important;
  border: none !important;
  box-shadow: none !important;
}

.ql-toolbar button:hover,
.ql-toolbar button.ql-active {
  color: #2bb8dd !important;
}




.blog-form input,
.blog-form button {
  width: 100%;
  padding: 12px 18px;
  margin: 0.8rem 0;
  font-size: 1rem;
  border-radius: 8px;
  background: #111827;
  color: white;
  border: 1px solid #2bb8dd;
}

.blog-form button {
  background: #2bb8dd;
  color: white;
  font-weight: bold;
  cursor: pointer;
  border: none !important;
  box-shadow: none !important;
}

.blog-form button:hover {
  background-color: #2399ba;
}


/* ========================= */
/* 🛠️ ADMIN PANEL POST LIST  */
/* ========================= */

.blog-custom-container {
  background-color: #111827;
  min-height: 100vh;
  padding: 2rem;
  color: white;
}

.blog-admin-post {
  border: 1px solid #2bb8dd;
  border-radius: 10px;
  padding: 1rem;
  margin-top: 1rem;
  display: flex;
  justify-content: space-between;
  background-color: #1f2937;
  color: white;
  flex-wrap: wrap;
}

/* ✅ Edit & Delete buttons in admin panel */
.blog-admin-post button,
.blog-admin-post .blog-btn {
  background-color: #2bb8dd;
  color: white;
  font-weight: bold;
  padding: 10px 18px;
  border-radius: 20px;
  border: none !important;
  box-shadow: none !important;
  margin: 0.3rem;
  cursor: pointer;
}

.blog-admin-post button:hover,
.blog-admin-post .blog-btn:hover {
  background-color: #2399ba;
}

/* =============== Responsive Breakpoints =============== */

/* Tablets */
@media screen and (max-width: 1024px) {
  .blog-post-layout,
  .blog-main,
  .enquiry-box-container,
  .comment-box,
  .featured-blog .article-card,
  .blog-custom-container {
    padding: 1.5rem;
  }

  .blog-form input,
  .blog-form button,
  .ql-editor {
    font-size: 1rem;
  }
}

/* Mobile */
@media screen and (max-width: 768px) {
  .hero-content h1 {
    font-size: 1.5rem;
  }

  .hero-content p {
    font-size: 1rem;
  }

  .featured-blog,
  .recent-articles,
  .blog-custom-container {
    padding: 1.5rem 1rem;
  }

  .article-card {
    flex: 0 0 100%;
  }

  .carousel-controls {
    flex-direction: column;
    gap: 0.5rem;
  }

  .blog-admin-post {
    flex-direction: column;
    gap: 1rem;
  }

  .blog-form input,
  .blog-form button {
    font-size: 0.95rem;
    padding: 10px 14px;
  }

  .form-actions {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
  }

  .ql-editor {
    font-size: 1rem;
  }
}

/* Extra Small Devices */
@media screen and (max-width: 480px) {
  .blog-btn,
  .article-btn,
  .carousel-controls button {
    width: 100%;
    font-size: 0.95rem;
    padding: 10px;
  }

  .post-title {
    font-size: 1.8rem;
  }

  .comment-box,
  .enquiry-box-container {
    padding: 1.2rem;
  }

  .article-card {
    padding: 1rem;
  }

  .ql-toolbar {
    flex-wrap: wrap;
  }

  .blog-custom-container {
    padding: 1rem;
  }

  .editor-heading {
    font-size: 1.5rem;
  }
}




.form-actions {
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  margin-top: 1rem;
}

@media screen and (max-width: 768px) {
  .form-actions {
    flex-direction: column;
  }

  .form-actions button {
    width: 100%;
  }
}


/* Blog Content Styling - Consistent between Blog and Single Post */
.featured-body,
.post-content {
  text-align: left;
  color: white !important;
  font-size: 1.1rem;
  line-height: 1.8;
  margin-bottom: 2rem;
}

.featured-body p,
.post-content p {
  margin-bottom: 1.5rem;
  color: #e5e7eb !important;
  font-size: 1.1rem;
  line-height: 1.8;
}

.featured-body h1, 
.featured-body h2, 
.featured-body h3, 
.featured-body h4,
.post-content h1,
.post-content h2,
.post-content h3,
.post-content h4 {
  color: white !important;
  margin: 1.5rem 0 1rem 0;
  font-weight: 700;
}

.featured-body h1,
.post-content h1 {
  font-size: 2.2rem;
}

.featured-body h2,
.post-content h2 {
  font-size: 1.8rem;
}

.featured-body h3,
.post-content h3 {
  font-size: 1.5rem;
}

.featured-body h4,
.post-content h4 {
  font-size: 1.3rem;
}

.featured-body ul, 
.featured-body ol,
.post-content ul,
.post-content ol {
  margin-left: 1.5rem;
  margin-bottom: 1.5rem;
  padding-left: 1rem;
}

.featured-body li,
.post-content li {
  margin-bottom: 0.5rem;
  color: #e5e7eb !important;
}

.featured-body a,
.post-content a {
  color: #2bb8dd !important;
  text-decoration: underline;
}

.featured-body blockquote,
.post-content blockquote {
  border-left: 4px solid #2bb8dd;
  padding-left: 1rem;
  margin-left: 0;
  margin-right: 0;
  font-style: italic;
  color: #d1d5db !important;
}

.featured-body pre,
.post-content pre {
  background-color: #1a1e2d;
  padding: 1rem;
  border-radius: 5px;
  overflow-x: auto;
  margin-bottom: 1.5rem;
}

.featured-body code,
.post-content code {
  font-family: monospace;
  background-color: #1a1e2d;
  padding: 0.2rem 0.4rem;
  border-radius: 3px;
  font-size: 0.9em;
}

.featured-body img,
.post-content img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  margin: 1.5rem 0;
}

.featured-body table,
.post-content table {
  width: 100%;
  border-collapse: collapse;
  margin: 1.5rem 0;
}

.featured-body th, 
.featured-body td,
.post-content th,
.post-content td {
  border: 1px solid #374151;
  padding: 0.75rem;
  text-align: left;
}

.featured-body th,
.post-content th {
  background-color: #1f2937;
}

/* Article cards in recent posts */
.article-card p {
  color: #e5e7eb !important;
  font-size: 1rem;
  line-height: 1.6;
  margin-bottom: 1rem;
}

/* Make sure all content is properly visible */
.featured-blog, 
.featured-blog * {
  color: white !important;
}

.featured-blog p {
  margin-bottom: 1rem;
}

/* 🌐 Responsive blog main layout */
@media screen and (max-width: 768px) {
  .blog-main {
    padding: 1.5rem 1rem;
  }

  .post-title {
    font-size: 1.8rem;
  }

  .single-post-hero {
    padding-bottom: 0.5rem;
  }

  .post-date,
  .post-author {
    font-size: 0.85rem;
  }
  
  .featured-body,
  .post-content {
    font-size: 1rem;
  }
  
  .featured-body h1,
  .post-content h1 {
    font-size: 1.8rem;
  }
  
  .featured-body h2,
  .post-content h2 {
    font-size: 1.5rem;
  }
}
/* Blog Hero Section */
.blog-hero-section {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  min-height: 60vh;
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
}

.blog-hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1;
}

.blog-hero-overlay {
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.blog-hero-content {
  text-align: center;
  color: white;
}

.blog-hero-title {
  font-size: 3.5rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  line-height: 1.2;
}

.blog-hero-subtitle {
  font-size: 1.25rem;
  margin-bottom: 2rem;
  opacity: 0.9;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.blog-hero-btn {
  display: inline-block !important;
  background: linear-gradient(90deg, #2596be, #3fb6e0) !important;
  color: var(--text-color) !important;
  padding: 14px 32px !important;
  border-radius: 30px !important;
  font-family: var(--font-family) !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  text-decoration: none !important;
  transition: all 0.3s ease !important;
  box-shadow: 0 4px 15px rgba(37, 150, 190, 0.3) !important;
  border: none !important;
}

.blog-hero-btn:hover {
  background: linear-gradient(90deg, #3fb6e0, #2596be) !important;
  transform: translateY(-3px) !important;
  box-shadow: 0 6px 22px rgba(37, 150, 190, 0.45) !important;
  color: var(--text-color) !important;
  text-decoration: none !important;
}


/* Blog Container */
.blog-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* Loading */
.blog-loading-container {
  text-align: center;
  padding: 4rem 0;
}

.blog-loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3fb6e0;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 1rem;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Featured Section */
.blog-featured-section {
  padding: 4rem 0;
  background: #f8f9fa;
  margin: 2rem 0;
  border-radius: 20px;
}

.blog-featured-container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 2rem;
}

.blog-featured-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  align-items: center;
}

.blog-featured-meta {
  margin-bottom: 1.5rem;
}

.blog-featured-badge {
  background: linear-gradient(90deg, #2596be, #3fb6e0) !important;
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 600;
  display: inline-block;
  margin-bottom: 1rem;
}

.blog-meta-info {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  font-size: 0.875rem;
  color: #666;
}

.blog-featured-title {
  font-size: 2.5rem;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 1.5rem;
  color: #2d3748;
}

.blog-featured-excerpt {
  font-size: 1.125rem;
  line-height: 1.6;
  color: #4a5568;
  margin-bottom: 2rem;
}

.blog-read-more-btn {
  display: inline-flex !important;
  align-items: center !important;
  gap: 0.5rem !important;
  background: #3fb6e0 !important;
  color: white !important;
  padding: 12px 24px !important;
  border-radius: 8px !important;
  text-decoration: none !important;
  font-weight: 600 !important;
  transition: all 0.3s ease !important;
}

.blog-read-more-btn:hover {
  background: #3fb6e0 !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3) !important;
  color: white !important;
  text-decoration: none !important;
}


.blog-btn-arrow {
  transition: transform 0.3s ease;
}

.blog-read-more-btn:hover .blog-btn-arrow {
  transform: translateX(4px);
}

/* Featured Image */
.blog-featured-image {
  position: relative;
}

.blog-featured-img,
.blog-featured-video {
  width: 100%;
  height: 300px;
  object-fit: cover;
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.blog-featured-img:hover,
.blog-featured-video:hover {
  transform: scale(1.02);
}

.blog-featured-placeholder {
  width: 100%;
  height: 300px;
  background: linear-gradient(135deg, #e2e8f0, #cbd5e0);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.blog-placeholder-content {
  text-align: center;
  color: #718096;
}

.blog-placeholder-icon {
  font-size: 3rem;
  display: block;
  margin-bottom: 0.5rem;
}

/* Recent Articles Section */
.blog-recent-section {
  padding: 4rem 0;
}

.blog-section-header {
  text-align: center;
  margin-bottom: 3rem;
}

.blog-section-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 1rem;
}

.blog-section-subtitle {
  font-size: 1.125rem;
  color: #718096;
  max-width: 600px;
  margin: 0 auto;
}

.blog-articles-container {
  position: relative;
}

.blog-articles-wrapper {
  display: flex;
  gap: 2rem;
  overflow-x: auto;
  scroll-behavior: smooth;
  padding: 1rem 0;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.blog-articles-wrapper::-webkit-scrollbar {
  display: none;
}

/* Article Cards */
.blog-article-card {
  flex: 0 0 350px;
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  border: 1px solid #e2e8f0;
}

.blog-article-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
}

.blog-card-image {
  position: relative;
  height: 200px;
  overflow: hidden;
}

.blog-card-img,
.blog-card-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.blog-article-card:hover .blog-card-img,
.blog-article-card:hover .blog-card-video {
  transform: scale(1.05);
}

.blog-card-placeholder {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #f7fafc, #edf2f7);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #a0aec0;
}

.blog-card-placeholder .blog-placeholder-icon {
  font-size: 2.5rem;
}

.blog-card-content {
  padding: 1.5rem;
}

.blog-card-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  font-size: 0.875rem;
  color: #718096;
}

.blog-card-date {
  font-weight: 500;
}

.blog-card-reading-time {
  background: #edf2f7;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.75rem;
}

.blog-card-title {
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1.3;
  margin-bottom: 0.75rem;
  color: #2d3748;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.blog-card-category {
  display: inline-block;
  background: #3fb6e0;
  color: white;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 0.75rem;
  font-weight: 600;
  margin-bottom: 1rem;
}

.blog-card-excerpt {
  color: #4a5568;
  line-height: 1.5;
  margin-bottom: 1.5rem;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.blog-card-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: #3fb6e0;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
  padding: 8px 0;
}

.blog-card-btn:hover {
  color: #5a67d8;
  text-decoration: none;
}

.blog-card-btn:hover .blog-btn-arrow {
  transform: translateX(4px);
}

/* Carousel Controls */
.blog-carousel-controls {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 2rem;
}

.blog-carousel-btn {
  width: 50px;
  height: 50px;
  border: none;
  border-radius: 50%;
  background: #3fb6e0;
  color: white;
  font-size: 1.25rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.blog-carousel-btn:hover {
  background: #5a67d8;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
}

.blog-carousel-btn:active {
  transform: translateY(0);
}

/* Responsive Design */
@media (max-width: 768px) {
  .blog-hero-title {
    font-size: 2.5rem;
  }
  
  .blog-hero-subtitle {
    font-size: 1rem;
  }
  
  .blog-featured-content {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
  
  .blog-featured-title {
    font-size: 2rem;
  }
  
  .blog-section-title {
    font-size: 2rem;
  }
  
  .blog-article-card {
    flex: 0 0 280px;
  }
  
  .blog-container {
    padding: 0 15px;
  }
}

@media (max-width: 480px) {
  .blog-hero-title {
    font-size: 2rem;
  }
  
  .blog-featured-title {
    font-size: 1.75rem;
  }
  
  .blog-section-title {
    font-size: 1.75rem;
  }
  
  .blog-article-card {
    flex: 0 0 250px;
  }
  
  .blog-featured-container {
    padding: 0 1rem;
  }
}

/* Additional Animations */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.blog-article-card {
  animation: fadeInUp 0.6s ease forwards;
}

.blog-article-card:nth-child(2) {
  animation-delay: 0.1s;
}

.blog-article-card:nth-child(3) {
  animation-delay: 0.2s;
}

.blog-article-card:nth-child(4) {
  animation-delay: 0.3s;
}

/* Smooth scrolling for the entire page */
html {
  scroll-behavior: smooth;
}

/* Focus states for accessibility */
.blog-hero-btn:focus,
.blog-read-more-btn:focus,
.blog-card-btn:focus,
.blog-carousel-btn:focus {
  outline: 2px solid #3fb6e0;
  outline-offset: 2px;
}
/* Blog Hero Section */
.blog-hero-section {
  background: linear-gradient(135deg, #1a202c 0%, #2d3748 100%);
  min-height: 60vh;
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
}

.blog-hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1;
}

.blog-hero-overlay {
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.blog-hero-content {
  text-align: center;
  color: white;
}

.blog-hero-title {
  font-size: 3.5rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  line-height: 1.2;
  color: #ffffff;
}

.blog-hero-subtitle {
  font-size: 1.25rem;
  margin-bottom: 2rem;
  opacity: 0.9;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  color: #e2e8f0;
}

.blog-hero-btn {
  display: inline-block;
  background: #3fb6e0;
  color: white;
  padding: 15px 30px;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.blog-hero-btn:hover {
  background: #5a67d8;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
  color: white;
  text-decoration: none;
}

/* Blog Container */
.blog-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  background: #111827;
  min-height: 100vh;
}

/* Loading */
.blog-loading-container {
  text-align: center;
  padding: 4rem 0;
  color: #e2e8f0;
}

.blog-loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #374151;
  border-top: 4px solid #3fb6e0;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 1rem;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Featured Section */
.blog-featured-section {
  padding: 4rem 0;
  background: #1f2937;
  margin: 2rem 0;
  border-radius: 20px;
  border: 1px solid #374151;
}

.blog-featured-container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 2rem;
}

.blog-featured-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  align-items: center;
}

.blog-featured-meta {
  margin-bottom: 1.5rem;
}

.blog-featured-badge {
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 600;
  display: inline-block;
  margin-bottom: 1rem;
}

.blog-meta-info {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  font-size: 0.875rem;
  color: #9ca3af;
}

.blog-featured-title {
  font-size: 2.5rem;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 1.5rem;
  color: #ffffff;
}

.blog-featured-excerpt {
  font-size: 1.125rem;
  line-height: 1.6;
  color: #d1d5db;
  margin-bottom: 2rem;
}

.blog-read-more-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: #3fb6e0;
  color: white;
  padding: 12px 24px;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
}

.blog-read-more-btn:hover {
  background: #5a67d8;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
  color: white;
  text-decoration: none;
}

.blog-btn-arrow {
  transition: transform 0.3s ease;
}

.blog-read-more-btn:hover .blog-btn-arrow {
  transform: translateX(4px);
}

/* Featured Image */
.blog-featured-image {
  position: relative;
}

.blog-featured-img,
.blog-featured-video {
  width: 100%;
  height: 300px;
  object-fit: cover;
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s ease;
  border: 1px solid #374151;
}

.blog-featured-img:hover,
.blog-featured-video:hover {
  transform: scale(1.02);
}

.blog-featured-placeholder {
  width: 100%;
  height: 300px;
  background: linear-gradient(135deg, #374151, #4b5563);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
  border: 1px solid #6b7280;
}

.blog-placeholder-content {
  text-align: center;
  color: #9ca3af;
}

.blog-placeholder-icon {
  font-size: 3rem;
  display: block;
  margin-bottom: 0.5rem;
}

/* Recent Articles Section */
.blog-recent-section {
  padding: 4rem 0;
}

.blog-section-header {
  text-align: center;
  margin-bottom: 3rem;
}

.blog-section-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 1rem;
}

.blog-section-subtitle {
  font-size: 1.125rem;
  color: #9ca3af;
  max-width: 600px;
  margin: 0 auto;
}

.blog-articles-container {
  position: relative;
}

.blog-articles-wrapper {
  display: flex;
  gap: 2rem;
  overflow-x: auto;
  scroll-behavior: smooth;
  padding: 1rem 0;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.blog-articles-wrapper::-webkit-scrollbar {
  display: none;
}

/* Article Cards - Black Theme */
.blog-article-card {
  flex: 0 0 350px;
  background: #1f2937;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  border: 1px solid #374151;
}

.blog-article-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.5);
  border-color: #3fb6e0;
}

.blog-card-image {
  position: relative;
  height: 200px;
  overflow: hidden;
}

.blog-card-img,
.blog-card-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.blog-article-card:hover .blog-card-img,
.blog-article-card:hover .blog-card-video {
  transform: scale(1.05);
}

.blog-card-placeholder {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #374151, #4b5563);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9ca3af;
}

.blog-card-placeholder .blog-placeholder-icon {
  font-size: 2.5rem;
}

.blog-card-content {
  padding: 1.5rem;
  background: #1f2937;
}

.blog-card-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  font-size: 0.875rem;
  color: #9ca3af;
}

.blog-card-date {
  font-weight: 500;
  color: #d1d5db;
}

.blog-card-reading-time {
  background: #374151;
  color: #e5e7eb;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 0.75rem;
}

.blog-card-title {
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1.3;
  margin-bottom: 0.75rem;
  color: #ffffff;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.blog-card-category {
  display: inline-block;
  background: #3fb6e0;
  color: white;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 0.75rem;
  font-weight: 600;
  margin-bottom: 1rem;
}

.blog-card-excerpt {
  color: #d1d5db;
  line-height: 1.5;
  margin-bottom: 1.5rem;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.blog-card-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: #3fb6e0;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
  padding: 8px 0;
}

.blog-card-btn:hover {
  color: #818cf8;
  text-decoration: none;
}

.blog-card-btn:hover .blog-btn-arrow {
  transform: translateX(4px);
}

/* Carousel Controls */
.blog-carousel-controls {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 2rem;
}

.blog-carousel-btn {
  width: 50px;
  height: 50px;
  border: none;
  border-radius: 50%;
  background: #374151;
  color: #e5e7eb;
  font-size: 1.25rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  border: 1px solid #4b5563;
}

.blog-carousel-btn:hover {
  background: #3fb6e0;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
  border-color: #3fb6e0;
}

.blog-carousel-btn:active {
  transform: translateY(0);
}

/* Responsive Design */
@media (max-width: 768px) {
  .blog-hero-title {
    font-size: 2.5rem;
  }
  
  .blog-hero-subtitle {
    font-size: 1rem;
  }
  
  .blog-featured-content {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
  
  .blog-featured-title {
    font-size: 2rem;
  }
  
  .blog-section-title {
    font-size: 2rem;
  }
  
  .blog-article-card {
    flex: 0 0 280px;
  }
  
  .blog-container {
    padding: 0 15px;
  }
}

@media (max-width: 480px) {
  .blog-hero-title {
    font-size: 2rem;
  }
  
  .blog-featured-title {
    font-size: 1.75rem;
  }
  
  .blog-section-title {
    font-size: 1.75rem;
  }
  
  .blog-article-card {
    flex: 0 0 250px;
  }
  
  .blog-featured-container {
    padding: 0 1rem;
  }
}

/* Additional Animations */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.blog-article-card {
  animation: fadeInUp 0.6s ease forwards;
}

.blog-article-card:nth-child(2) {
  animation-delay: 0.1s;
}

.blog-article-card:nth-child(3) {
  animation-delay: 0.2s;
}

.blog-article-card:nth-child(4) {
  animation-delay: 0.3s;
}

/* Smooth scrolling for the entire page */
html {
  scroll-behavior: smooth;
}

/* Focus states for accessibility */
.blog-hero-btn:focus,
.blog-read-more-btn:focus,
.blog-card-btn:focus,
.blog-carousel-btn:focus {
  outline: 2px solid #3fb6e0;
  outline-offset: 2px;
}

/* Additional Black Theme Enhancements */

/* Ensure the entire blog page has dark background */
.blog-page-wrapper {
  background-color: #111827;
  min-height: 100vh;
}

/* Dark theme for text selections */
::selection {
  background-color: #3fb6e0;
  color: white;
}

::-moz-selection {
  background-color: #3fb6e0;
  color: white;
}

/* Enhanced card hover effects for dark theme */
.blog-article-card:hover {
  background: #374151;
  border-color: #3fb6e0;
  box-shadow: 0 12px 40px rgba(102, 126, 234, 0.2);
}

/* Dark theme scrollbar for webkit browsers */
.blog-articles-wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.blog-articles-wrapper::-webkit-scrollbar-track {
  background: #1f2937;
  border-radius: 4px;
}

.blog-articles-wrapper::-webkit-scrollbar-thumb {
  background: #4b5563;
  border-radius: 4px;
}

.blog-articles-wrapper::-webkit-scrollbar-thumb:hover {
  background: #6b7280;
}

/* Enhanced gradient for featured section */
.blog-featured-section {
  background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
  border: 1px solid #374151;
  position: relative;
}

.blog-featured-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 50% 50%, rgba(102, 126, 234, 0.05) 0%, transparent 70%);
  pointer-events: none;
}

/* Enhanced button styles for dark theme */
.blog-hero-btn,
.blog-read-more-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.blog-hero-btn:hover,
.blog-read-more-btn:hover {
  background: linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

/* Dark theme for date and meta information */
.blog-date,
.blog-reading-time,
.blog-category {
  color: #9ca3af;
}

.blog-category {
  background: #374151;
  color: #e5e7eb;
  border: 1px solid #4b5563;
}

/* Enhanced placeholder styles */
.blog-featured-placeholder,
.blog-card-placeholder {
  background: linear-gradient(135deg, #374151 0%, #1f2937 100%);
  border: 2px dashed #4b5563;
}

.blog-placeholder-content p {
  color: #6b7280;
  font-weight: 500;
}

/* Loading spinner dark theme */
.blog-loading-container {
  background: #111827;
}

.blog-loading-container p {
  color: #9ca3af;
  font-size: 1.1rem;
}

/* Enhanced typography for dark theme */
.blog-hero-title {
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.blog-section-title {
  background: linear-gradient(135deg, #ffffff 0%, #e5e7eb 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Card content enhancements */
.blog-card-content {
  position: relative;
}

.blog-card-content::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent 0%, #4b5563 50%, transparent 100%);
}

/* Enhanced meta information styling */
.blog-meta-info span {
  padding: 4px 8px;
  background: #374151;
  border-radius: 6px;
  font-size: 0.75rem;
  border: 1px solid #4b5563;
}

.blog-card-meta {
  border-bottom: 1px solid #374151;
  padding-bottom: 0.75rem;
  margin-bottom: 1rem;
}

/* Improved accessibility and contrast */
.blog-card-title:hover {
  color: #f3f4f6;
}

.blog-featured-title:hover {
  color: #f9fafb;
}

/* Enhanced animation for cards */
@keyframes cardGlow {
  0% {
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  }
  50% {
    box-shadow: 0 8px 30px rgba(102, 126, 234, 0.2);
  }
  100% {
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  }
}

.blog-article-card:hover {
  animation: cardGlow 2s ease-in-out infinite;
}

/* Dark theme for form elements if any */



/* Enhanced mobile responsiveness for dark theme */
@media (max-width: 768px) {
  .blog-container {
    background: #111827;
  }
  
  .blog-featured-section {
    margin: 1rem 0;
    border-radius: 12px;
  }
  
  .blog-article-card {
    background: #1f2937;
    border: 1px solid #374151;
  }
}

@media (max-width: 480px) {
  .blog-hero-section {
    background: linear-gradient(135deg, #111827 0%, #1f2937 100%);
  }
  
  .blog-carousel-controls {
    gap: 0.5rem;
  }
  
  .blog-carousel-btn {
    width: 40px;
    height: 40px;
    font-size: 1rem;
  }
}

/* Print styles for dark theme */
@media print {
  .blog-container,
  .blog-article-card,
  .blog-featured-section {
    background: white !important;
    color: black !important;
    border: 1px solid #ccc !important;
  }
  
  .blog-carousel-controls {
    display: none;
  }
}
/* Add this to your existing App.css file */

/* Professional Comments Section Styling */
.comment-section {
  display: flex;
  justify-content: center;
  padding: 3rem 1rem;
  background: transparent;
}

.comment-box {
  background-color: #1f2937;
  border: 2px solid #2bb8dd;
  border-radius: 16px;
  padding: 2.5rem;
  width: 100%;
  max-width: 900px;
  color: white;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  transition: box-shadow 0.3s ease;
}

.comment-box:hover {
  box-shadow: 0 15px 40px rgba(43, 184, 221, 0.2);
}

.comment-box h3 {
  font-size: 1.8rem;
  margin-bottom: 2rem;
  text-align: center;
  color: white;
  font-weight: 700;
  position: relative;
}

.comment-box h3::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, #2bb8dd, #667eea);
  border-radius: 2px;
}

/* Comment Form Styling */
.comment-form {
  margin-bottom: 3rem;
  padding-bottom: 2rem;
  border-bottom: 1px solid #374151;
}

.comment-form input,
.comment-form textarea {
  width: 100%;
  padding: 14px 18px;
  margin-bottom: 1.2rem;
  border: 1px solid #374151;
  border-radius: 12px;
  background-color: #111827;
  color: white;
  font-size: 1rem;
  transition: all 0.3s ease;
  font-family: 'Poppins', sans-serif;
}

.comment-form input:focus,
.comment-form textarea:focus {
  outline: none;
  border-color: #2bb8dd;
  background-color: #1e293b;
  box-shadow: 0 0 0 3px rgba(43, 184, 221, 0.1);
}

.comment-form input::placeholder,
.comment-form textarea::placeholder {
  color: #9ca3af;
}

.comment-form textarea {
  min-height: 120px;
  resize: vertical;
}

.comment-form button {
  background: linear-gradient(135deg, #2bb8dd 0%, #667eea 100%);
  color: white;
  padding: 12px 30px;
  font-size: 1rem;
  border: none;
  border-radius: 25px;
  cursor: pointer;
  font-weight: 600;
  box-shadow: 0 4px 15px rgba(43, 184, 221, 0.3);
  transition: all 0.3s ease;
  display: block;
  margin: 0 auto;
  min-width: 140px;
}

.comment-form button:hover:not(:disabled) {
  background: linear-gradient(135deg, #2399ba 0%, #5a67d8 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(43, 184, 221, 0.4);
}

.comment-form button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

/* Comments List Styling */
.comments-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.comment-item {
  background: linear-gradient(135deg, #111827 0%, #1e293b 100%);
  border: 1px solid #374151;
  border-radius: 16px;
  padding: 1.8rem;
  margin-bottom: 1.5rem;
  position: relative;
  transition: all 0.3s ease;
  overflow: hidden;
}

.comment-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(180deg, #2bb8dd 0%, #667eea 100%);
  border-radius: 0 2px 2px 0;
}

.comment-item:hover {
  border-color: #2bb8dd;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(43, 184, 221, 0.15);
}

.comment-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.comment-author {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.comment-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #2bb8dd 0%, #667eea 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 1.1rem;
  color: white;
  text-transform: uppercase;
  box-shadow: 0 3px 10px rgba(43, 184, 221, 0.3);
}

.comment-author-info {
  display: flex;
  flex-direction: column;
}

.comment-author-name {
  font-weight: 600;
  color: #ffffff;
  font-size: 1.1rem;
  margin: 0;
}

.comment-author-email {
  font-size: 0.85rem;
  color: #9ca3af;
  margin: 0;
}

.comment-meta {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.comment-date {
  font-size: 0.85rem;
  color: #6b7280;
  background: #374151;
  padding: 4px 12px;
  border-radius: 20px;
  font-weight: 500;
}

.comment-badge {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Update existing comment content font size */
.comment-content {
  color: #e5e7eb;
  line-height: 1.7;
  font-size: 1.5rem !important; /* Increased from 1rem */
  margin: 0;
  word-wrap: break-word;
  font-weight: 400;
}


.comment-actions {
  margin-top: 1.2rem;
  padding-top: 1rem;
  border-top: 1px solid #374151;
  display: flex;
  gap: 1rem;
}

.comment-action-btn {
  background: transparent;
  border: 1px solid #4b5563;
  color: #9ca3af;
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.comment-action-btn:hover {
  border-color: #2bb8dd;
  color: #2bb8dd;
  background: rgba(43, 184, 221, 0.1);
}

/* Empty State */
.comments-empty {
  text-align: center;
  padding: 3rem 1rem;
  color: #6b7280;
}

.comments-empty-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
  opacity: 0.5;
}

.comments-empty-text {
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
}

.comments-empty-subtext {
  font-size: 0.9rem;
  opacity: 0.7;
}

/* Error Message Styling */
.error-message {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: white;
  padding: 12px 18px;
  border-radius: 10px;
  margin-bottom: 1.5rem;
  font-weight: 500;
  border: 1px solid #f87171;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.error-message::before {
  content: '⚠️';
  font-size: 1.2rem;
}

/* Success Message */
.success-message {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  padding: 12px 18px;
  border-radius: 10px;
  margin-bottom: 1.5rem;
  font-weight: 500;
  border: 1px solid #34d399;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.success-message::before {
  content: '✅';
  font-size: 1.2rem;
}

/* Login Prompt Styling */
.login-prompt {
  text-align: center;
  padding: 3rem 2rem;
  background: linear-gradient(135deg, #374151 0%, #1f2937 100%);
  border-radius: 16px;
  border: 2px dashed #4b5563;
}

.login-prompt-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
  color: #6b7280;
}

.login-prompt-text {
  font-size: 1.2rem;
  color: #d1d5db;
  margin-bottom: 1rem;
}

.login-prompt a {
  color: #2bb8dd;
  text-decoration: none;
  font-weight: 600;
  padding: 10px 20px;
  border: 2px solid #2bb8dd;
  border-radius: 25px;
  transition: all 0.3s ease;
  display: inline-block;
  margin-top: 1rem;
}

.login-prompt a:hover {
  background: #2bb8dd;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(43, 184, 221, 0.3);
}

/* Responsive Design */
@media (max-width: 768px) {
  .comment-box {
    padding: 1.5rem;
    margin: 1rem;
  }

  .comment-box h3 {
    font-size: 1.5rem;
  }

  .comment-item {
    padding: 1.2rem;
  }

  .comment-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }

  .comment-meta {
    align-self: stretch;
    justify-content: space-between;
  }

  .comment-avatar {
    width: 35px;
    height: 35px;
    font-size: 1rem;
  }

  .comment-actions {
    flex-wrap: wrap;
  }

  .comment-form input,
  .comment-form textarea {
    font-size: 0.95rem;
    padding: 12px 16px;
  }

  .comment-form button {
    width: 100%;
    padding: 14px;
  }
}

@media (max-width: 480px) {
  .comment-box {
    padding: 1rem;
    border-radius: 12px;
  }

  .comment-item {
    padding: 1rem;
    border-radius: 12px;
  }

  .comment-author {
    gap: 0.5rem;
  }

  .comment-avatar {
    width: 32px;
    height: 32px;
    font-size: 0.9rem;
  }

  .comment-author-name {
    font-size: 1rem;
  }

  .comment-content {
    font-size: 0.95rem;
  }
}

/* Animation for new comments */
@keyframes slideInComment {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.comment-item.new-comment {
  animation: slideInComment 0.5s ease-out;
}

/* Loading state for comments */
.comments-loading {
  text-align: center;
  padding: 2rem;
  color: #6b7280;
}

.comments-loading-spinner {
  width: 30px;
  height: 30px;
  border: 3px solid #374151;
  border-top: 3px solid #2bb8dd;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 1rem;
}
/* Reply and Edit Form Styles */
.reply-form, .edit-form {
  margin-top: 1rem;
  padding: 1rem;
  background: #0f172a;
  border-radius: 12px;
  border: 1px solid #334155;
}

.reply-textarea, .edit-textarea {
  width: 100%;
  min-height: 80px;
  padding: 12px;
  border: 1px solid #374151;
  border-radius: 8px;
  background-color: #111827;
  color: white;
  font-size: 0.9rem;
  resize: vertical;
  margin-bottom: 0.75rem;
}

.reply-textarea:focus, .edit-textarea:focus {
  outline: none;
  border-color: #2bb8dd;
  box-shadow: 0 0 0 2px rgba(43, 184, 221, 0.1);
}

.reply-actions, .edit-actions {
  display: flex;
  gap: 0.75rem;
}

.reply-btn, .save-btn {
  background: linear-gradient(135deg, #2bb8dd 0%, #667eea 100%);
  color: white;
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-size: 0.85rem;
  cursor: pointer;
  font-weight: 500;
}

.reply-btn:hover, .save-btn:hover {
  background: linear-gradient(135deg, #2399ba 0%, #5a67d8 100%);
}

.cancel-btn {
  background: transparent;
  color: #9ca3af;
  padding: 8px 16px;
  border: 1px solid #4b5563;
  border-radius: 6px;
  font-size: 0.85rem;
  cursor: pointer;
}

.cancel-btn:hover {
  background: #374151;
  color: white;
}

.reply-comment {
  margin-left: 2rem;
  border-left: 3px solid #2bb8dd;
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
}

.reply-indicator {
  color: #2bb8dd;
  font-size: 0.8rem;
  margin-left: 0.5rem;
  font-weight: 500;
}

@media (max-width: 768px) {
  .reply-comment {
    margin-left: 1rem;
  }
  
  .reply-actions, .edit-actions {
    flex-direction: column;
  }
  
  .reply-btn, .save-btn, .cancel-btn {
    width: 100%;
  }
}
.comment-action-btn.liked {
  color: #ef4444;
  border-color: #ef4444;
  background: rgba(239, 68, 68, 0.1);
}

.comment-action-btn.delete-btn {
  color: #ef4444;
  border-color: #ef4444;
}

.comment-action-btn.delete-btn:hover {
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
}

.comment-action-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Replies Container Styling */
.replies-container {
  margin-top: 1.5rem;
  padding-left: 1rem;
  border-left: 3px solid #2bb8dd;
  background: linear-gradient(135deg, rgba(15, 23, 42, 0.5) 0%, rgba(30, 41, 59, 0.3) 100%);
  border-radius: 0 12px 12px 0;
  padding: 1rem 0 1rem 1.5rem;
}

.replies-header {
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #334155;
}

.replies-count {
  color: #2bb8dd;
  font-weight: 600;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.replies-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.reply-item {
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
  border: 1px solid #334155;
  border-radius: 12px;
  padding: 1.2rem;
  margin-bottom: 1rem;
  position: relative;
  transition: all 0.3s ease;
}

.reply-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 3px;
  height: 100%;
  background: linear-gradient(180deg, #10b981 0%, #059669 100%);
  border-radius: 0 2px 2px 0;
}

.reply-item:hover {
  border-color: #10b981;
  transform: translateY(-1px);
  box-shadow: 0 4px 15px rgba(16, 185, 129, 0.15);
}

.reply-avatar {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  width: 35px !important;
  height: 35px !important;
  font-size: 0.9rem !important;
}

.reply-indicator {
  color: #10b981;
  font-size: 0.8rem;
  margin-left: 0.5rem;
  font-weight: 500;
}

/* Update form font sizes */
.comment-form input,
.comment-form textarea,
.reply-textarea,
.edit-textarea {
  font-size: 1rem; /* Increased from 0.9rem */
}

.comment-form textarea {
  font-size: 1rem; /* Increased */
}

/* Update author name font size */
.comment-author-name {
  font-weight: 600;
  color: #ffffff;
  font-size: 1.15rem; /* Increased from 1.1rem */
  margin: 0;
}

.comment-author-email {
  font-size: 0.9rem; /* Increased from 0.85rem */
  color: #9ca3af;
  margin: 0;
}

/* Update action buttons font size */
.comment-action-btn {
  font-size: 0.9rem; /* Increased from 0.85rem */
}

/* Update date font size */
.comment-date {
  font-size: 0.9rem; /* Increased from 0.85rem */
  color: #6b7280;
  background: #374151;
  padding: 4px 12px;
  border-radius: 20px;
  font-weight: 500;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .replies-container {
    padding-left: 0.75rem;
    margin-left: 0.5rem;
  }
  
  .reply-item {
    padding: 1rem;
  }
  
  .comment-content {
    font-size: 1rem;
  }
  
  .comment-author-name {
    font-size: 1.05rem;
  }
}

@media (max-width: 480px) {
  .replies-container {
    padding-left: 0.5rem;
    margin-left: 0.25rem;
  }
  
  .comment-content {
    font-size: 0.95rem;
  }
  
  .comment-author-name {
    font-size: 1rem;
  }
}
/* Single Post Page Styling */
.blog-post-layout {
  background: #000000;
  min-height: 100vh;
  color: #ffffff;
}

.blog-main {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0;
}

/* Loading State */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #000000;
  color: #ffffff;
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid #1a1a1a;
  border-top: 4px solid #2bb8dd;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

.loading-text {
  font-size: 1.1rem;
  color: #9ca3af;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Hero Section */
.single-post-hero {
  position: relative;
  padding: 4rem 2rem 3rem;
  background: linear-gradient(135deg, #000000 0%, #1a1a1a 50%, #000000 100%);
  text-align: center;
  overflow: hidden;
}

.hero-content {
  position: relative;
  z-index: 2;
  max-width: 800px;
  margin: 0 auto;
}

.post-category {
  margin-bottom: 1.5rem;
}

.category-badge {
  background: linear-gradient(135deg, #2bb8dd 0%, #667eea 100%);
  color: white;
  padding: 8px 20px;
  border-radius: 25px;
  font-size: 0.85rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  box-shadow: 0 4px 15px rgba(43, 184, 221, 0.3);
}

.post-title {
  font-size: clamp(2rem, 5vw, 3.5rem);
  font-weight: 800;
  line-height: 1.2;
  margin: 1.5rem 0;
  background: linear-gradient(135deg, #ffffff 0%, #e5e7eb 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.post-meta {
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin-top: 2rem;
  flex-wrap: wrap;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #9ca3af;
  font-size: 0.95rem;
}

.meta-icon {
  font-size: 1.1rem;
}

.hero-gradient {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at center, rgba(43, 184, 221, 0.1) 0%, transparent 70%);
  pointer-events: none;
}

/* Media Section */
.post-media-container {
  position: relative;
  margin: 2rem auto;
  max-width: 1000px;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
}

.blog-post-media {
  width: 100%;
  height: auto;
  max-height: 500px;
  object-fit: cover;
  display: block;
  transition: transform 0.3s ease;
}

.blog-post-media:hover {
  transform: scale(1.02);
}

.media-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, rgba(43, 184, 221, 0.1) 0%, rgba(102, 126, 234, 0.1) 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.post-media-container:hover .media-overlay {
  opacity: 1;
}

/* Content Section */
.post-content-wrapper {
  padding: 3rem 2rem;
  background: linear-gradient(180deg, #000000 0%, #0a0a0a 100%);
}

.post-content-container {
  max-width: 800px;
  margin: 0 auto;
}

.post-content {
  font-size: 1.15rem;
  line-height: 1.8;
  color: #e5e7eb;
  margin-bottom: 3rem;
}

.post-content h1,
.post-content h2,
.post-content h3,
.post-content h4,
.post-content h5,
.post-content h6 {
  color: #ffffff;
  margin: 2rem 0 1rem;
  font-weight: 700;
}

.post-content h2 {
  font-size: 1.8rem;
  border-bottom: 2px solid #2bb8dd;
  padding-bottom: 0.5rem;
}

.post-content h3 {
  font-size: 1.5rem;
  color: #2bb8dd;
}

.post-content p {
  margin-bottom: 1.5rem;
}

.post-content a {
  color: #2bb8dd;
  text-decoration: none;
  border-bottom: 1px solid transparent;
  transition: border-color 0.3s ease;
}

.post-content a:hover {
  border-bottom-color: #2bb8dd;
}

.post-content ul,
.post-content ol {
  margin: 1.5rem 0;
  padding-left: 2rem;
}

.post-content li {
  margin-bottom: 0.5rem;
}

.post-content blockquote {
  border-left: 4px solid #2bb8dd;
  padding: 1rem 1.5rem;
  margin: 2rem 0;
  background: #1a1a1a;
  border-radius: 0 8px 8px 0;
  font-style: italic;
}

.post-content code {
  background: #1a1a1a;
  padding: 2px 6px;
  border-radius: 4px;
  font-family: 'Courier New', monospace;
  color: #2bb8dd;
}

.post-content pre {
  background: #1a1a1a;
  padding: 1.5rem;
  border-radius: 8px;
  overflow-x: auto;
  margin: 1.5rem 0;
}

/* Social Share */
.social-share {
  padding: 2rem 0;
  border-top: 1px solid #333333;
  text-align: center;
}

.social-share h4 {
  color: #ffffff;
  margin-bottom: 1.5rem;
  font-size: 1.2rem;
}

.share-buttons {
  display: flex;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.share-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 10px 20px;
  border: 1px solid #333333;
  background: transparent;
  color: #9ca3af;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.9rem;
}

.share-btn:hover {
  border-color: #2bb8dd;
  color: #2bb8dd;
  background: rgba(43, 184, 221, 0.1);
  transform: translateY(-2px);
}

.share-btn.twitter:hover {
  border-color: #1da1f2;
  color: #1da1f2;
  background: rgba(29, 161, 242, 0.1);
}

.share-btn.facebook:hover {
  border-color: #4267b2;
  color: #4267b2;
  background: rgba(66, 103, 178, 0.1);
}

.share-btn.linkedin:hover {
  border-color: #0077b5;
  color: #0077b5;
  background: rgba(0, 119, 181, 0.1);
}

.share-btn.copy:hover {
  border-color: #10b981;
  color: #10b981;
  background: rgba(16, 185, 129, 0.1);
}

/* Comment Section Styling */
.comment-section {
  margin: 4rem 2rem 2rem;
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;
}

.comment-box {
  background: linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 100%);
  border-radius: 20px;
  padding: 2.5rem;
  border: 1px solid #333333;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

.comment-box h3 {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 2rem;
  color: #ffffff;
  text-align: center;
  background: linear-gradient(135deg, #2bb8dd 0%, #667eea 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Comment Form */
.comment-form {
  background: linear-gradient(135deg, #111111 0%, #1f1f1f 100%);
  padding: 2rem;
  border-radius: 15px;
  margin-bottom: 3rem;
  border: 1px solid #2a2a2a;
}

.comment-form input,
.comment-form textarea {
  width: 100%;
  padding: 15px 20px;
  margin-bottom: 1.5rem;
  background: #000000;
  border: 2px solid #333333;
  border-radius: 12px;
  color: #ffffff;
  font-size: 1rem;
  transition: all 0.3s ease;
  font-family: inherit;
}

.comment-form input:focus,
.comment-form textarea:focus {
  outline: none;
  border-color: #2bb8dd;
  box-shadow: 0 0 0 3px rgba(43, 184, 221, 0.1);
  background: #0a0a0a;
}

.comment-form textarea {
  min-height: 120px;
  resize: vertical;
}

.comment-form button {
  background: linear-gradient(135deg, #2bb8dd 0%, #667eea 100%);
  color: white;
  padding: 15px 30px;
  border: none;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: 0 4px 15px rgba(43, 184, 221, 0.3);
}

.comment-form button:hover {
  background: linear-gradient(135deg, #2399ba 0%, #5a67d8 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(43, 184, 221, 0.4);
}

.comment-form button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

/* Comments List */
.comments-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.comment-item {
  background: linear-gradient(135deg, #0f0f0f 0%, #1a1a1a 100%);
  border: 1px solid #2a2a2a;
  border-radius: 15px;
  padding: 2rem;
  margin-bottom: 2rem;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.comment-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(180deg, #2bb8dd 0%, #667eea 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.comment-item:hover {
  border-color: #2bb8dd;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(43, 184, 221, 0.15);
}

.comment-item:hover::before {
  opacity: 1;
}

.comment-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1.5rem;
}

.comment-author {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.comment-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: linear-gradient(135deg, #2bb8dd 0%, #667eea 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: 700;
  font-size: 1.2rem;
  box-shadow: 0 4px 15px rgba(43, 184, 221, 0.3);
}

.comment-author-info {
  flex: 1 1;
}

.comment-author-name {
  font-weight: 700;
  color: #ffffff;
  font-size: 1.2rem;
  margin-bottom: 0.25rem;
}

.comment-author-email {
  font-size: 0.9rem;
  color: #9ca3af;
}

.comment-meta {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.comment-date {
  font-size: 0.85rem;
  color: #6b7280;
  background: #2a2a2a;
  padding: 6px 12px;
  border-radius: 20px;
  font-weight: 500;
}

.comment-badge {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  padding: 4px 12px;
  border-radius: 15px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.comment-content {
  color: #e5e7eb;
  line-height: 1.7;
  font-size: 1.1rem;
  margin-bottom: 1.5rem;
  word-wrap: break-word;
}

.comment-actions {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.comment-action-btn {
  background: transparent;
  border: 1px solid #333333;
  color: #9ca3af;
  padding: 8px 16px;
  border-radius: 20px;
  cursor: pointer;
  font-size: 0.85rem;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.comment-action-btn:hover {
  border-color: #2bb8dd;
  color: #2bb8dd;
  background: rgba(43, 184, 221, 0.1);
  transform: translateY(-1px);
}

.comment-action-btn.liked {
  color: #ef4444;
  border-color: #ef4444;
  background: rgba(239, 68, 68, 0.1);
}

.comment-action-btn.delete-btn {
  color: #ef4444;
  border-color: #ef4444;
}

.comment-action-btn.delete-btn:hover {
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
}

/* Recent Articles Section */
.recent-articles {
  padding: 4rem 2rem;
  background: linear-gradient(180deg, #000000 0%, #0a0a0a 100%);
}

.section-header {
  text-align: center;
  margin-bottom: 3rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.section-header h2 {
  font-size: 2.5rem;
  font-weight: 800;
  margin-bottom: 1rem;
  background: linear-gradient(135deg, #ffffff 0%, #2bb8dd 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.section-header p {
  font-size: 1.1rem;
  color: #9ca3af;
  line-height: 1.6;
}

.articles-container {
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
}

.articles-wrapper {
  display: flex;
  gap: 2rem;
  overflow-x: auto;
  scroll-behavior: smooth;
  padding: 1rem 0 2rem;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.articles-wrapper::-webkit-scrollbar {
  display: none;
}

.article-card {
  flex: 0 0 350px;
  background: linear-gradient(135deg, #0f0f0f 0%, #1a1a1a 100%);
  border-radius: 20px;
  overflow: hidden;
  border: 1px solid #2a2a2a;
  transition: all 0.3s ease;
  position: relative;
  cursor: pointer;
}

.article-card:hover {
  transform: translateY(-8px);
  border-color: #2bb8dd;
  box-shadow: 0 15px 40px rgba(43, 184, 221, 0.2);
}

.card-content {
  padding: 2rem;
  position: relative;
  z-index: 2;
}

.card-header {
  margin-bottom: 1rem;
}

.card-date {
  background: linear-gradient(135deg, #2bb8dd 0%, #667eea 100%);
  color: white;
  padding: 6px 12px;
  border-radius: 15px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.card-title {
  font-size: 1.4rem;
  font-weight: 700;
  color: #ffffff;
  margin: 1rem 0;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.card-excerpt {
  color: #9ca3af;
  line-height: 1.6;
  margin-bottom: 1.5rem;
  font-size: 0.95rem;
}

.article-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  color: #2bb8dd;
  text-decoration: none;
  font-weight: 600;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.article-btn:hover {
  color: #ffffff;
  gap: 1rem;
}

.btn-arrow {
  transition: transform 0.3s ease;
}

.article-btn:hover .btn-arrow {
  transform: translateX(4px);
}

.card-gradient {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, rgba(43, 184, 221, 0.05) 0%, rgba(102, 126, 234, 0.05) 100%);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.article-card:hover .card-gradient {
  opacity: 1;
}

/* Carousel Controls */
.carousel-controls {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 2rem;
}

.carousel-btn {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%);
  border: 1px solid #333333;
  color: #9ca3af;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
}

.carousel-btn:hover {
  background: linear-gradient(135deg, #2bb8dd 0%, #667eea 100%);
  color: white;
  border-color: #2bb8dd;
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(43, 184, 221, 0.3);
}

/* Login Prompt */
.login-prompt {
  text-align: center;
  padding: 3rem 2rem;
  background: linear-gradient(135deg, #0f0f0f 0%, #1a1a1a 100%);
  border-radius: 20px;
  border: 1px solid #2a2a2a;
}

.login-prompt-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.login-prompt-text {
  font-size: 1.5rem;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 1rem;
}

.login-prompt p {
  color: #9ca3af;
  margin-bottom: 2rem;
  font-size: 1.1rem;
}

.login-prompt p {
  color: #9ca3af;
  margin-bottom: 2rem;
  font-size: 1.1rem;
}

.login-prompt a {
  display: inline-block;
  background: linear-gradient(135deg, #2bb8dd 0%, #667eea 100%);
  color: white;
  padding: 12px 30px;
  border-radius: 25px;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: 0 4px 15px rgba(43, 184, 221, 0.3);
}

.login-prompt a:hover {
  background: linear-gradient(135deg, #2399ba 0%, #5a67d8 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(43, 184, 221, 0.4);
}

/* Comments Empty State */
.comments-empty {
  text-align: center;
  padding: 4rem 2rem;
  background: linear-gradient(135deg, #0f0f0f 0%, #1a1a1a 100%);
  border-radius: 20px;
  border: 1px solid #2a2a2a;
}

.comments-empty-icon {
  font-size: 4rem;
  margin-bottom: 1.5rem;
  opacity: 0.7;
}

.comments-empty-text {
  font-size: 1.5rem;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 0.5rem;
}

.comments-empty-subtext {
  color: #9ca3af;
  font-size: 1rem;
}

/* Error and Success Messages */
.error-message {
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
  color: white;
  padding: 1rem 1.5rem;
  border-radius: 12px;
  margin-bottom: 1.5rem;
  font-weight: 500;
  box-shadow: 0 4px 15px rgba(220, 38, 38, 0.3);
}

.success-message {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  padding: 1rem 1.5rem;
  border-radius: 12px;
  margin-bottom: 1.5rem;
  font-weight: 500;
  box-shadow: 0 4px 15px rgba(16, 185, 129, 0.3);
}

/* Comments Loading State */
.comments-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3rem 2rem;
  background: linear-gradient(135deg, #0f0f0f 0%, #1a1a1a 100%);
  border-radius: 20px;
  border: 1px solid #2a2a2a;
}

.comments-loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #2a2a2a;
  border-top: 3px solid #2bb8dd;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

.comments-loading p {
  color: #9ca3af;
  font-size: 1rem;
  margin: 0;
}

/* Replies Container Enhanced */
.replies-container {
  margin-top: 2rem;
  padding: 1.5rem;
  background: linear-gradient(135deg, rgba(15, 23, 42, 0.3) 0%, rgba(30, 41, 59, 0.2) 100%);
  border-left: 4px solid #2bb8dd;
  border-radius: 0 15px 15px 0;
  position: relative;
}

.replies-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: -4px;
  width: 4px;
  height: 100%;
  background: linear-gradient(180deg, #2bb8dd 0%, #10b981 100%);
}

.replies-header {
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #334155;
}

.replies-count {
  color: #2bb8dd;
  font-weight: 700;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  background: rgba(43, 184, 221, 0.1);
  padding: 6px 12px;
  border-radius: 15px;
  display: inline-block;
}

.replies-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.reply-item {
  background: linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 100%);
  border: 1px solid #2a2a2a;
  border-radius: 15px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  position: relative;
  transition: all 0.3s ease;
}

.reply-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 3px;
  height: 100%;
  background: linear-gradient(180deg, #10b981 0%, #059669 100%);
  border-radius: 0 2px 2px 0;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.reply-item:hover {
  border-color: #10b981;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.15);
}

.reply-item:hover::before {
  opacity: 1;
}

.reply-avatar {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  width: 40px !important;
  height: 40px !important;
  font-size: 1rem !important;
}

.reply-indicator {
  color: #10b981;
  font-size: 0.8rem;
  margin-left: 0.5rem;
  font-weight: 600;
  background: rgba(16, 185, 129, 0.1);
  padding: 2px 8px;
  border-radius: 10px;
}

/* Form Enhancements */
.reply-form, .edit-form {
  margin-top: 1.5rem;
  padding: 1.5rem;
  background: linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 100%);
  border-radius: 15px;
  border: 1px solid #2a2a2a;
}

.reply-textarea, .edit-textarea {
  width: 100%;
  min-height: 100px;
  padding: 15px;
  border: 2px solid #333333;
  border-radius: 12px;
  background-color: #000000;
  color: white;
  font-size: 1rem;
  resize: vertical;
  margin-bottom: 1rem;
  font-family: inherit;
  transition: all 0.3s ease;
}

.reply-textarea:focus, .edit-textarea:focus {
  outline: none;
  border-color: #2bb8dd;
  box-shadow: 0 0 0 3px rgba(43, 184, 221, 0.1);
  background-color: #0a0a0a;
}

.reply-actions, .edit-actions {
  display: flex;
  gap: 1rem;
}

.reply-btn, .save-btn {
  background: linear-gradient(135deg, #2bb8dd 0%, #667eea 100%);
  color: white;
  padding: 12px 24px;
  border: none;
  border-radius: 10px;
  font-size: 0.9rem;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.reply-btn:hover, .save-btn:hover {
  background: linear-gradient(135deg, #2399ba 0%, #5a67d8 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 15px rgba(43, 184, 221, 0.3);
}

.cancel-btn {
  background: transparent;
  color: #9ca3af;
  padding: 12px 24px;
  border: 1px solid #4b5563;
  border-radius: 10px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
}

.cancel-btn:hover {
  background: #374151;
  color: white;
  border-color: #6b7280;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .post-meta {
    gap: 1.5rem;
  }
  
  .articles-wrapper {
    gap: 1.5rem;
  }
  
  .article-card {
    flex: 0 0 300px;
  }
}

@media (max-width: 768px) {
  .single-post-hero {
    padding: 3rem 1.5rem 2rem;
  }
  
  .post-title {
    font-size: 2rem;
  }
  
  .post-meta {
    flex-direction: column;
    gap: 1rem;
  }
  
  .post-content-wrapper {
    padding: 2rem 1.5rem;
  }
  
  .comment-box {
    padding: 2rem 1.5rem;
  }
  
  .comment-form {
    padding: 1.5rem;
  }
  
  .comment-item {
    padding: 1.5rem;
  }
  
  .comment-header {
    flex-direction: column;
    gap: 1rem;
  }
  
  .comment-meta {
    align-self: flex-start;
  }
  
  .replies-container {
    padding: 1rem;
    margin-left: 0.5rem;
  }
  
  .reply-item {
    padding: 1.25rem;
  }
  
  .articles-wrapper {
    gap: 1rem;
  }
  
  .article-card {
    flex: 0 0 280px;
  }
  
  .card-content {
    padding: 1.5rem;
  }
  
  .share-buttons {
    flex-direction: column;
    align-items: center;
  }
  
  .share-btn {
    width: 200px;
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .single-post-hero {
    padding: 2rem 1rem;
  }
  
  .post-title {
    font-size: 1.75rem;
  }
  
  .section-header h2 {
    font-size: 2rem;
  }
  
  .comment-box {
    padding: 1.5rem 1rem;
  }
  
  .comment-form {
    padding: 1rem;
  }
  
  .comment-item {
    padding: 1rem;
  }
  
  .comment-avatar {
    width: 40px;
    height: 40px;
    font-size: 1rem;
  }
  
  .reply-actions, .edit-actions {
    flex-direction: column;
  }
  
  .reply-btn, .save-btn, .cancel-btn {
    width: 100%;
  }
  
  .article-card {
    flex: 0 0 250px;
  }
  
  .carousel-controls {
    gap: 0.5rem;
  }
  
  .carousel-btn {
    width: 40px;
    height: 40px;
    font-size: 1rem;
  }
}

/* Animation for new comments */
.new-comment {
  animation: slideInFromTop 0.5s ease-out;
}

@keyframes slideInFromTop {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Smooth transitions for all interactive elements */
* {
  transition: color 0.3s ease, background-color 0.3s ease, border-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease;
}
/* Enhanced Share Button Styles */
.share-btn.success {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  border-color: #10b981;
  transform: scale(1.05);
}

.share-btn.native {
  background: linear-gradient(135deg, #3fb6e0 0%, #7c3aed 100%);
  color: white;
  border-color: #3fb6e0;
}

.share-btn.native:hover {
  background: linear-gradient(135deg, #3fb6e0 0%, #6d28d9 100%);
  border-color: #7c3aed;
}

.share-stats {
  margin-top: 1.5rem;
  text-align: center;
  padding-top: 1rem;
  border-top: 1px solid #333333;
}

.share-stats p {
  color: #9ca3af;
  font-size: 0.9rem;
  margin: 0;
  font-style: italic;
}

/* Animation for copy success */
.share-btn.copy.success {
  animation: copySuccess 0.3s ease-in-out;
}

@keyframes copySuccess {
  0% { transform: scale(1); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1.05); }
}

/* Responsive share buttons */
@media (max-width: 768px) {
  .share-buttons {
    grid-template-columns: repeat(2, 1fr);
    display: grid;
    gap: 1rem;
  }
  
  .share-btn {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .share-buttons {
    grid-template-columns: 1fr;
  }
}
/* ===== GLOBAL DESIGN SYSTEM ===== */
:root {
  /* Colors */
  --primary-color: #1a73e8;
  --primary-dark: #1557b0;
  --primary-light: #4285f4;
  --secondary-color: #34a853;
  --accent-color: #fbbc04;
  --danger-color: #ea4335;
  --warning-color: #ff9800;
  
  /* Neutrals */
  --white: #ffffff;
  --gray-50: #f8f9fa;
  --gray-100: #f1f3f4;
  --gray-200: #e8eaed;
  --gray-300: #dadce0;
  --gray-400: #bdc1c6;
  --gray-500: #9aa0a6;
  --gray-600: #80868b;
  --gray-700: #5f6368;
  --gray-800: #3c4043;
  --gray-900: #202124;
  
  /* Gradients */
  --gradient-primary: linear-gradient(135deg, #1a73e8 0%, #4285f4 100%);
  --gradient-secondary: linear-gradient(135deg, #34a853 0%, #0f9d58 100%);
  --gradient-hero: linear-gradient(135deg, #1a73e8 0%, #4285f4 50%, #34a853 100%);
  --gradient-card: linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%);
  
  /* Shadows */
  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.1);
  --shadow-md: 0 4px 12px rgba(0, 0, 0, 0.1);
  --shadow-lg: 0 8px 25px rgba(0, 0, 0, 0.15);
  --shadow-xl: 0 20px 40px rgba(0, 0, 0, 0.1);
  
  /* Typography */
  --font-primary: 'Inter', 'Segoe UI', 'Roboto', sans-serif;
  --font-secondary: 'Poppins', 'Inter', sans-serif;
  
  /* Spacing */
  --spacing-xs: 0.25rem;
  --spacing-sm: 0.5rem;
  --spacing-md: 1rem;
  --spacing-lg: 1.5rem;
  --spacing-xl: 2rem;
  --spacing-2xl: 3rem;
  --spacing-3xl: 4rem;
  
  /* Border Radius */
  --radius-sm: 6px;
  --radius-md: 12px;
  --radius-lg: 16px;
  --radius-xl: 24px;
  
  /* Transitions */
  --transition-fast: 0.15s ease-in-out;
  --transition-normal: 0.3s ease-in-out;
  --transition-slow: 0.5s ease-in-out;
}

/* Global Reset */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: var(--font-primary);
  line-height: 1.6;
  color: var(--gray-800);
  background: var(--gray-50);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Typography */
h1, h2, h3, h4, h5, h6 {
  font-family: var(--font-secondary);
  font-weight: 600;
  line-height: 1.3;
  color: var(--gray-900);
  margin-bottom: var(--spacing-md);
}

h1 { font-size: 2.5rem; }
h2 { font-size: 2rem; }
h3 { font-size: 1.5rem; }
h4 { font-size: 1.25rem; }
h5 { font-size: 1.125rem; }
h6 { font-size: 1rem; }

p {
  margin-bottom: var(--spacing-md);
  color: var(--gray-700);
}

/* Buttons */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-sm);
  padding: var(--spacing-md) var(--spacing-xl);
  border: none;
  border-radius: var(--radius-md);
  font-family: var(--font-primary);
  font-weight: 500;
  font-size: 0.95rem;
  text-decoration: none;
  cursor: pointer;
  transition: all var(--transition-normal);
  position: relative;
  overflow: hidden;
}

.btn-primary {
  background: var(--gradient-primary);
  color: var(--white);
  box-shadow: var(--shadow-md);
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

.btn-secondary {
  background: var(--white);
  color: var(--primary-color);
  border: 2px solid var(--primary-color);
}

.btn-secondary:hover {
  background: var(--primary-color);
  color: var(--white);
}

.btn-danger {
  background: var(--danger-color);
  color: var(--white);
}

.btn-success {
  background: var(--secondary-color);
  color: var(--white);
}

/* Cards */
.card {
  background: var(--white);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  padding: var(--spacing-xl);
  transition: all var(--transition-normal);
  border: 1px solid var(--gray-200);
}

.card:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-lg);
}

.card-header {
  margin-bottom: var(--spacing-lg);
  padding-bottom: var(--spacing-lg);
  border-bottom: 2px solid var(--gray-100);
}

.card-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--gray-900);
  margin-bottom: var(--spacing-sm);
}

.card-subtitle {
  color: var(--gray-600);
  font-size: 0.95rem;
}

/* Forms */
.form-group {
  margin-bottom: var(--spacing-lg);
}

.form-label {
  display: block;
  font-weight: 500;
  color: var(--gray-800);
  margin-bottom: var(--spacing-sm);
  font-size: 0.95rem;
}

.form-input,
.form-select,
.form-textarea {
  width: 100%;
  padding: var(--spacing-md);
  border: 2px solid var(--gray-300);
  border-radius: var(--radius-md);
  font-family: var(--font-primary);
  font-size: 0.95rem;
  transition: all var(--transition-normal);
  background: var(--white);
}

.form-input:focus,
.form-select:focus,
.form-textarea:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.1);
}

/* Utilities */
.text-center { text-align: center; }
.text-left { text-align: left; }
.text-right { text-align: right; }

.mb-sm { margin-bottom: var(--spacing-sm); }
.mb-md { margin-bottom: var(--spacing-md); }
.mb-lg { margin-bottom: var(--spacing-lg); }
.mb-xl { margin-bottom: var(--spacing-xl); }

.mt-sm { margin-top: var(--spacing-sm); }
.mt-md { margin-top: var(--spacing-md); }
.mt-lg { margin-top: var(--spacing-lg); }
.mt-xl { margin-top: var(--spacing-xl); }

.p-sm { padding: var(--spacing-sm); }
.p-md { padding: var(--spacing-md); }
.p-lg { padding: var(--spacing-lg); }
.p-xl { padding: var(--spacing-xl); }

/* Animations */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.animate-fade-in-up {
  animation: fadeInUp 0.6s ease-out;
}

.animate-slide-in-right {
  animation: slideInRight 0.6s ease-out;
}

/* Responsive */
@media (max-width: 768px) {
  h1 { font-size: 2rem; }
  h2 { font-size: 1.75rem; }
  h3 { font-size: 1.25rem; }
  
  .btn {
    padding: var(--spacing-sm) var(--spacing-lg);
    font-size: 0.9rem;
  }
  
  .card {
    padding: var(--spacing-lg);
  }
}

/* Loading States */
.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid var(--gray-200);
  border-top: 4px solid var(--primary-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-3xl);
  gap: var(--spacing-lg);
}

.loading-text {
  color: var(--gray-600);
  font-weight: 500;
}
/* FINAL OVERRIDE - Add this at the very end of App.css */
@media screen and (max-width: 768px) {
  .dashboard-container .sidebar {
    display: flex !important;
    visibility: visible !important;
    opacity: 1 !important;
    width: 100% !important;
    height: 70px !important;
    position: relative !important;
    top: 0 !important;
    left: 0 !important;
    transform: none !important;
    background: #2c3e50 !important;
    border-right: none !important;
    border-bottom: 2px solid #5a5a5a !important;
    flex-direction: row !important;
    z-index: 1000 !important;
  }
  
  .dashboard-container .sidebar ul {
    display: flex !important;
    flex-direction: row !important;
    overflow-x: auto !important;
    overflow-y: hidden !important;
    padding: 5px 10px !important;
    margin: 0 !important;
    height: 100% !important;
    align-items: center !important;
    width: 100% !important;
  }
  
  .dashboard-container .sidebar ul li {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
    flex: 0 0 auto !important;
    margin: 0 5px !important;
    padding: 5px 8px !important;
    min-width: 150px !important;
    max-width: 80px !important;
    height: 55px !important;
    text-align: center !important;
    border-radius: 8px !important;
    white-space: nowrap !important;
    font-size: 10px !important;
  }
  
  .dashboard-container .sidebar ul li i {
    font-size: 16px !important;
    margin-bottom: 2px !important;
  }
  
  .dashboard-container .sidebar ul li span {
    font-size: 9px !important;
    line-height: 1 !important;
  }
  
  .dashboard-container .content {
    margin-left: 0 !important;
    width: 100% !important;
    padding: 15px !important;
  }
  .dashboard-container .sidebar .sidebar-header {
    display: none !important;
  }
}
.section-bordered {
  border-top: 2px solid;
  border-bottom: 2px solid;
  border-image: linear-gradient(to right, #2596be, #3b82f6) 1;
  border-left: none;
  border-right: none;
}
.post-editor-quill {
  min-height: 200px;
  margin-bottom: 20px;
}
.footer-logo-img {
  max-width: 35px;
  height: auto;
}

.hero-students-image {
  max-height: 600px;
  object-fit: cover;
  min-height: 400px;
}

.featured-universities-title {
  color: #ffffff;
  text-align: center;
}

.university-card-styled {
  margin: 15px;
  background-color: #1e88e5;
  border-radius: 20px;
  padding: 35px;
  box-shadow: 0 15px 30px rgba(0,0,0,0.08);
  transition: all 0.4s ease;
  cursor: pointer;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border: 1px solid rgba(0,0,0,0.05);
}

.university-card-styled:hover {
  transform: translateY(-5px);
  box-shadow: 0 20px 40px rgba(0,0,0,0.12);
}

.university-icon-centered {
  display: flex;
  justify-content: center;
}

.university-icon-image {
  border-radius: 50%;
  width: 75px;
  object-fit: contain;
  box-shadow: 0 8px 16px rgba(30,136,229,0.2);
}

.university-content-centered {
  text-align: center;
}

.university-card-title {
  color: #2bb8dd;
  font-size: 25px;
  font-weight: 600;
  margin-bottom: 18px;
  letter-spacing: 0.5px;
}

.university-card-description {
  color: #ffffff;
  font-size: 16px;
  line-height: 1.8;
  margin-bottom: 0;
}

.howitworks-title {
  color: #ffffff;
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 18px;
  letter-spacing: 0.5px;
}

.howitworks-description {
  color: #ffffff;
}

.footer-logo-image {
  max-width: 35px;
}
/* Prevent the page from scrolling when popup is open */
body.popup-open {
  overflow: hidden;
}

/* The dark translucent backdrop, full-screen */
.popup-overlay {
  animation: fadeIn 0.3s ease-out;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999; /* Corrected here */
  animation: fadeIn 0.2s ease-out;
}

/* The white "card" in the center */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes scaleIn {
  from { 
    opacity: 0;
    transform: scale(0.95);
  }
  to { 
    opacity: 1;
    transform: scale(1);
  }
}

.popup-content {
  animation: scaleIn 0.3s ease-out;
  position: relative;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  width: 90%; /* shrink on phones */
  max-width: 480px; /* cap on desktop */
  max-height: 90%; /* ensures popup doesn't overflow screen */
  padding: 1.5rem;
  /* Remove forced internal scroll for most popups; handle overflow in .popup-body.
     When .popup-content has .image-only we remove padding and allow image to fill. */
  overflow: visible;
  animation: scaleUp 0.2s ease-out;
  z-index: 10000; /* added extra to ensure it's above everything else */
}

/* Close "×" button */
.popup-close {
  position: absolute;
  top: 12px;
  right: 12px;
  background: none;
  border: none;
  font-size: 1.8rem;
  line-height: 1;
  cursor: pointer;
  color: #444;
  transition: color 0.2s;
}

.popup-close:hover {
  color: #000;
}

/* Responsive media within popup */
.popup-body img,
.popup-body video {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
}

/* When the popup is image-only (we add this class via JS), remove scroll and padding
   so the image fills nicely across screen sizes. */
.popup-content.image-only {
  padding: 0;
}
.popup-content.image-only .popup-body {
  display:flex;
  align-items:center;
  justify-content:center;
  overflow: visible;
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes scaleUp {
  from {
    transform: scale(0.85);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}












/* Student Success Stories Section - Dark Theme */
.student-success-stories {
  padding: 60px 0;
  background-color: #121828; /* matching your navbar background */
  color: #ffffff;
}

/* Section Heading */
.student-success-stories .section-heading h2 {
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 40px;
  color: #fff;
  font-weight: 600;
}

/* Success Story Card */
.success-story-card {
  background: #1e253a; /* slightly lighter than background */
  border-radius: 12px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
  padding: 20px;
  margin: 10px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.success-story-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.4);
}

/* Success Story Image */
.success-story-image {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 auto 15px;
  border: 3px solid #3c7cff; /* Accent color matching theme */
}

.success-story-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Student Name */
.student-name {
  font-size: 1.4rem;
  color: #ffffff;
  text-align: center;
  margin-bottom: 5px;
  font-weight: 600;
}

/* University Name */
.student-university {
  font-size: 1rem;
  color: #a0a8b5;
  text-align: center;
  margin-bottom: 15px;
}

/* Student Testimonial */
.student-testimonial {
  font-size: 0.95rem;
  color: #bfc5cf;
  font-style: italic;
  text-align: center;
}

/* Slider Dots matching your theme */
.slick-dots {
  bottom: -35px;
}

.slick-dots li button {
  background-color: #46516c;
}

.slick-dots li.slick-active button {
  background-color: #3c7cff;
}











/* Meet Our Team Section - Dark Theme */
.meet-our-team {
  padding: 60px 0;
  background-color: #121828;
  color: #ffffff;
}

.meet-our-team .section-heading h2 {
  text-align: center;
  font-size: 2.5rem;
  margin-bottom: 40px;
  font-weight: 600;
}

.meet-our-team .section-intro {
  max-width: 800px;
  margin: 0 auto 50px;
  font-size: 1.1rem;
  color: #bfc5cf;
  text-align: center;
  line-height: 1.6;
}

/* Grid */
.meet-our-team .team-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 20px;
}

.team-member-card {
  background: #1e253a;
  border-radius: 12px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
  padding: 30px 20px;
  text-align: center;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(45% - 20px);
  max-width: calc(45% - 20px);
  /* add a transparent border for the glow */
  border: 2px solid transparent;
  transition:
    border-color 0.3s ease,
    box-shadow 0.3s ease,
    transform 0.3s ease;
}

.team-member-card:hover {
  /* keep the original dark fill */
  background-color: #1e253a;
  /* show a crisp blue outline */
  border-color: white;
  /* add a soft outer glow */
  box-shadow:
    0 6px 12px rgba(0, 0, 0, 0.3),
    0 0 10px rgba(60, 124, 255, 0.8);
  /* slight lift */
  transform: translateY(-6px);
}


/* Avatar */
.team-member-image {
  width: 120px;
  height: 120px;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 auto 20px;
  border: 3px solid #3c7cff;
}
.team-member-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Text */
.team-member-name {
  font-size: 1.6rem;
  color: #ffffff;
  margin-bottom: 8px;
  font-weight: 600;
}
.team-member-role {
  font-size: 1rem;
  color: #a0a8b5;
  margin-bottom: 15px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.team-member-description {
  font-size: 0.95rem;
  color: #bfc5cf;
  line-height: 1.5;
}

/* Dots if using slick */
.meet-our-team .slick-dots {
  bottom: -30px;
}
.meet-our-team .slick-dots li button {
  background-color: #46516c;
}
.meet-our-team .slick-dots li.slick-active button {
  background-color: #3c7cff;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .meet-our-team .team-grid {
    flex-direction: column;
    gap: 30px;
  }
  .team-member-card {
    flex: 1 1 100%;
    max-width: 100%;
  }
}











.team-member-country {
  display: inline-block;
  margin-top: -25px;
  font-size: 0.9rem;
  font-weight: 600;
  padding: 2px 8px;
  border: 1px solid rgba(255,255,255,0.25);
  border-radius: 999px;
  opacity: 0.9;
}

/* Section base */
#ourservices {
  background: var(--section-bg);
    background-color: ffffff;

  padding: 4rem 0;
}

/* Make sure text inside isn’t forced to white by global classes */
#ourservices h1,
#ourservices h2,
#ourservices h3,
#ourservices p,
#ourservices li,
#ourservices .desc {
  color: var(--section-text) !important; 
  
}

/* Card surfaces + their text */
#ourservices .item {
  background: #fff;                /* readable on light bg */
  color: #111;                     /* ensure body text shows */
  border-radius: 12px;
  padding: 20px;
  transition: transform .2s ease, box-shadow .2s ease;
    background-color: fffff;

}

[data-theme="dark"] #ourservices .item {
  background: #161b22;             /* dark card */
  color: #e6edf3;
}

#ourservices .item:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 24px rgba(0,0,0,.12);
}

/* Icon color so it doesn’t inherit white */
#ourservices .item .social-icon i {
  margin-bottom: 12px;
  color: var(--brand-500);
}
.contact-map {
  width: 100%;
  /* Use a responsive height with a sensible min so the map isn't cropped into a thin strip */
  height: 100%;
  min-height: 220px;
  max-height: 720px;
  border-radius: 12px;
  overflow: hidden;
  display: block;
  background: transparent !important;
}
@media (min-width: 768px) {
  .contact-map { height: 320px; }
}
@media (min-width: 992px) {
  .contact-map { min-height: 360px; }
}

/* Ensure inner Google map canvas expands to fill the container */
.contact-map > * { width:100% !important; height:100% !important; display:block; }

/* Force right column containing the map to let the map stretch: make the parent flow adapt */
.right-info { display: flex; flex-direction: column; }
.right-info #contactMap { flex: 1 1 auto; width:100%; height:100%; min-height: 280px; }

/* Make sure small embedded map controls don't show a blank band: allow the map to cover the full box */
.contact-map .gm-style, .contact-map .gm-style > div { width:100% !important; height:100% !important; }




`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":";AACA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA,2CAA2C;AAC3C;EACE,qDAAqD;EACrD,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,4CAA4C;AAC9C;;AAEA,uBAAuB,2BAA2B,EAAE,4CAA4C,EAAE;;;AAGlG;EACE,SAAS;EACT,iCAAiC;AACnC;;;AAGA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;;AAGA;EACE,gBAAgB;AAClB;;;;AAIA,+BAA+B;AAC/B;;;;;;CAMC;;AAED;;;;;;;;;;;;;;;;+CAgB+C;AAC/C;;;;CAIC;AAED;;;;CAIC;AACD;;;;EAIE,SAAS;EACT,UAAU;EACV,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,0BAA0B;EAC1B,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,WAAW;AACb;;AAEA;CACC,WAAW;AACZ;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;;;;CAIC;AACD;;EAEE,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,eAAe;EACf,wBAAwB,EAAE,SAAS;EACnC,qDAAqD,CAAC,6BAA6B;EACnF,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,yBAAyB;EACzB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;EACxB,qCAAqC;AACvC;;;AAGA;EACE,cAAc,EAAE,+BAA+B;EAC/C,qBAAqB,EAAE,sBAAsB;EAC7C,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,cAAc,EAAE,uCAAuC;EACvD,qBAAqB;AACvB;;;AAGA;EACE,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,WAAW;AACb;;;AAGA;;;;CAIC;;AAED;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;GACG,kBAAkB;GAClB,cAAc;AACjB;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,mDAAmD;AACrD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;EAIZ,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EAIX,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAI7B,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,WAAW;EAIX,4BAA4B;EAC5B,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;EAEE,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,4CAA4C;EAC5C,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EAIjB,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,UAAU;EACV,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,WAAW;EACX,WAAW;EACX,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;;;EAME,oBAAoB;EACpB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,OAAO;AACT;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;EAKE,oBAAoB;EACpB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,OAAO;EACP,UAAU;AACZ;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EAIE,0BAA0B;EAC1B,UAAU;EACV,WAAW;AACb;;AAEA;EAIE,uBAAuB;EACvB,SAAS;AACX;;AAEA;;;EAGE,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EAIE,wDAAwD;EACxD,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EAIE,0DAA0D;EAC1D,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,cAAc;EAChB;EACA;;IAEE,wBAAwB;IACxB,UAAU;EACZ;EACA;IACE,WAAW;EACb;EACA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,WAAW;IACX,aAAa;IAIb,0BAA0B;IAC1B,gBAAgB;EAClB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,6BAA6B;IAC7B,4BAA4B;IAC5B,6BAA6B;EAC/B;EACA;IACE,uBAAuB;IACvB,4BAA4B;IAC5B,uBAAuB;IACvB,uBAAuB;IACvB,8BAA8B;IAC9B,yBAAyB;EAC3B;EACA;IACE,2BAA2B;IAC3B,wBAAwB;EAC1B;EACA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,UAAU;IACV,UAAU;IACV,yBAAyB;IACzB,QAAQ;IACR,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,cAAc;IACd,WAAW;IACX,eAAe;IACf,SAAS;EACX;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;;AAGA;;;;CAIC;;AAED;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,qCAAqC;IACrC,MAAM;IACN,OAAO;IACP,SAAS;IACT,QAAQ;IACR,WAAW;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;AAEF;;;AAGA;;;;CAIC;;AAED;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yDAAwE;EACxE,4BAA4B;EAC5B,sBAAsB;EACtB,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;;AAGA;;;;CAIC;;AAED;EACE,0EAA0E;EAC1E,yBAAyB;EACzB,kCAAkC;EAClC,4BAA4B;EAC5B,4BAA4B;EAC5B,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uCAAuC;EACvC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;;;AAIA;;;;CAIC;;AAED;EACE,uEAAuE;EACvE,kCAAkC;EAClC,4BAA4B;EAC5B,4BAA4B;EAC5B,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mCAAmC;EACnC,6BAA6B;AAC/B;AACA;EACE;IACE,aAAa;IACb,iBAAiB;EACnB;AACF;AACA;EACE,YAAY;EACZ,uCAAuC;AACzC;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,oCAAoC;EACpC,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,cAAc;AAChB;;;AAGA;;;;CAIC;AACD;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;AACA;EACE,yDAAoE;EACpE,kCAAkC;EAClC,4BAA4B;EAC5B,4BAA4B;EAC5B,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;;AAGA;;;;CAIC;;AAED;EACE,yDAAiE;EACjE,kCAAkC;EAClC,4BAA4B;EAC5B,4BAA4B;EAC5B,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,qBAAqB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,yDAAsE;EACtE,4BAA4B;EAC5B,kCAAkC;EAClC,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;;AAGA;;;;CAIC;;AAED;EACE,yDAAoE;EACpE,kCAAkC;EAClC,4BAA4B;EAC5B,4BAA4B;EAC5B,sBAAsB;EACtB,0BAA0B;AAC5B;AACA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,6BAA6B;EAC7B,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,WAAW;EACX,gEAAgE;EAChE,4CAA4C;EAC5C,SAAS;EACT,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,qDAAqD,EAAE,2BAA2B;EAClF,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,6CAA6C;EAC7C,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;EAC7C,qDAAqD,EAAE,2BAA2B;AACpF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qDAAqD,EAAE,oBAAoB;EAC3E,mBAAmB,EAAE,qCAAqC;EAC1D,YAAY,EAAE,uBAAuB;AACvC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB,EAAE,yBAAyB;EAC9C,aAAa;AACf;;;AAGA;EACE,qBAAqB;EACrB,+CAA+C;EAC/C,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,4CAA4C;EAC5C,iBAAiB;AACnB;AACA;EACE,+BAA+B;EAC/B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;;AAGA;;;;CAIC;;AAED;EACE,yDAAmE;EACnE,kCAAkC;EAClC,4BAA4B;EAC5B,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;;AAGA;;;;CAIC;;AAED;EACE,yDAAyE;EACzE,kCAAkC;EAClC,4BAA4B;EAC5B,4BAA4B;EAC5B,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,uCAAuC;EACvC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,wBAAwB;AACxB;CACC,UAAU;AACX;;AAEA;CACC;EACC,UAAU;CACX;AACD;;AAEA;CACC;EACC,WAAW;CACZ;AACD;;AAEA;;;;CAIC;;AAED;EACE;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF;;AAEA;;EAEE;IACE,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;;;AAIF;;AAEA;;EAEE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;AAEF;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;AACA;EACE,2BAA2B;IACzB,6BAA6B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;IACX,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,eAAe;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,4BAA4B;IAC1B,mBAAmB;IACnB,+CAA+C;AACnD;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;IACb,cAAc;IACd,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,iBAAiB;;AAEnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,aAAa;AACf;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;AACA,aAAa;AACb,eAAe,kBAAkB,EAAE;AACnC,kBAAkB,wBAAwB,EAAE;AAC5C,kBAAkB,wBAAwB,EAAE,kBAAkB,EAAE;AAChE,kBAAkB,wBAAwB,EAAE;;AAE5C,+BAA+B;AAC/B,eAAe,cAAc,EAAE;AAC/B,0BAA0B,kBAAkB,EAAE;AAC9C,4BAA4B,aAAa,EAAE,iBAAiB,EAAE;;AAE9D,SAAS;AACT;EACE,mBAAmB,EAAE,OAAO,EAAE,WAAW;EACzC,wBAAwB,EAAE,mBAAmB;EAC7C,kDAAkD;EAClD,2EAA2E;AAC7E;AACA;EACE,QAAQ,EAAE,iBAAiB,EAAE,mBAAmB,EAAE,cAAc;EAChE,aAAa,EAAE,eAAe,EAAE,sBAAsB;AACxD;AACA;EACE,UAAU,EAAE,kDAAkD;EAC9D,+DAA+D;AACjE;;AAEA,UAAU;AACV;EACE,oBAAoB,EAAE,wBAAwB,EAAE,kBAAkB;EAClE,YAAY,EAAE,iBAAiB,EAAE,WAAW;EAC5C,2EAA2E;AAC7E;AACA;EACE,iBAAiB,EAAE,QAAQ,EAAE,UAAU;EACvC,+BAA+B,EAAE,aAAa;EAC9C,qCAAqC;EACrC,eAAe,EAAE,mBAAmB,EAAE,cAAc,EAAE,eAAe;AACvE;AACA;EACE,YAAY,EAAE,kBAAkB,EAAE,QAAQ,EAAE,iBAAiB;AAC/D;AACA,cAAc;AACd;EACE,UAAU,EAAE,WAAW,EAAE,kBAAkB,EAAE,YAAY,EAAE,kBAAkB;EAC7E,gCAAgC,EAAE,wBAAwB,EAAE,cAAc;AAC5E;AACA,2CAA2C;AAC3C,2BAA2B,wBAAwB,EAAE,QAAQ,EAAE;;AAE/D,oCAAoC;AACpC,wBAAwB,wBAAwB,EAAE,eAAe,EAAE;;AAEnE,cAAc;AACd;EACE,eAAe,EAAE,cAAc,EAAE,eAAe;EAChD,2CAA2C,EAAE,gBAAgB;EAC7D,aAAa,EAAE,cAAc,EAAE,YAAY,EAAE,OAAO;AACtD;AACA,yBAAyB,aAAa,EAAE;;AAExC,sBAAsB;AACtB;EACE,oBAAoB,EAAE,eAAe,EAAE,iBAAiB;EACxD,aAAa,EAAE,eAAe,EAAE,oBAAoB;AACtD;AACA,6BAA6B,yBAAyB,EAAE;;;AAGxD,8CAA8C;;AAE9C,sBAAsB;AACtB;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,kBAAkB,EAAE,mBAAmB;EACzC;;EAEA;IACE,UAAU;IACV,WAAW,EAAE,wCAAwC;IACrD,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,cAAc,EAAE,wBAAwB;IACxC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,kBAAkB,EAAE,6BAA6B;EACnD;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB,EAAE,oBAAoB;IACzC,QAAQ;EACV;;EAEA;IACE,cAAc,EAAE,gCAAgC;EAClD;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;;AAGA;;;;;;;;;;;;;GAaG;;;AAGH;EACE,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,kBAAkB;EAClB,qDAAqD;EACrD,eAAe;EACf,6DAA6D;EAC7D,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;;AAGA;EACE,4BAA4B;IAC1B,qBAAqB;IACrB,+CAA+C;AACnD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,0EAA0E;EAC1E,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,eAAe;EACf,6DAA6D;EAC7D,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;;AAGA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,qCAAqC;;EAErC,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,eAAe;;AAEjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;;;;AAKA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;MACX,yBAAyB;MACzB,qBAAqB;MACrB,mBAAmB;;EAEvB;EACA;MACI,sBAAsB;MACtB,kBAAkB;EACtB;;EAEA;MACI,cAAc;EAClB;;EAEA;MACI,UAAU;EACd;;EAEA,8BAA8B;EAC9B;IACE,eAAe;EACjB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,iCAAiC;EACnC;EACA;IACE,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;;IAEE,6BAA6B;IAC7B,kCAAkC;EACpC;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE;EACF;EACA;IACE,aAAa;EACf;AACF;;;;AAIA,kBAAkB;AAClB;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,0CAA0C;GACzC,aAAa;EACd,yBAAyB;EACzB,eAAe;AACjB;;;AAGA,qDAAqD;AACrD;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;AACA;;EAEE,WAAW;EACX,cAAc;EACd,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,OAAO;AACT;AACA,yBAAyB,MAAM,EAAE;AACjC,yBAAyB,SAAS,EAAE;;AAEpC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;EACV,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,gDAAgD;AAChD;EACE;IACE,+BAA+B;EACjC;AACF;;AAEA,oCAAoC;AACpC;EACE,iBAAiB,iBAAiB,EAAE;EACpC,iBAAiB,iBAAiB,EAAE;EACpC,iBAAiB,iBAAiB,EAAE;EACpC,+CAA+C;EAC/C,8BAA8B,eAAe,EAAE;AACjD;;AAEA,oCAAoC;AACpC;EACE,kCAAkC;EAClC,SAAS,eAAe,EAAE;;EAE1B,yCAAyC;EACzC;IACE,eAAe;IACf,aAAa;EACf;EACA,iBAAiB,eAAe,EAAE;EAClC,iBAAiB,iBAAiB,EAAE;;EAEpC,kDAAkD;EAClD;IACE,6BAA6B;IAC7B,kBAAkB;IAClB,oBAAoB;EACtB;AACF;;;;;;;AAOA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;;AAGA,mBAAmB;AACnB;;EAEE,qBAAqB,YAAY,uBAAuB;EACxD,uBAAuB,UAAU,gCAAgC;EACjE,uBAAuB,UAAU,eAAe;EAChD,qBAAqB,YAAY,yBAAyB;EAC1D,yBAAyB,QAAQ,eAAe;;EAEhD,oCAAoC;;EAEpC,0BAA0B;EAC1B,qBAAqB;EACrB,0BAA0B;EAC1B,4BAA4B;;EAE5B,wCAAwC;EACxC,2CAA2C;EAC3C,0CAA0C;;;AAG5C;;AAEA,kBAAkB;AAClB;EACE,mCAAmC;EACnC,wBAAwB;EACxB,+BAA+B;EAC/B,SAAS;EACT,UAAU;AACZ;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;EACjB,gGAAgG;EAChG,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,uCAAuC,EAAE,yBAAyB;EAClE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;EACd,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,qBAAqB;EACrB,uDAAuD;AACzD;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,gEAAgE;AAChE;EACE,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,gBAAgB;EAChB,+BAA+B;EAC/B,wBAAwB;EACxB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,WAAW;AACX;EACE,qCAAqC;EACrC,wBAAwB;EACxB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;AACA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,kCAAkC;EAClC,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA,0BAA0B;AAC1B;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB,EAAE,4BAA4B;EACvD,cAAc;EACd,kCAAkC;AACpC;;AAEA,YAAY;AACZ;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,cAAc,EAAE,WAAW;AAC7B;;AAEA,uBAAuB;AACvB;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;;;;AAKA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,uCAAuC;AACzC;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;;;;;;;;;;;;AAaA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;AACd;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;AACvB;;;AAGA,kBAAkB;AAClB;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA,mCAAmC;AACnC;;;;;;;;EAQE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,0CAA0C;EAC1C,YAAY;EACZ,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA,yBAAyB;AACzB;;EAEE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,0CAA0C;EAC1C,2DAA2D;EAC3D,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,0CAA0C;AAC1C;EACE;IACE,kBAAkB;EACpB;AACF;;;;;;;;;;AAUA,eAAe;AACf;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE;IACE,sBAAsB;EACxB;AACF;;;;;;;;;;AAUA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;AACd;;AAEA,wBAAwB;AACxB;;EAEE,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,oDAAoD;AACtD;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,yCAAyC;EACzC,2DAA2D;EAC3D,cAAc;EACd,cAAc,EAAE,wBAAwB;AAC1C;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;;;;;;;;;;;AAYA,sBAAsB;AACtB;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,qBAAqB;EACrB,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,wCAAwC;EACxC,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;;;;;;;;;;;;;;;;;;;AAoBA,6BAA6B;AAC7B;EACE,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;;AAGA,uCAAuC;AACvC;EACE,WAAW;EACX,cAAc;EACd,YAAY;EACZ,kFAAkF;EAClF,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,6BAA6B;EAC7B,uBAAuB;EACvB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB,EAAE,8BAA8B;AAClD;;AAEA;EACE,2BAA2B;AAC7B;;;AAGA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF;AACA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,kBAAkB;EACpB;AACF;;AAEA,uCAAuC;AACvC;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,mCAAmC;AACnC;EACE;;IAEE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;AACF;;;AAGA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;AACF;;;AAGA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,UAAU;IACV,cAAc;EAChB;AACF;;AAEA;EACE;IACE,aAAa;IACb,cAAc;EAChB;AACF;AACA,2CAA2C;AAC3C;EACE;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,wCAAwC;IACxC,sCAAsC;EACxC;;EAEA;IACE,yBAAyB;EAC3B;AACF;;;;;;;;;;;;;;;AAeA;;EAEE,yBAAyB;EACzB,oCAAoC;AACtC;;;AAGA;EACE,sBAAsB;AACxB;;AAEA,oBAAoB;AACpB;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;;EAEE,yBAAyB;AAC3B;;;;;AAKA;;EAEE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA,8BAA8B;AAC9B,+BAA+B;AAC/B,8BAA8B;;AAE9B;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,yBAAyB;EACzB,YAAY;EACZ,eAAe;AACjB;;AAEA,2CAA2C;AAC3C;;EAEE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,2DAA2D;;AAE3D,YAAY;AACZ;EACE;;;;;;IAME,eAAe;EACjB;;EAEA;;;IAGE,eAAe;EACjB;AACF;;AAEA,WAAW;AACX;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;IAGE,oBAAoB;EACtB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,wBAAwB;AACxB;EACE;;;IAGE,WAAW;IACX,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF;;;;;AAKA;EACE,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;;AAGA,mEAAmE;AACnE;;EAEE,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;;;;;;;EAQE,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;;;EAIE,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;EAEE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;EAEE,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;;;EAIE,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,8CAA8C;AAC9C;;EAEE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;EACnB;AACF;AACA,sBAAsB;AACtB;EACE,6DAA6D;EAC7D,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,+DAA+D;EAC/D,mCAAmC;EACnC,6BAA6B;EAC7B,8BAA8B;EAC9B,0CAA0C;EAC1C,2BAA2B;EAC3B,0BAA0B;EAC1B,gCAAgC;EAChC,oCAAoC;EACpC,yDAAyD;EACzD,uBAAuB;AACzB;;AAEA;EACE,+DAA+D;EAC/D,sCAAsC;EACtC,0DAA0D;EAC1D,mCAAmC;EACnC,gCAAgC;AAClC;;;AAGA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,+DAA+D;EAC/D,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;EAC7B,6BAA6B;EAC7B,gCAAgC;EAChC,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,0DAA0D;EAC1D,uBAAuB;EACvB,gCAAgC;AAClC;;;AAGA;EACE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qDAAqD;EACrD,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA,4BAA4B;AAC5B;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,0BAA0B;AAC1B;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,yCAAyC;AACzC;EACE,uBAAuB;AACzB;;AAEA,mCAAmC;AACnC;;;;EAIE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA,sBAAsB;AACtB;EACE,6DAA6D;EAC7D,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,+CAA+C;EAC/C,YAAY;EACZ,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,+CAA+C;EAC/C,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qDAAqD;EACrD,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA,4BAA4B;AAC5B;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,yCAAyC;EACzC,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,+CAA+C;EAC/C,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,0BAA0B;AAC1B;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,yCAAyC;AACzC;EACE,uBAAuB;AACzB;;AAEA,mCAAmC;AACnC;;;;EAIE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,wCAAwC;;AAExC,oDAAoD;AACpD;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,mCAAmC;AACnC;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,+CAA+C;AAC/C;EACE,mBAAmB;EACnB,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA,6CAA6C;AAC7C;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,6FAA6F;EAC7F,oBAAoB;AACtB;;AAEA,0CAA0C;AAC1C;;EAEE,6DAA6D;EAC7D,+CAA+C;AACjD;;AAEA;;EAEE,6DAA6D;EAC7D,+CAA+C;AACjD;;AAEA,6CAA6C;AAC7C;;;EAGE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,gCAAgC;AAChC;;EAEE,6DAA6D;EAC7D,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,+BAA+B;AAC/B;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,uCAAuC;AACvC;EACE,yCAAyC;AAC3C;;AAEA;EACE,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,iFAAiF;AACnF;;AAEA,sCAAsC;AACtC;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE;IACE,yCAAyC;EAC3C;EACA;IACE,+CAA+C;EACjD;EACA;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,wCAAwC;;;;AAIxC,kDAAkD;AAClD;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,6DAA6D;EAC/D;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA,gCAAgC;AAChC;EACE;;;IAGE,4BAA4B;IAC5B,uBAAuB;IACvB,iCAAiC;EACnC;;EAEA;IACE,aAAa;EACf;AACF;AACA,2CAA2C;;AAE3C,0CAA0C;AAC1C;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,oDAAoD;EACpD,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,8CAA8C;EAC9C,yBAAyB;EACzB,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,YAAY;EACZ,6DAA6D;EAC7D,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,8CAA8C;AAC9C;EACE,cAAc;EACd,gBAAgB;EAChB,4BAA4B,EAAE,wBAAwB;EACtD,SAAS;EACT,qBAAqB;EACrB,gBAAgB;AAClB;;;AAGA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,aAAa;EACb,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mCAAmC;AACrC;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,6DAA6D;EAC7D,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,+BAA+B;AAC/B;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,uCAAuC;AACzC;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;AACA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,6DAA6D;AAC/D;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;AACA;EACE,cAAc;EACd,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,kBAAkB;EAClB,8BAA8B;EAC9B,yFAAyF;EACzF,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,YAAY;EACZ,6DAA6D;EAC7D,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,wEAAwE;EACxE,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;;;;EAIE,eAAe,EAAE,0BAA0B;AAC7C;;AAEA;EACE,eAAe,EAAE,cAAc;AACjC;;AAEA,iCAAiC;AACjC;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB,EAAE,0BAA0B;EAC9C,SAAS;AACX;;AAEA;EACE,iBAAiB,EAAE,2BAA2B;EAC9C,cAAc;EACd,SAAS;AACX;;AAEA,oCAAoC;AACpC;EACE,iBAAiB,EAAE,2BAA2B;AAChD;;AAEA,0BAA0B;AAC1B;EACE,iBAAiB,EAAE,2BAA2B;EAC9C,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE;IACE,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;AACA,6BAA6B;AAC7B;EACE,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,uBAAuB;EACvB,0EAA0E;EAC1E,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,0FAA0F;EAC1F,oBAAoB;AACtB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,6FAA6F;EAC7F,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,6DAA6D;AAC/D;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;;;;EAME,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mCAAmC;AACrC;;AAEA,4BAA4B;AAC5B;EACE,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,YAAY;EACZ,6DAA6D;EAC7D,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,6DAA6D;AAC/D;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,6DAA6D;EAC7D,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+FAA+F;EAC/F,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,qBAAqB;EACrB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,6DAA6D;EAC7D,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,6DAA6D;EAC7D,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,+BAA+B;AAC/B;EACE,6DAA6D;EAC7D,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,6DAA6D;EAC7D,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,eAAe;EACf,yFAAyF;EACzF,8BAA8B;EAC9B,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,UAAU;EACV,YAAY;EACZ,6DAA6D;AAC/D;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,mCAAmC;EACnC,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,YAAY;EACZ,6DAA6D;EAC7D,0BAA0B;EAC1B,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wEAAwE;EACxE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,eAAe;EACf,6DAA6D;EAC7D,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA,+BAA+B;AAC/B;EACE,uCAAuC;AACzC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,oDAAoD;AACpD;EACE,0HAA0H;AAC5H;AACA,iCAAiC;AACjC;EACE,6DAA6D;EAC7D,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;EACT,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;EACE,uCAAuC;AACzC;;AAEA;EACE,KAAK,mBAAmB,EAAE;EAC1B,MAAM,qBAAqB,EAAE;EAC7B,OAAO,sBAAsB,EAAE;AACjC;;AAEA,6BAA6B;AAC7B;EACE;IACE,qCAAqC;IACrC,aAAa;IACb,SAAS;EACX;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA,qCAAqC;AACrC;EACE,WAAW;EACX,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;;EAExB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;;EAEnB,cAAc;EACd,qEAAqE;EACrE,uEAAuE;EACvE,+EAA+E;EAC/E,kEAAkE;;EAElE,YAAY;EACZ,yCAAyC;EACzC,0CAA0C;EAC1C,2CAA2C;EAC3C,2CAA2C;;EAE3C,eAAe;EACf,yDAAyD;EACzD,gDAAgD;;EAEhD,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;;EAEnB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;;EAEjB,gBAAgB;EAChB,oCAAoC;EACpC,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA,iBAAiB;AACjB;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;EAC1B,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA,eAAe;AACf;EACE,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA,KAAK,iBAAiB,EAAE;AACxB,KAAK,eAAe,EAAE;AACtB,KAAK,iBAAiB,EAAE;AACxB,KAAK,kBAAkB,EAAE;AACzB,KAAK,mBAAmB,EAAE;AAC1B,KAAK,eAAe,EAAE;;AAEtB;EACE,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA,YAAY;AACZ;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,4CAA4C;EAC5C,YAAY;EACZ,+BAA+B;EAC/B,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,4BAA4B;EAC5B,0BAA0B;EAC1B,wCAAwC;EACxC,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,UAAU;AACV;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;;;EAGE,WAAW;EACX,0BAA0B;EAC1B,iCAAiC;EACjC,+BAA+B;EAC/B,gCAAgC;EAChC,kBAAkB;EAClB,wCAAwC;EACxC,wBAAwB;AAC1B;;AAEA;;;EAGE,aAAa;EACb,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA,cAAc;AACd,eAAe,kBAAkB,EAAE;AACnC,aAAa,gBAAgB,EAAE;AAC/B,cAAc,iBAAiB,EAAE;;AAEjC,SAAS,gCAAgC,EAAE;AAC3C,SAAS,gCAAgC,EAAE;AAC3C,SAAS,gCAAgC,EAAE;AAC3C,SAAS,gCAAgC,EAAE;;AAE3C,SAAS,6BAA6B,EAAE;AACxC,SAAS,6BAA6B,EAAE;AACxC,SAAS,6BAA6B,EAAE;AACxC,SAAS,6BAA6B,EAAE;;AAExC,QAAQ,0BAA0B,EAAE;AACpC,QAAQ,0BAA0B,EAAE;AACpC,QAAQ,0BAA0B,EAAE;AACpC,QAAQ,0BAA0B,EAAE;;AAEpC,eAAe;AACf;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,eAAe;AACf;EACE,KAAK,eAAe,EAAE;EACtB,KAAK,kBAAkB,EAAE;EACzB,KAAK,kBAAkB,EAAE;;EAEzB;IACE,4CAA4C;IAC5C,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,0CAA0C;EAC1C,kBAAkB;EAClB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;AACA,yDAAyD;AACzD;EACE;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,qBAAqB;IACrB,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;IAC7B,iBAAiB;IACjB,kBAAkB;IAClB,0BAA0B;IAC1B,8BAA8B;IAC9B,6BAA6B;IAC7B,2CAA2C;IAC3C,8BAA8B;IAC9B,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;IACxB,8BAA8B;IAC9B,2BAA2B;IAC3B,6BAA6B;IAC7B,4BAA4B;IAC5B,oBAAoB;IACpB,uBAAuB;IACvB,8BAA8B;IAC9B,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;IACxB,iCAAiC;IACjC,8BAA8B;IAC9B,kCAAkC;IAClC,yBAAyB;IACzB,wBAAwB;IACxB,2BAA2B;IAC3B,2BAA2B;IAC3B,0BAA0B;IAC1B,uBAAuB;IACvB,6BAA6B;IAC7B,6BAA6B;IAC7B,8BAA8B;IAC9B,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;IACzB,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;AACF;AACA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,2DAA2D;EAC3D,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;AACA,uDAAuD;AACvD;EACE,gBAAgB;AAClB;;AAEA,+CAA+C;AAC/C;EACE,+BAA+B;EAC/B,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa,EAAE,mBAAmB;EAClC,+BAA+B;AACjC;;AAEA,mCAAmC;AACnC;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,UAAU,EAAE,qBAAqB;EACjC,gBAAgB,EAAE,mBAAmB;EACrC,eAAe,EAAE,0CAA0C;EAC3D,eAAe;EACf;qFACmF;EACnF,iBAAiB;EACjB,gCAAgC;EAChC,cAAc,EAAE,qDAAqD;AACvE;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA,kCAAkC;AAClC;;EAEE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;mDACmD;AACnD;EACE,UAAU;AACZ;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;;;;;;;;;;;;AAaA,iDAAiD;AACjD;EACE,eAAe;EACf,yBAAyB,EAAE,oCAAoC;EAC/D,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB,EAAE,qCAAqC;EAC1D,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,YAAY;EACZ,qDAAqD;AACvD;;AAEA;EACE,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA,wBAAwB;AACxB;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB,EAAE,gCAAgC;AAC7D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;;;;;;;;;;;AAYA,uCAAuC;AACvC;EACE,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,kBAAkB;EAClB,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B;EAC1B,2BAA2B;EAC3B,0CAA0C;EAC1C,6BAA6B;EAC7B;;;uBAGqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;EACnB,0BAA0B;EAC1B;;oCAEkC;EAClC,gBAAgB;EAChB,2BAA2B;AAC7B;;;AAGA,WAAW;AACX;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,SAAS;AACT;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,aAAa;AACf;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,cAAc;IACd,eAAe;EACjB;AACF;;;;;;;;;;;;AAYA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,wCAAwC;EACxC,oBAAoB;EACpB,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,6BAA6B;IAC3B,wBAAwB;;EAE1B,eAAe;AACjB;;AAEA,kEAAkE;AAClE;;;;;;EAME,qCAAqC;;AAEvC;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB,iBAAiB,yBAAyB;EAC1D,WAAW,sBAAsB,2BAA2B;EAC5D,mBAAmB;EACnB,aAAa;EACb,mDAAmD;IACjD,uBAAuB;;AAE3B;;AAEA;EACE,mBAAmB,cAAc,cAAc;EAC/C,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA,2CAA2C;AAC3C;EACE,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,2FAA2F;EAC3F,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;AACA;EACE,eAAe,aAAa,EAAE;AAChC;AACA;EACE,eAAe,iBAAiB,EAAE;AACpC;;AAEA,iEAAiE;AACjE,mBAAmB,qBAAqB,EAAE,sBAAsB,EAAE,aAAa,EAAE;;AAEjF,6FAA6F;AAC7F,cAAc,aAAa,EAAE,sBAAsB,EAAE;AACrD,0BAA0B,cAAc,EAAE,UAAU,EAAE,WAAW,EAAE,iBAAiB,EAAE;;AAEtF,uGAAuG;AACvG,uDAAuD,qBAAqB,EAAE,sBAAsB,EAAE","sourcesContent":["\n.app-container {\n  font-family: Arial, sans-serif;\n  background-color: #fff;\n}\n\n/* Dashboard CTA shown to logged-in users */\n.dashboard-btn {\n  background: linear-gradient(135deg, #06b6d4, #3c82ff);\n  color: #fff;\n  padding: 12px 28px;\n  border-radius: 22px;\n  border: none;\n  font-weight: 600;\n  cursor: pointer;\n  box-shadow: 0 6px 18px rgba(60,124,255,0.16);\n}\n\n.dashboard-btn:hover { transform: translateY(-2px); box-shadow: 0 8px 22px rgba(60,124,255,0.22); }\n\n\nbody {\n  margin: 0;\n  font-family: 'Roboto', sans-serif;\n}\n\n\na.active {\n  color: #007bff;\n}\n\n.featured-universities {\n  padding: 40px 20px;\n  background-color: #f9f9f9; \n  text-align: center;\n}\n\n.featured-universities h2 {\n  font-size: 36px;\n  font-weight: 700;\n  color: #333;\n  margin-bottom: 30px;\n}\n\n\n.featured-universities .university-slider {\n  margin-top: 20px;\n}\n\n\n\n/* Templatemo-edu-meeting.css */\n/*\n\nTemplateMo 569 Edu Meeting\n\nhttps://templatemo.com/tm-569-edu-meeting\n\n*/\n\n/* ---------------------------------------------\nTable of contents\n------------------------------------------------\n01. font & reset css\n02. reset\n03. global styles\n04. header\n05. banner\n06. features\n07. testimonials\n08. contact\n09. footer\n10. preloader\n11. search\n12. portfolio\n\n--------------------------------------------- */\n/* \n---------------------------------------------\nfont & reset css\n--------------------------------------------- \n*/\n@import url(\"https://fonts.googleapis.com/css?family=Poppins:100,200,300,400,500,600,700,800,900\");\n/* \n---------------------------------------------\nreset\n--------------------------------------------- \n*/\nhtml, body, div, span, applet, object, iframe, h1, h2, h3, h4, h5, h6, p, blockquote, div\npre, a, abbr, acronym, address, big, cite, code, del, dfn, em, font, img, ins, kbd, q,\ns, samp, small, strike, strong, sub, sup, tt, var, b, u, i, center, dl, dt, dd, ol, ul, li,\nfigure, header, nav, section, article, aside, footer, figcaption {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  outline: 0;\n}\n\n.clearfix:after {\n  content: \".\";\n  display: block;\n  clear: both;\n  visibility: hidden;\n  line-height: 0;\n  height: 0;\n}\n\n.clearfix {\n  display: inline-block;\n}\n\nhtml[xmlns] .clearfix {\n  display: block;\n}\n\n* html .clearfix {\n  height: 1%;\n}\n\nul, li {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n\nheader, nav, section, article, aside, footer, hgroup {\n  display: block;\n}\n\n* {\n  box-sizing: border-box;\n}\n\nhtml, body {\n  font-family: 'Poppins', sans-serif;\n  font-weight: 400;\n  background-color: #fff;\n  font-size: 14px;\n  -ms-text-size-adjust: 100%;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\na {\n  text-decoration: none !important;\n  color: #3CF;\n}\n\na:hover {\n\tcolor: #FC3;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  margin-top: 0px;\n  margin-bottom: 0px;\n}\n\nul {\n  margin-bottom: 0px;\n}\n\np {\n  font-size: 14px;\n  line-height: 25px;\n  color: #2a2a2a;\n}\n\nimg {\n  width: 100%;\n  overflow: hidden;\n}\n\n/* \n---------------------------------------------\nglobal styles\n--------------------------------------------- \n*/\nhtml,\nbody {\n  background: #fff;\n  font-family: 'Poppins', sans-serif;\n}\n\n::selection {\n  background: #f5a425;\n  color: #fff;\n}\n\n::-moz-selection {\n  background: #f5a425;\n  color: #fff;\n}\n\n@media (max-width: 991px) {\n  html, body {\n    overflow-x: hidden;\n  }\n  .mobile-top-fix {\n    margin-top: 30px;\n    margin-bottom: 0px;\n  }\n  .mobile-bottom-fix {\n    margin-bottom: 30px;\n  }\n  .mobile-bottom-fix-big {\n    margin-bottom: 60px;\n  }\n}\n\n.main-button-red a {\n  font-size: 13px;\n  color: var(--text-color); /* #fff */\n  background: linear-gradient(135deg, #2563eb, #3b82f6);/* dashboard-style gradient */\n  padding: 12px 30px;\n  display: inline-block;\n  border-radius: 22px;\n  font-weight: 500;\n  font-family: var(--font-family);\n  transition: all 0.3s ease;\n  text-decoration: none;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n.main-button-red a:hover {\n  background-color: var(--text-color);\n  color: var(--primary-bg);\n  border: 1px solid var(--accent-color);\n}\n\n\n.read-more-button a {\n  color: #2596be; /* or use var(--accent-color) */\n  text-decoration: none; /* removes underline */\n  font-weight: 500;\n  font-size: 1rem;\n  padding: 0;\n  background: transparent;\n}\n\n.read-more-button a:hover {\n  color: #1e88e5; /* optional: slightly darker on hover */\n  text-decoration: none;\n}\n\n\n.main-button-yellow a {\n  font-size: 13px;\n  color: #fff;\n  background-color: #ffffff;\n  padding: 12px 30px;\n  display: inline-block;\n  border-radius: 22px;\n  font-weight: 500;\n  text-transform: uppercase;\n  transition: all .3s;\n}\n\n.main-button-yellow a:hover {\n  opacity: 0.9;\n  background-color: #ffffff;\n}\n\n.section-heading h2 {\n  line-height: 40px;\n  margin-top: 0px;\n  margin-bottom: 50px; \n  padding-bottom: 20px;\n  border-bottom: 1px solid rgba(250,250,250,0.15);\n  font-size: 32px;\n  font-weight: 700;\n  /* text-transform: uppercase; */\n  text-align: center;\n  color: #fff;\n}\n\n\n/* \n---------------------------------------------\nheader\n--------------------------------------------- \n*/\n\n.sub-header {\n  background-color: #1f272b;\n  position: relative;\n  z-index: 1111;\n}\n\n.sub-header .left-content p {\n  color: #fff;\n  padding: 8px 0px;\n  font-size: 13px;\n}\n\n.sub-header .right-icons {\n  text-align: right;\n  padding: 8px 0px;\n}\n\n.sub-header .right-icons ul li {\n  display: inline-block;\n  margin-left: 15px;\n}\n\n.sub-header .right-icons ul li a {\n  color: #fff;\n  font-size: 14px;\n  transition: all .3s;\n}\n\n.sub-header .right-icons ul li a:hover {\n  color: #f5a425;\n}\n\n.sub-header .left-content p em {\n   font-style: normal;\n   color: #f5a425;\n}\n\n.background-header {\n  background-color: #fff!important;\n  height: 80px!important;\n  position: fixed!important;\n  top: 0!important;\n  left: 0;\n  right: 0;\n  box-shadow: 0px 0px 10px rgba(0,0,0,0.15)!important;\n}\n\n.background-header .main-nav .nav li a {\n  color: #1e1e1e!important;\n}\n\n.background-header .logo,\n.background-header .main-nav .nav li a {\n  color: #1e1e1e!important;\n}\n\n.background-header .main-nav .nav li:hover a {\n  color: #fb5849!important;\n}\n\n.background-header .nav li a.active {\n  color: #fb5849!important;\n}\n\n.header-area {\n  background-color: rgba(250,250,250,0.15);\n  position: absolute;\n  top: 40px;\n  left: 0;\n  right: 0;\n  z-index: 100;\n  -webkit-transition: all .5s ease 0s;\n  -moz-transition: all .5s ease 0s;\n  -o-transition: all .5s ease 0s;\n  transition: all .5s ease 0s;\n}\n\n.header-area .main-nav {\n  min-height: 80px;\n  background: transparent;\n}\n\n.header-area .main-nav .logo {\n  line-height: 100px;\n  color: #fff;\n  font-size: 28px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  float: left;\n  -webkit-transition: all 0.3s ease 0s;\n  -moz-transition: all 0.3s ease 0s;\n  -o-transition: all 0.3s ease 0s;\n  transition: all 0.3s ease 0s;\n}\n\n.background-header .main-nav .logo {\n  line-height: 75px;\n}\n\n.background-header .nav {\n  margin-top: 20px !important;\n}\n\n.header-area .main-nav .nav {\n  float: right;\n  margin-top: 30px;\n  margin-right: 0px;\n  background-color: transparent;\n  -webkit-transition: all 0.3s ease 0s;\n  -moz-transition: all 0.3s ease 0s;\n  -o-transition: all 0.3s ease 0s;\n  transition: all 0.3s ease 0s;\n  position: relative;\n  z-index: 999;\n}\n\n.header-area .main-nav .nav li {\n  padding-left: 15px;\n  padding-right: 15px;\n}\n\n.header-area .main-nav .nav li:last-child {\n  padding-right: 0px;\n}\n\n.header-area .main-nav .nav li a {\n  display: block;\n  font-weight: 500;\n  font-size: 14px;\n  text-transform: uppercase;\n  color: #fff;\n  -webkit-transition: all 0.3s ease 0s;\n  -moz-transition: all 0.3s ease 0s;\n  -o-transition: all 0.3s ease 0s;\n  transition: all 0.3s ease 0s;\n  height: 40px;\n  line-height: 40px;\n  border: transparent;\n  letter-spacing: 1px;\n}\n\n.header-area .main-nav .nav li:hover a,\n.header-area .main-nav .nav li a.active {\n  color: #f5a425!important;\n}\n\n.background-header .main-nav .nav li:hover a,\n.background-header .main-nav .nav li a.active {\n  color: #f5a425!important;\n  opacity: 1;\n}\n\n.header-area .main-nav .nav li.has-sub {\n  position: relative;\n  padding-right: 15px;\n}\n\n.header-area .main-nav .nav li.has-sub:after {\n  font-family: FontAwesome;\n  content: \"\\f107\";\n  font-size: 12px;\n  color: #fff;\n  position: absolute;\n  right: 5px;\n  top: 12px;\n}\n\n.background-header .main-nav .nav li.has-sub:after {\n  color: #1e1e1e;\n}\n\n.header-area .main-nav .nav li.has-sub ul.sub-menu {\n  position: absolute;\n  width: 200px;\n  box-shadow: 0 2px 28px 0 rgba(0, 0, 0, 0.06);\n  overflow: hidden;\n  top: 40px;\n  opacity: 0;\n  transition: all .3s;\n  transform: translateY(+2em);\n  visibility: hidden;\n  z-index: -1;\n}\n\n.header-area .main-nav .nav li.has-sub ul.sub-menu li {\n  margin-left: 0px;\n  padding-left: 0px;\n  padding-right: 0px;\n}\n\n.header-area .main-nav .nav li.has-sub ul.sub-menu li a {\n  opacity: 1;\n  display: block;\n  background: #f7f7f7;\n  color: #2a2a2a!important;\n  padding-left: 20px;\n  height: 40px;\n  line-height: 40px;\n  -webkit-transition: all 0.3s ease 0s;\n  -moz-transition: all 0.3s ease 0s;\n  -o-transition: all 0.3s ease 0s;\n  transition: all 0.3s ease 0s;\n  position: relative;\n  font-size: 13px;\n  font-weight: 400;\n  border-bottom: 1px solid #eee;\n}\n\n.header-area .main-nav .nav li.has-sub ul li a:hover {\n  background: #fff;\n  color: #f5a425!important;\n  padding-left: 25px;\n}\n\n.header-area .main-nav .nav li.has-sub ul li a:hover:before {\n  width: 3px;\n}\n\n.header-area .main-nav .nav li.has-sub:hover ul.sub-menu {\n  visibility: visible;\n  opacity: 1;\n  z-index: 1;\n  transform: translateY(0%);\n  transition-delay: 0s, 0s, 0.3s;\n}\n\n.header-area .main-nav .menu-trigger {\n  cursor: pointer;\n  display: block;\n  position: absolute;\n  top: 33px;\n  width: 32px;\n  height: 40px;\n  text-indent: -9999em;\n  z-index: 99;\n  right: 40px;\n  display: none;\n}\n\n.background-header .main-nav .menu-trigger {\n  top: 23px;\n}\n\n.header-area .main-nav .menu-trigger span,\n.header-area .main-nav .menu-trigger span:before,\n.header-area .main-nav .menu-trigger span:after {\n  -moz-transition: all 0.4s;\n  -o-transition: all 0.4s;\n  -webkit-transition: all 0.4s;\n  transition: all 0.4s;\n  background-color: #1e1e1e;\n  display: block;\n  position: absolute;\n  width: 30px;\n  height: 2px;\n  left: 0;\n}\n\n.background-header .main-nav .menu-trigger span,\n.background-header .main-nav .menu-trigger span:before,\n.background-header .main-nav .menu-trigger span:after {\n  background-color: #1e1e1e;\n}\n\n.header-area .main-nav .menu-trigger span:before,\n.header-area .main-nav .menu-trigger span:after {\n  -moz-transition: all 0.4s;\n  -o-transition: all 0.4s;\n  -webkit-transition: all 0.4s;\n  transition: all 0.4s;\n  background-color: #1e1e1e;\n  display: block;\n  position: absolute;\n  width: 30px;\n  height: 2px;\n  left: 0;\n  width: 75%;\n}\n\n.background-header .main-nav .menu-trigger span:before,\n.background-header .main-nav .menu-trigger span:after {\n  background-color: #1e1e1e;\n}\n\n.header-area .main-nav .menu-trigger span:before,\n.header-area .main-nav .menu-trigger span:after {\n  content: \"\";\n}\n\n.header-area .main-nav .menu-trigger span {\n  top: 16px;\n}\n\n.header-area .main-nav .menu-trigger span:before {\n  -moz-transform-origin: 33% 100%;\n  -ms-transform-origin: 33% 100%;\n  -webkit-transform-origin: 33% 100%;\n  transform-origin: 33% 100%;\n  top: -10px;\n  z-index: 10;\n}\n\n.header-area .main-nav .menu-trigger span:after {\n  -moz-transform-origin: 33% 0;\n  -ms-transform-origin: 33% 0;\n  -webkit-transform-origin: 33% 0;\n  transform-origin: 33% 0;\n  top: 10px;\n}\n\n.header-area .main-nav .menu-trigger.active span,\n.header-area .main-nav .menu-trigger.active span:before,\n.header-area .main-nav .menu-trigger.active span:after {\n  background-color: transparent;\n  width: 100%;\n}\n\n.header-area .main-nav .menu-trigger.active span:before {\n  -moz-transform: translateY(6px) translateX(1px) rotate(45deg);\n  -ms-transform: translateY(6px) translateX(1px) rotate(45deg);\n  -webkit-transform: translateY(6px) translateX(1px) rotate(45deg);\n  transform: translateY(6px) translateX(1px) rotate(45deg);\n  background-color: #1e1e1e;\n}\n\n.background-header .main-nav .menu-trigger.active span:before {\n  background-color: #1e1e1e;\n}\n\n.header-area .main-nav .menu-trigger.active span:after {\n  -moz-transform: translateY(-6px) translateX(1px) rotate(-45deg);\n  -ms-transform: translateY(-6px) translateX(1px) rotate(-45deg);\n  -webkit-transform: translateY(-6px) translateX(1px) rotate(-45deg);\n  transform: translateY(-6px) translateX(1px) rotate(-45deg);\n  background-color: #1e1e1e;\n}\n\n.background-header .main-nav .menu-trigger.active span:after {\n  background-color: #1e1e1e;\n}\n\n.header-area.header-sticky {\n  min-height: 80px;\n}\n\n.header-area .nav {\n  margin-top: 30px;\n}\n\n.header-area.header-sticky .nav li a.active {\n  color: #f5a425;\n}\n\n@media (max-width: 1200px) {\n  .header-area .main-nav .nav li {\n    padding-left: 7px;\n    padding-right: 7px;\n  }\n  .header-area .main-nav:before {\n    display: none;\n  }\n}\n\n@media (max-width: 767px) {\n  .header-area .main-nav .logo {\n    color: #1e1e1e;\n  }\n  .header-area.header-sticky .nav li a:hover,\n  .header-area.header-sticky .nav li a.active {\n    color: #f5a425!important;\n    opacity: 1;\n  }\n  .header-area.header-sticky .nav li.search-icon a {\n    width: 100%;\n  }\n  .header-area {\n    background-color: #f7f7f7;\n    padding: 0px 15px;\n    height: 100px;\n    box-shadow: none;\n    text-align: center;\n  }\n  .header-area .container {\n    padding: 0px;\n  }\n  .header-area .logo {\n    margin-left: 30px;\n  }\n  .header-area .menu-trigger {\n    display: block !important;\n  }\n  .header-area .main-nav {\n    overflow: hidden;\n  }\n  .header-area .main-nav .nav {\n    float: none;\n    width: 100%;\n    display: none;\n    -webkit-transition: all 0s ease 0s;\n    -moz-transition: all 0s ease 0s;\n    -o-transition: all 0s ease 0s;\n    transition: all 0s ease 0s;\n    margin-left: 0px;\n  }\n  .header-area .main-nav .nav li:first-child {\n    border-top: 1px solid #eee;\n  }\n  .header-area.header-sticky .nav {\n    margin-top: 100px !important;\n  }\n  .header-area .main-nav .nav li {\n    width: 100%;\n    background: #fff;\n    border-bottom: 1px solid #eee;\n    padding-left: 0px !important;\n    padding-right: 0px !important;\n  }\n  .header-area .main-nav .nav li a {\n    height: 50px !important;\n    line-height: 50px !important;\n    padding: 0px !important;\n    border: none !important;\n    background: #f7f7f7 !important;\n    color: #191a20 !important;\n  }\n  .header-area .main-nav .nav li a:hover {\n    background: #eee !important;\n    color: #f5a425!important;\n  }\n  .header-area .main-nav .nav li.has-sub ul.sub-menu {\n    position: relative;\n    visibility: inherit;\n    opacity: 1;\n    z-index: 1;\n    transform: translateY(0%);\n    top: 0px;\n    width: 100%;\n    box-shadow: none;\n    height: 0px;\n    transition: all 0s;\n  }\n  .header-area .main-nav .nav li.submenu ul li a {\n    font-size: 12px;\n    font-weight: 400;\n  }\n  .header-area .main-nav .nav li.submenu ul li a:hover:before {\n    width: 0px;\n  }\n  .header-area .main-nav .nav li.has-sub ul.sub-menu {\n    height: auto;\n  }\n  .header-area .main-nav .nav li.has-sub:after {\n    color: #3B566E;\n    right: 30px;\n    font-size: 14px;\n    top: 15px;\n  }\n  .header-area .main-nav .nav li.submenu:hover ul, .header-area .main-nav .nav li.submenu:focus ul {\n    height: 0px;\n  }\n}\n\n@media (min-width: 767px) {\n  .header-area .main-nav .nav {\n    display: flex !important;\n  }\n}\n\n\n/* \n---------------------------------------------\nbanner\n--------------------------------------------- \n*/\n\n.main-banner {\n  position: relative;\n  max-height: 100%;\n  overflow: hidden;\n  margin-bottom: -7px;\n}\n\n#bg-video {\n    min-width: 100%;\n    min-height: 100vh;\n    max-width: 100%;\n    max-height: 100vh;\n    object-fit: cover;\n    z-index: -1;\n}\n\n#bg-video::-webkit-media-controls {\n    display: none !important;\n}\n\n.video-overlay {\n    position: absolute;\n    background-color: rgba(31,39,43,0.75);\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    width: 100%;\n}\n\n.main-banner .caption {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.main-banner .caption h6 {\n  margin-top: 0px;\n  font-size: 18px;\n  /* text-transform: uppercase; */\n  font-weight: 600;\n  color: #fff;\n  letter-spacing: 1px;\n}\n\n.main-banner .caption h1 {\n  margin-top: 20px;\n  margin-bottom: 20px;\n  font-size: 50px;\n  /* text-transform: uppercase; */\n  font-weight: 600;\n  color: #fff;\n  letter-spacing: 1px;\n}\n\n.main-banner .caption h1 em {\n  font-style: normal;\n  color: #f5a425;\n  font-weight: 900;\n}\n\n.main-banner .caption p {\n  color: #fff;\n  font-size: 16px;\n  max-width: 570px;\n}\n\n.main-banner .caption .main-button-red {\n  margin-top: 30px;\n}\n\n@media screen and (max-width: 767px) {\n\n  .main-banner .caption h6 {\n    font-weight: 500;\n  }\n\n  .main-banner .caption h1 {\n    font-size: 36px;\n  }\n\n}\n\n\n/*\n---------------------------------------------\nservices\n---------------------------------------------\n*/\n\n.services {\n  margin-top: -135px;\n  position: absolute;\n  width: 100%;\n}\n\n.services .item {\n  background-image: url(../public/assets/images/webp/service-item-bg.webp);\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center center;\n  border-radius: 20px;\n  text-align: center;\n  color: #fff;\n  padding: 40px;\n}\n\n.services .item .icon {\n  max-width: 60px;\n  margin: 0 auto;\n}\n\n.services .item h4 {\n  margin-top: 25px;\n  margin-bottom: 15px;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.services .item p {\n  color: #fff;\n  font-size: 13px;\n}\n\n.services .owl-nav {\n  display: inline-block !important;\n  text-align: center;\n  position: absolute;\n  width: 100%;\n  top: 50%;\n  transform: translateY(-25px);\n}\n    \n.services .owl-nav .owl-prev{\n  margin-right: 10px;\n  outline: none;\n  position: absolute;\n  left: -80px;\n}\n\n.services .owl-nav .owl-prev span,\n.services .owl-nav .owl-next span {\n  opacity: 0;\n}\n\n.services .owl-nav .owl-prev:before {\n  display: inline-block;\n  font-family: 'FontAwesome';\n  color: #1e1e1e;\n  font-size: 25px;\n  font-weight: 700;\n  content: '\\f104';\n  background-color: #fff;\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  line-height: 50px;\n}\n\n.services .owl-nav .owl-prev {\n  opacity: 1;\n  transition: all .5s;\n}\n\n.services .owl-nav .owl-prev:hover {\n  opacity: 0.9;\n}\n\n.services .owl-nav .owl-next {\n  opacity: 1;\n  transition: all .5s;\n}\n\n.services .owl-nav .owl-next:hover {\n  opacity: 0.9;\n}\n\n.services .owl-nav .owl-next{\n  margin-left: 10px;\n  outline: none;\n  position: absolute;\n  right: -85px;\n}\n\n.services .owl-nav .owl-next:before {\n  display: inline-block;\n  font-family: 'FontAwesome';\n  color: #1e1e1e;\n  font-size: 25px;\n  font-weight: 700;\n  content: '\\f105';\n  background-color: #fff;\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  line-height: 50px;\n}\n\n\n/*\n---------------------------------------------\nupcoming meetings\n---------------------------------------------\n*/\n\nsection.upcoming-meetings {\n  /* background-image: url(../public/assets/images/webp/meetings-bg.webp); */\n  background-color: #2596be;\n  background-position: center center;\n  background-attachment: fixed;\n  background-repeat: no-repeat;\n  background-size: cover;\n  padding-top: 100px;\n  padding-bottom: 100px;\n}\n\nsection.upcoming-meetings .section-heading {\n  text-align: center;\n}\n\nsection.upcoming-meetings .categories {\n  background-color: #fff;\n  border-radius: 20px;\n  padding: 40px;\n  margin-right: 45px;\n}\n\nsection.upcoming-meetings .categories h4 {\n  font-size: 18px;\n  font-weight: 600;\n  color: #1f272b;\n  margin-bottom: 30px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid #eee;\n}\n\nsection.upcoming-meetings .categories ul li {\n  display: inline-block;\n  margin-bottom: 15px;\n}\n\nsection.upcoming-meetings .categories ul li a {\n  font-size: 15px;\n  color: #1f272b;\n  font-weight: 500;\n  transition: all .3s;\n}\n\nsection.upcoming-meetings .categories ul li a:hover {\n  color: #2596be;\n}\n\nsection.upcoming-meetings .categories .main-button-red {\n  border-top: 1px solid #eee;\n  padding-top: 30px;\n  margin-top: 15px;\n}\n\nsection.upcoming-meetings .categories .main-button-red a {\n  width: 100%;\n  text-align: center;\n}\n\n.meeting-item {\n  margin-bottom: 30px;\n}\n\n.meeting-item .thumb {\n  position: relative;\n}\n\n.meeting-item .thumb img {\n  border-top-right-radius: 20px;\n  border-top-left-radius: 20px;\n}\n\n.meeting-item .thumb .price {\n  position: absolute;\n  left: 20px;\n  top: 20px;\n}\n\n.meeting-item .thumb .price span {\n  font-size: 16px;\n  color: #1f272b;\n  font-weight: 600;\n  background-color: rgba(250,250,250,0.9);\n  padding: 7px 12px;\n  border-radius: 10px;\n}\n\n.meeting-item .down-content {\n  background-color: #fff;\n  padding: 30px;\n  border-bottom-right-radius: 20px;\n  border-bottom-left-radius: 20px;\n}\n\n.meeting-item .down-content .date {\n  float: left;\n  text-align: center;\n  display: inline-block;\n  margin-right: 20px;\n}\n\n.meeting-item .down-content .date h6 {\n  font-size: 13px;\n  text-transform: uppercase;\n  font-weight: 600;\n  color: #2596be;\n}\n\n.meeting-item .down-content .date span {\n  display: block;\n  color: #1f272b;\n  font-size: 22px;\n  margin-top: 7px;\n}\n\n.meeting-item .down-content h4 {\n  font-size: 18px;\n  color: #1f272b;\n  font-weight: 600;\n  display: inline-block;\n  margin-bottom: 15px;\n}\n\n.meeting-item .down-content p {\n  margin-left: 50px;\n  color: #1f272b;\n  font-size: 14px;\n}\n\n\n\n/*\n---------------------------------------------\napply now\n---------------------------------------------\n*/\n\nsection.apply-now {\n  /* background-image: url(../public/assets/images/webp/apply-bg.webp); */\n  background-position: center center;\n  background-attachment: fixed;\n  background-repeat: no-repeat;\n  background-size: cover;\n  padding: 140px 0px;\n}\n\nsection.apply-now .item {\n  background-color: rgba(250,250,250,0.15);\n  padding: 40px;\n  margin-bottom: 30px;\n  text-align: center;\n  height: 395px;\n}\n\nsection.apply-now .item h3 {\n  color: #fff;\n  text-transform: uppercase;\n  font-size: 24px;\n  font-weight: 700;\n  margin-bottom: 20px;\n}\n\nsection.apply-now .item p {\n  color: #fff;\n  margin-bottom: 20px;\n}\n\n.accordions {\n  border-radius: 20px;\n  padding: 40px;\n  background-color: #fff;\n  margin-left: 45px;\n}\n.accordions .accordion {\n  border-bottom: 1px solid #eee;\n}\n.accordions .last-accordion {\n  border-bottom: none;\n}\n.accordion-head {\n  padding: 20px;  \n  font-size: 18px;\n  font-weight: 700;\n  color: #1f272b;\n  cursor: pointer;\n  transition: color 200ms ease-in-out;\n  border-bottom: 1px solid #fff;\n}\n@media screen and (min-width: 768px) {\n  .accordion-head {\n    padding: 1rem;\n    font-size: 1.2rem;\n  }\n}\n.accordion-head .icon {\n  float: right;\n  transition: transform 200ms ease-in-out;\n}\n.accordion-head.is-open {\n  color: #f5a425;\n  border-bottom: none;\n}\n.accordion-head.is-open .icon {\n  transform: rotate(45deg);\n}\n.accordion-body {\n  overflow: hidden;\n  height: 0;\n  transition: height 300ms ease-in-out;\n  border-bottom: 1px solid #fff;\n}\n.accordion-body > .content {\n  padding: 20px;\n  padding-top: 0;\n}\n\n\n/* \n---------------------------------------------\ncourses\n--------------------------------------------- \n*/\n#courses {\n  background: #f6f6f6 !important;\n  background-image: none !important;\n}\nsection.our-courses {\n  background-image: url(../public/assets/images/webp/meetings-bg.webp);\n  background-position: center center;\n  background-attachment: fixed;\n  background-repeat: no-repeat;\n  background-size: cover;\n  padding-top: 100px;\n  padding-bottom: 120px;\n}\n\n.our-courses .item .down-content {\n  background-color: #ffffff;\n}\n\n.our-courses .item .down-content h4 {\n  padding: 25px;\n  font-size: 18px;\n  color: #1f272b;\n  text-align: center; \n  border-bottom: 1px solid #eee;\n}\n\n.our-courses .item .down-content .info {\n  padding: 25px;\n}\n\n.our-courses .item .down-content .info ul li {\n  display: inline-block;\n  margin-right: 1px;\n}\n\n.our-courses .item .down-content .info ul li i {\n  color: #f5a425;\n  font-size: 14px;\n}\n\n.our-courses .item .down-content .info span {\n  color: white;\n  font-size: 15px;\n  font-weight: 600;\n  text-align: right;\n  display: inline-block;\n  width: 100%;\n}\n\n.our-courses .owl-nav {\n  text-align: center;\n  position: absolute;\n  width: 100%;\n  top: 50%;\n  transform: translateY(-45px);\n}\n\n.our-courses .owl-dots {\n  display: inline-block;\n  text-align: center;\n  width: 100%;\n  margin-top: 40px;\n}\n\n.our-courses .owl-dots .owl-dot {\n  transition: all .5s;\n  width: 7px;\n  height: 7px;\n  background-color: #fff;\n  margin: 0px 5px;\n  border-radius: 50%;\n  outline: none;\n}\n\n.our-courses .owl-dots .active {\n  width: 24px;\n  height: 8px;\n  border-radius: 4px;\n}\n    \n.our-courses .owl-nav .owl-prev{\n  margin-right: 10px;\n  outline: none;\n  position: absolute;\n  left: -80px;\n}\n\n.our-courses .owl-nav .owl-prev span,\n.our-courses .owl-nav .owl-next span {\n  opacity: 0;\n}\n\n.our-courses .owl-nav .owl-prev:before {\n  display: inline-block;\n  font-family: 'FontAwesome';\n  color: #1e1e1e;\n  font-size: 25px;\n  font-weight: 700;\n  content: '\\f104';\n  background-color: #fff;\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  line-height: 50px;\n}\n\n.our-courses .owl-nav .owl-prev {\n  opacity: 1;\n  transition: all .5s;\n}\n\n.our-courses .owl-nav .owl-prev:hover {\n  opacity: 0.9;\n}\n\n.our-courses .owl-nav .owl-next {\n  opacity: 1;\n  transition: all .5s;\n}\n\n.our-courses .owl-nav .owl-next:hover {\n  opacity: 0.9;\n}\n\n.our-courses .owl-nav .owl-next{\n  margin-left: 10px;\n  outline: none;\n  position: absolute;\n  right: -85px;\n}\n\n.our-courses .owl-nav .owl-next:before {\n  display: inline-block;\n  font-family: 'FontAwesome';\n  color: #1e1e1e;\n  font-size: 25px;\n  font-weight: 700;\n  content: '\\f105';\n  background-color: #fff;\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  line-height: 50px;\n}\n\n\n/*\n---------------------------------------------\nour facts\n---------------------------------------------\n*/\n\nsection.our-facts {\n  background-image: url(../public/assets/images/webp/facts-bg.webp);\n  background-position: center center;\n  background-attachment: fixed;\n  background-repeat: no-repeat;\n  background-size: cover;\n  padding: 140px 0px 125px 0px;\n}\n\nsection.our-facts h2 {\n  font-size: 38px;\n  color: #fff;\n  line-height: 50px;\n  font-weight: 700;\n  letter-spacing: 0.5px;\n  margin-bottom: 50px;\n}\n\n.count-area-content {\n  text-align: center;\n  background-color: rgba(250,250,250,0.15);\n  border-radius: 20px;\n  padding: 25px 30px 35px 30px;\n  margin: 15px 0px;\n}\n\n.percentage .count-digit:after {\n  content: '%';\n  margin-left: 3px;\n}\n\n.count-digit {\n    margin: 5px 0px;\n    color: #f5a425;\n    font-weight: 700;\n    font-size: 36px;\n}\n.count-title {\n    font-size: 18px;\n    font-weight: 500;\n    color: #fff;\n    letter-spacing: 0.5px;\n}\n\n.new-students {\n  margin-top: 45px;\n}\n\nsection.our-facts .video {\n  text-align: center;\n  margin-left: 70px;\n  background-image: url(../public/assets/images/webp/video-item-bg.webp);\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: cover;\n  border-radius: 20px;\n}\n\nsection.our-facts .video img {\n  padding: 170px 0px;\n  max-width: 56px;\n}\n\n\n/* \n---------------------------------------------\ncontact us\n--------------------------------------------- \n*/\n\nsection.contact-us {\n  background-image: url(../public/assets/images/webp/meetings-bg.webp);\n  background-position: center center;\n  background-attachment: fixed;\n  background-repeat: no-repeat;\n  background-size: cover;\n  padding: 140px 0px 0px 0px;\n}\n.contact-form{\n  background-color: rgba(250,250,250,0.15);\n  border-radius: 20px;\n  background: #2bb8dd;\n  padding: 1px;\n}\nsection.contact-us #contact {\n  background-color: #111827;\n  border-color: #2bb8dd;\n  border-radius: 20px;\n  padding: 119px;\n}\n\nsection.contact-us #contact h2 {\n  text-transform: uppercase;\n  color: #2bb8dd;\n  border-bottom: 1px solid #eee;\n  margin-bottom: 40px;\n  padding-bottom: 20px;\n  font-size: 22px;\n  font-weight: 700;\n}\n.section-divider {\n  height: 2px;\n  width: 100%;\n  background: linear-gradient(to right, #1e90ff, #3b82f6, #1e90ff);\n  box-shadow: 0 0 10px rgba(59, 130, 246, 0.6);\n  margin: 0;\n  padding: 0;\n}\nsection.contact-us #contact input {\n  width: 100%;\n  height: 40px;\n  border-radius: 20px;\n  background-color: #f7f7f7;\n  outline: none;\n  border: none;\n  box-shadow: none;\n  font-size: 13px;\n  font-weight: 500;\n  color: #7a7a7a;\n  padding: 0px 15px;\n  margin-bottom: 30px;\n}\n\nsection.contact-us #contact textarea {\n  width: 100%;\n  min-height: 140px;\n  max-height: 180px;\n  border-radius: 20px;\n  background-color: #f7f7f7;\n  outline: none;\n  border: none;\n  box-shadow: none;\n  font-size: 13px;\n  font-weight: 500;\n  color: #7a7a7a;\n  padding: 15px;\n  margin-bottom: 30px;\n}\n\nsection.contact-us #contact button {\n  font-size: 14px;\n  font-weight: 600;\n  color: #fff;\n  background: linear-gradient(135deg, #2563eb, #3b82f6); /* Matching blue gradient */\n  padding: 12px 30px;\n  border: none;\n  border-radius: 12px;\n  cursor: pointer;\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);\n  font-family: var(--font-family);\n  transition: all 0.3s ease;\n}\n\nsection.contact-us #contact button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 18px rgba(37, 99, 235, 0.4);\n  background: linear-gradient(135deg, #1d4ed8, #2563eb); /* Slight hover variation */\n}\n\nsection.contact-us #contact button:hover {\n  opacity: 0.9;\n}\n\n.contact-us .right-info {\n  background: linear-gradient(135deg, #2596be, #1f2937); /* Gradient border */\n  border-radius: 22px; /* Slightly larger for outer radius */\n  padding: 2px; /* Thin border effect */\n}\n\n.contact-us .right-info > * {\n  background-color: #111827;\n  border-radius: 20px; /* Inner content radius */\n  padding: 40px;\n}\n\n\nsection.contact-us .right-info ul li {\n  display: inline-block;\n  border-bottom: 1px solid rgba(250,250,250,0.15);\n  margin-bottom: 30px;\n  padding-bottom: 30px;\n}\n\nsection.contact-us .right-info ul li:last-child {\n  margin-bottom: 0;\n  padding-bottom: 0;\n  border-bottom: none;\n}\n\nsection.contact-us .right-info ul li h6 {\n  color: #fff;\n  font-size: 15px;\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n\nsection.contact-us .right-info ul li span {\n  display: block;\n  font-size: 16px;\n  color: #fff;\n  font-weight: 500;\n}\n\n.footer {\n  /* text-align: center; */\n  margin-top: 140px;\n  border-top: 1px solid rgba(250,250,250,0.15);\n  padding: 50px 0px;\n}\n.footer p {\n  /* text-transform: uppercase; */\n  font-size: 14px;\n  color: #fff;\n}\n\n.footer p a {\n  color: #f5a425;\n}\n\n\n/*\n---------------------------------------------\nheading page\n---------------------------------------------\n*/\n\nsection.heading-page {\n  background-image: url(../public/assets/images/webp/heading-bg.webp);\n  background-position: center center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  padding-top: 230px;\n  padding-bottom: 110px;\n  text-align: center;\n}\n\nsection.heading-page h6 {\n  margin-top: 0px;\n  font-size: 15px;\n  text-transform: uppercase;\n  font-weight: 600;\n  color: #fff;\n  letter-spacing: 1px;\n}\n\nsection.heading-page h2 {\n  margin-top: 20px;\n  margin-bottom: 20px;\n  font-size: 36px;\n  text-transform: uppercase;\n  font-weight: 800;\n  color: #fff;\n  letter-spacing: 1px;\n}\n\n\n/*\n---------------------------------------------\nupcoming meetings page\n---------------------------------------------\n*/\n\nsection.meetings-page {\n  background-image: url(../public/assets/images/webp/meetings-page-bg.webp);\n  background-position: center center;\n  background-attachment: fixed;\n  background-repeat: no-repeat;\n  background-size: cover;\n  padding-top: 140px;\n  padding-bottom: 0px;\n}\n\nsection.meetings-page .filters {\n  text-align: center;\n  margin-bottom: 60px;\n}\n\nsection.meetings-page .filters li {\n  font-size: 13px;\n  color: #2596be;\n  background-color: #fff;\n  padding: 11px 30px;\n  display: inline-block;\n  border-radius: 22px;\n  font-weight: 600;\n  text-transform: uppercase;\n  transition: all .3s;\n  cursor: pointer;\n  margin: 0px 3px;\n}\n\nsection.meetings-page .filters ul li.active,\nsection.meetings-page .filters ul li:hover {\n  background-color: #2596be;\n  color: #fff;\n}\n\nsection.meetings-page .pagination {\n  text-align: center;\n  width: 100%;\n  margin-top: 30px;\n  display: inline-block;\n}\n\nsection.meetings-page .pagination ul li {\n  display: inline-block;\n}\n\nsection.meetings-page .pagination ul li a {\n  width: 40px;\n  height: 40px;\n  background-color: #fff;\n  border-radius: 10px;\n  color: #1f272b;\n  display: inline-block;\n  text-align: center;\n  line-height: 40px;\n  font-weight: 600;\n  font-size: 15px;\n  transition: all .3s;\n}\n\nsection.meetings-page .main-button-red {\n  text-align: center;\n}\n\nsection.meetings-page .main-button-red a {\n  padding: 12px 60px;\n  text-align: center;\n  margin-top: 30px;\n}\n\nsection.meetings-page .pagination ul li.active a,\nsection.meetings-page .pagination ul li a:hover {\n  background-color: #2596be;\n  color: #fff;\n}\n\n.meeting-single-item .thumb {\n  position: relative;\n}\n\n.meeting-single-item .thumb img {\n  border-top-right-radius: 20px;\n  border-top-left-radius: 20px;\n}\n\n.meeting-single-item .thumb .price {\n  position: absolute;\n  left: 20px;\n  top: 20px;\n}\n\n.meeting-single-item .thumb .price span {\n  font-size: 16px;\n  color: #1f272b;\n  font-weight: 600;\n  background-color: rgba(250,250,250,0.9);\n  padding: 7px 12px;\n  border-radius: 10px;\n}\n\n.meeting-single-item .down-content {\n  background-color: #fff;\n  padding: 40px;\n  border-bottom-right-radius: 20px;\n  border-bottom-left-radius: 20px;\n}\n\n.meeting-single-item .thumb .date {\n  position: absolute;\n  background-color: rgba(250,250,250,0.9);\n  width: 80px;\n  height: 80px;\n  text-align: center;\n  padding: 15px 0px;\n  border-radius: 10px;\n  right: 20px;\n  top: 20px;\n}\n\n.meeting-single-item .thumb .date h6 {\n  font-size: 13px;\n  text-transform: uppercase;\n  font-weight: 600;\n  color: #2596be;\n}\n\n.meeting-single-item .thumb .date span {\n  display: block;\n  color: #1f272b;\n  font-size: 22px;\n  margin-top: 7px;\n}\n\n.meeting-single-item .down-content h4 {\n  font-size: 22px;\n  color: #1f272b;\n  font-weight: 600;\n  display: inline-block;\n  margin-bottom: 15px;\n}\n\n.meeting-single-item .down-content h5 {\n  font-size: 18px;\n  color: #1f272b;\n  font-weight: 700;\n  display: inline-block;\n  margin-bottom: 15px;\n}\n\n.meeting-single-item .down-content p {\n  color: #1f272b;\n  font-size: 14px;\n}\n\n.meeting-single-item .down-content p.description {\n  margin-top: 40px;\n  padding-top: 40px;\n  border-top: 1px solid #eee;\n  margin-bottom: 40px;\n  padding-bottom: 40px;\n  border-bottom: 1px solid #eee;\n}\n\n.meeting-single-item .down-content .share {\n  margin-top: 40px;\n  padding-top: 40px;\n  border-top: 1px solid #eee;\n}\n\n.meeting-single-item .down-content .share h5 {\n  float: left;\n  margin-right: 10px;\n  margin-bottom: 0px;\n}\n\n.meeting-single-item .down-content .share ul li {\n  display: inline;\n}\n\n.meeting-single-item .down-content .share ul li a {\n  font-size: 14px;\n  color: #1f272b;\n  transition: all .3s;\n}\n\n.meeting-single-item .down-content .share ul li a:hover {\n  color: #f5a425;\n}\n\n/* Meeting item column */\n.templatemo-item-col {\n\twidth: 31%;\n}\n\n@media (max-width: 992px) {\n\t.templatemo-item-col {\n\t\twidth: 45%;\n\t}\n}\n\n@media (max-width: 767px) {\n\t.templatemo-item-col {\n\t\twidth: 100%;\n\t}\n}\n\n/* \n---------------------------------------------\nresponsive\n--------------------------------------------- \n*/\n\n@media (max-width: 1300px) {\n  .services .owl-nav .owl-next{\n    right: -30px;\n  }\n  .services .owl-nav .owl-prev{\n    left: -25px;\n  }\n  .our-courses .owl-nav .owl-next{\n    right: -30px;\n  }\n  .our-courses .owl-nav .owl-prev{\n    left: -25px;\n  }\n}\n\n@media (max-width: 1200px) {\n  .services .owl-nav .owl-next{\n    right: -70px;\n  }\n  .services .owl-nav .owl-prev{\n    left: -65px;\n  }\n  .our-courses .owl-nav .owl-next{\n    right: -70px;\n  }\n  .our-courses .owl-nav .owl-prev{\n    left: -65px;\n  }\n}\n\n@media (max-width: 1085px) {\n  .services .owl-nav .owl-next{\n    right: -30px;\n  }\n  .services .owl-nav .owl-prev{\n    left: -25px;\n  }\n  .our-courses .owl-nav .owl-next{\n    right: -30px;\n  }\n  .our-courses .owl-nav .owl-prev{\n    left: -25px;\n  }\n}\n\n@media (max-width: 1005px) {\n  .services .owl-nav .owl-next{\n    display: none;\n  }\n  .services .owl-nav .owl-prev{\n    display: none;\n  }\n  .our-courses .owl-nav .owl-next{\n    display: none;\n  }\n  .our-courses .owl-nav .owl-prev{\n    display: none;\n  }\n}\n\n@media (max-width: 992px) {\n\n  .main-banner .caption {\n    top: 60%;\n  }\n\n  .main-banner .caption h1 {\n    margin-top: 10px;\n    margin-bottom: 10px;\n    font-size: 22px;\n  }\n\n  .main-banner .caption .main-button-red {\n    margin-top: 15px;\n  }\n\n  .services {\n    margin-top: 60px;\n  }\n\n  section.upcoming-meetings {\n    padding-top: 400px;\n  }\n\n  section.upcoming-meetings .categories {\n    margin-right: 0px;\n    margin-bottom: 30px;\n  }\n\n  .accordions {\n    margin-left: 0px;\n  }\n\n  .new-students {\n    margin-top: 15px;\n  }\n\n  section.our-facts .video {\n    margin-left: 0px;\n    margin-top: 15px;\n  }\n\n\n\n}\n\n@media (max-width: 767px) {\n\n  .sub-header .left-content p {\n    display: none;\n  }\n\n  .sub-header .right-icons {\n    text-align: center;\n  }\n\n  .main-nav .nav .sub-menu {\n    display: none;\n  }\n\n  .header-area .main-nav .nav li ul.sub-menu li a {\n    color: #1f272b;\n  }\n\n}\n\n.learn-more-btn {\n  background: transparent !important;\n  border: 2px solid #ffffff;\n}\n.learn-more-btn:hover{\n  background: #FC3 !important;\n    border-color: #FC3 !important;\n}\n\n.slick-dots {\n  bottom: -50px;\n}\n\n.howitworks-content{\n  padding: 50px;\n    /* background: #ffffff; */\n    height: 350px;\n    margin-bottom: 25px;\n    flex: 0 0 350px;\n  background: #0D1324;\n  border-radius: 20px;\n  overflow: hidden;\n  border: 1px solid #2a2a2a;\n  transition: all 0.3s ease;\n  position: relative;\n}\n.howitworks-content:hover{\n  transform: translateY(-10px);\n    border-color: white;\n    box-shadow: 0 15px 40px rgba(43, 184, 221, 0.2);\n}\n.howitworks-content h4, .howitworks-content p {\n  color: #2bb8dd !important;\n  text-align: left;\n}\n.howitworks-content p {\n  color: #ffffff !important;\n  text-align: left;\n}\n.howitworks-content:before {\n  content: '';\n}\n.howitworks_numbers{\n  font-size: 20px;\n    color: #ffffff;\n    display: inline-block;\n    width: 45px;\n    height: 45px;\n    background: #2596be;\n    border-radius: 50%;\n    vertical-align: middle;\n    padding-top: 7px;\n    text-align: center;\n    margin-bottom: 20px;\n}\n\n/* Footer styling */\n.footer {\n  background-color: #111827;\n  color: white;\n  padding: 2rem 1rem;\n  font-family: Arial, sans-serif;\n}\n\n.footer-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  flex-wrap: wrap;\n  gap: 2rem;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.footer-column {\n  flex: 1;\n  min-width: 200px;\n}\n\n.footer-logo img {\n  max-width: 150px;\n}\n\n.footer h4 {\n  font-size: 1.25rem;\n  margin-bottom: 1rem;\n}\n\n.footer-links {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.footer-links li {\n  margin-bottom: 0.5rem;\n}\n\n.footer-links a {\n  text-decoration: none;\n  color: white;\n  font-size: 1rem;\n  transition: color 0.3s;\n}\n\n.footer-links a:hover {\n  color: #f0f0f0;\n}\n\n.footer-social-icons {\n  display: flex;\n  gap: 0.5rem;\n  margin-top: 1rem;\n  margin-left: 5rem;\n\n}\n\n.social-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  background-color: white;\n  color: #2596be;\n  border-radius: 50%;\n  font-size: 1.25rem;\n  transition: all 0.3s;\n  text-decoration: none;\n}\n\n.social-icon:hover {\n  background-color: #20789c;\n  color: white;\n}\n\n.footer-copyright {\n  border-top: 1px solid rgba(250,250,250,0.15);\n  text-align: center;\n  margin-top: 2rem;\n  font-size: 0.875rem;\n  /* background-color: #20789c; */\n  padding: 1rem;\n}\n\nsection.apply-now .item .social-icon {\n  \n  margin: auto;\n  margin-bottom: 20px;\n  width: 70px;\n  height: 70px;\n}\n/* existing */\n#englishtest { background:#0A0F1C; }\n#englishtest h2 { color:#ffffff !important; }\n#englishtest h3 { color:#2bb8dd !important; margin-bottom:15px; }\n#englishtest p  { color:#ffffff !important; }\n\n/* additions for the new look */\n#englishtest { padding:60px 0; }\n#englishtest .et-header { margin-bottom:24px; }\n#englishtest .et-subtitle { color:#9aa3b1; margin:8px 0 16px; }\n\n/* tabs */\n#englishtest .et-tabs {\n  display:inline-flex; gap:8px; padding:6px;\n  border:1px solid #2c3a5f; border-radius:999px;\n  background:linear-gradient(180deg,#0f172a,#0b1324);\n  box-shadow:0 10px 30px rgba(0,0,0,.35), inset 0 1px 0 rgba(255,255,255,.03);\n}\n#englishtest .et-tab {\n  border:0; padding:10px 16px; border-radius:999px; cursor:pointer;\n  color:#a3acc2; font-weight:700; background:transparent;\n}\n#englishtest .et-tab.active {\n  color:#fff; background:linear-gradient(180deg,#1e293b,#0f172a);\n  box-shadow: inset 0 0 0 1px #2c3a5f, 0 4px 16px rgba(0,0,0,.35);\n}\n\n/* cards */\n#englishtest .et-card {\n  background:#0f172aee; border:1px solid #2c3a5f; border-radius:18px;\n  padding:22px; position:relative; height:100%;\n  box-shadow:0 10px 30px rgba(0,0,0,.35), inset 0 1px 0 rgba(255,255,255,.03);\n}\n#englishtest .et-badge{\n  position:absolute; top:18px; left:250px;\n  background:rgba(59,130,246,.15); color:#cfe1ff;\n  border:1px solid rgba(59,130,246,.35);\n  padding:4px 5px; border-radius:999px; font-size:12px; font-weight:800;\n}\n#englishtest .et-card-header{\n  display:flex; align-items:center; gap:12px; margin-bottom:8px;\n}\n/* icon pill */\n#englishtest .et-icon{\n  width:44px; height:44px; border-radius:12px; display:grid; place-items:center;\n  background:rgba(255,255,255,.06); border:1px solid #2c3a5f; font-size:22px;\n}\n/* make card titles white like screenshot */\n#englishtest .et-card h3 { color:#ffffff !important; margin:0; }\n\n/* body text muted for readability */\n#englishtest .et-text { color:#cbd5e1 !important; line-height:1.6; }\n\n/* meta list */\n#englishtest .et-meta{\n  list-style:none; padding-left:0; margin:12px 0 0;\n  border-top:1px dashed rgba(163,172,194,.25); padding-top:10px;\n  color:#c7d0e6; font-size:14px; display:grid; gap:6px;\n}\n#englishtest .et-meta b{ color:#e9eefc; }\n\n/* links under cards */\n#englishtest .et-link{\n  display:inline-block; margin-top:10px; margin-right:12px;\n  color:#9ec1ff; font-weight:700; text-decoration:none;\n}\n#englishtest .et-link:hover{ text-decoration:underline; }\n\n\n/* existing + new look already applied above */\n\n/* responsive tweaks */\n@media (max-width: 992px) {\n  #englishtest {\n    padding: 40px 16px;\n  }\n\n  #englishtest .et-tabs {\n    flex-wrap: wrap;\n    justify-content: center;\n  }\n\n  #englishtest .et-card {\n    padding: 18px;\n    text-align: center; /* center content */\n  }\n\n  #englishtest .et-badge {\n    left: auto;\n    right: 16px; /* keep inside card on smaller screens */\n    top: 12px;\n    font-size: 11px;\n  }\n\n  #englishtest .et-icon {\n    width: 40px;\n    height: 40px;\n    font-size: 20px;\n    margin: 0 auto; /* center horizontally */\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  #englishtest h2 {\n    font-size: 24px;\n    text-align: center;\n  }\n\n  #englishtest h3 {\n    font-size: 18px;\n  }\n\n  #englishtest p,\n  #englishtest .et-text {\n    font-size: 14px;\n  }\n}\n\n@media (max-width: 576px) {\n  #englishtest {\n    padding: 30px 12px;\n  }\n\n  #englishtest .et-tabs {\n    gap: 4px;\n  }\n\n  #englishtest .et-tab {\n    padding: 8px 12px;\n    font-size: 13px;\n  }\n\n  #englishtest .et-card {\n    border-radius: 12px;\n    padding: 16px;\n    text-align: center; /* keep everything centered */\n  }\n\n  #englishtest .et-badge {\n    position: static;\n    display: inline-block;\n    margin-top: 8px;\n  }\n\n  #englishtest .et-card-header {\n    flex-direction: column;\n    align-items: center; /* center children */\n    gap: 8px;\n  }\n\n  #englishtest .et-icon {\n    margin: 0 auto; /* ensure icon stays in center */\n  }\n\n  #englishtest h2 {\n    font-size: 20px;\n  }\n\n  #englishtest h3 {\n    font-size: 16px;\n  }\n}\n\n\n/* #englishtest {\n  background: #0A0F1C;\n}\n#englishtest h2 {\n  color: #ffffff !important;\n}\n\n#englishtest h3 {\n  color: #2bb8dd !important;\n  margin-bottom: 15px;\n}\n#englishtest p {\n  color: #ffffff !important;\n} */\n\n\n#aboutus, #studentservices, #courses {\n  background: #111827!important;\n}\n#aboutus p{\n  text-align: center;\n  padding: 0 20%;\n  color: #ffffff;\n  text-align: justify;\n  margin-bottom: 20px;\n}\np{\n  font-size: 14px !important;\n}\n\n.main-heading {\n  text-align: center;\n  font-size: 2.5rem;\n  color: #2c3e50;\n  margin-bottom: 50px;\n  position: relative;\n}\n\n.main-heading::after {\n  content: '';\n  position: absolute;\n  bottom: -10px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 100px;\n  height: 4px;\n  background: #3498db;\n  border-radius: 2px;\n}\n\n.timeline {\n  position: relative;\n  padding: 20px 0;\n}\n\n.timeline::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 6px;\n  height: 100%;\n  background: #ddd;\n  border-radius: 3px;\n}\n\n.timeline-item {\n  position: relative;\n  margin: 20px 0;\n}\n\n.timeline-item:nth-child(odd) {\n  text-align: left;\n  padding-right: 50px;\n}\n\n.timeline-item:nth-child(even) {\n  text-align: right;\n  padding-left: 50px;\n}\n\n.timeline-item::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 20px;\n  height: 20px;\n  background: #3498db;\n  border: 3px solid #f8f9fa;\n  border-radius: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.timeline-item-content {\n  display: inline-block;\n  width: 45%;\n  background: #fff;\n  border-radius: 10px;\n  padding: 20px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  position: relative;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  flex: 0 0 350px;\n  background: linear-gradient(135deg, #0f0f0f 0%, #1a1a1a 100%);\n  border-radius: 20px;\n  overflow: hidden;\n  border: 1px solid #2a2a2a;\n  transition: all 0.3s ease;\n  position: relative;\n}\n\n\n.timeline-item-content:hover {\n  transform: translateY(-10px);\n    border-color: #2bb8dd;\n    box-shadow: 0 15px 40px rgba(43, 184, 221, 0.2);\n}\n\n.timeline-item:nth-child(odd) .timeline-item-content {\n  margin-right: auto;\n}\n\n.timeline-item:nth-child(even) .timeline-item-content {\n  margin-left: auto;\n}\n\n.timeline-item h3 {\n  margin: 0;\n  font-size: 1.5rem;\n  color: #2bb8dd ;\n}\n\n.timeline-item p {\n  font-size: 1rem;\n  color: #ffffff;\n  margin: 10px 0 0;\n  line-height: 1.6;\n}\n\n.timeline-item .icon {\n  font-size: 2.5rem;\n  color: #3498db;\n  margin-bottom: 10px;\n}\n\n.additional-feature {\n  margin-top: 50px;\n  background: linear-gradient(135deg, #000000 0%, #1a1a1a 50%, #000000 100%);\n  padding: 30px;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  flex: 0 0 350px;\n  background: linear-gradient(135deg, #0f0f0f 0%, #1a1a1a 100%);\n  border-radius: 20px;\n  overflow: hidden;\n  border: 1px solid #2a2a2a;\n  transition: all 0.3s ease;\n  position: relative;\n}\n.additional-feature:hover {\n  transform: translateY(-8px);\n  border-color: #2bb8dd;\n  box-shadow: 0 15px 40px rgba(43, 184, 221, 0.2);\n}\n\n.additional-feature h3 {\n  text-align: center;\n  color: #2bb8dd ;\n  margin-bottom: 20px;\n}\n\n.additional-feature ul {\n  list-style: none;\n  padding: 0;\n}\n\n.additional-feature ul li {\n  margin-bottom: 10px;\n  font-size: 1rem;\n  color: #ffffff;\n}\n\n.additional-feature ul li i {\n  margin-right: 10px;\n  color: #3498db;\n}\n\n\n/* CEO Section Card Layout */\n.ceo-section {\n  display: flex;\n  flex-direction: column;\n  color: var(--section-text) !important; \n\n  align-items: center;\n  background: #111827;\n  border: 1px solid #2a2a2a;\n  border-radius: 20px;\n  padding: 30px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n  position: relative;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n/* Hover Effect */\n.ceo-section:hover {\n  transform: translateY(-8px);\n  border-color: white;\n  box-shadow: 0 15px 40px rgba(43, 184, 221, 0.2);\n}\n\n/* CEO Image Styling */\n.ceo-image {\n  margin-bottom: 20px;\n}\n\n.ceo-image img {\n  width: 160px;\n  height: 160px;\n  object-fit: cover;\n  border-radius: 50%;\n  border: 3px solid #ddd;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n/* CEO Content */\n.ceo-content {\n  text-align: center;\n  padding: 0 10px;\n  \n}\n\n.ceo-content h2 {\n  font-size: 2rem;\n  color: #2bb8dd;\n  margin-bottom: 10px;\n}\n\n.ceo-content h3 {\n  font-size: 1.2rem;\n  color: #2bb8dd;\n  margin-bottom: 20px;\n  font-weight: normal;\n}\n\n.ceo-content p {\n  font-size: 1rem;\n  color: #ffffff;\n  line-height: 1.6;\n  margin-bottom: 20px;\n}\n\n\n\n\n.quote {\n  font-style: italic;\n  color: #777;\n  font-size: 1.1rem;\n  margin-top: 20px;\n  position: relative;\n}\n\n.quote::before,\n.quote::after {\n  content: '\"';\n  font-size: 2rem;\n  color: #3498db;\n  position: absolute;\n}\n\n.quote::before {\n  top: -10px;\n  left: -10px;\n}\n\n.quote::after {\n  bottom: -10px;\n  right: -10px;\n}\n\n.ceo-signature {\n  display: flex;\n  align-items: center;\n  margin-top: 20px;\n}\n\n.ceo-signature img {\n  width: 80px;\n  height: auto;\n  margin-right: 20px;\n}\n\n@media (max-width: 768px) {\n  section.contact-us #contact {\n    padding: 30px;\n      background-color: #111827;\n      border-color: #2bb8dd;\n      border-radius: 20px;\n   \n  }\n  .ceo-section {\n      flex-direction: column;\n      text-align: center;\n  }\n\n  .ceo-image, .ceo-content {\n      flex: 1 1 100%;\n  }\n\n  .ceo-content {\n      padding: 0;\n  }\n\n  /* for mobile responsiveness */\n  .header{\n    padding: 0 10px;\n  }\n  .logo-text, .timeline::before, .timeline-item::after {\n    display: none !important;\n  }\n  .navbar {\n    position: absolute;\n    right: 0;\n    backdrop-filter: unset !important;\n  }\n  .hamburger {\n    position: absolute;\n    right: 15px;\n  }\n  .auth-controls {\n    margin-right: 50px;\n  }\n  .logo-section {\n    margin-left: 15px !important;\n  }\n  #bg-video {\n    min-height: 70vh !important;\n  }\n  .timeline-item {\n    padding: 0 !important;\n  }\n  .timeline-item-content {\n    width: 100% !important;\n  }\n  #englishtest, .howitworks-content, .howitworks-content p, .howitworks-content h4, .timeline-item-content, .footer, .footer-social-icons,\n  .section.contact-us .right-info, #contact, .video-overlay, #aboutus p {\n    text-align: center !important;\n    justify-content: center !important;\n  }\n  #aboutus p {\n    padding: 0 15px !important;\n  }\n  .logo-img {\n    height: 32px !important;\n    width: auto !important;\n  }\n  .auth-controls {\n    z-index: 9999 !important\n  }\n  .slick-slide {\n    padding: 15px;\n  }\n}\n\n\n\n/* WhatsApp Icon */\n.whatsapp-float {\n  position: fixed;\n  right: 30px;\n  bottom: 100px; \n  background-color: #25d366;\n  color: white;\n  border-radius: 50%;\n  width: 60px;\n  height: 60px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 26px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);\n   z-index: 1001; \n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n\n/* ===== Base (desktop/tablet stays the same) ===== */\n.feature-strip {\n  position: relative;\n  background: #0c1826;\n  padding: 2rem 0;\n}\n.feature-strip::before,\n.feature-strip::after {\n  content: \"\";\n  display: block;\n  height: 1px;\n  width: 100%;\n  background: #1b314a;\n  position: absolute;\n  left: 0;\n}\n.feature-strip::before { top: 0; }\n.feature-strip::after  { bottom: 0; }\n\n.feature-box {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: .6rem;\n  padding: .5rem 1rem;\n  min-height: 110px;\n}\n.feature-box i {\n  font-size: 2.4rem;\n  line-height: 1;\n  color: #1ea2ff;\n}\n.feature-label {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #fff;\n}\n\n/* desktop vertical separators between columns */\n@media (min-width: 992px) {\n  .feature-strip .col-md-4:not(:last-child) .feature-box {\n    border-right: 1px solid #1b314a;\n  }\n}\n\n/* ===== Tablet (≤ 991.98px) ===== */\n@media (max-width: 991.98px) {\n  .feature-strip { padding: 1.6rem 0; }\n  .feature-box i { font-size: 2.1rem; }\n  .feature-label { font-size: .98rem; }\n  /* remove desktop right borders when not 3-up */\n  .feature-strip .feature-box { border-right: 0; }\n}\n\n/* ===== Phones (≤ 575.98px) ===== */\n@media (max-width: 575.98px) {\n  /* section padding a bit tighter */\n  #about { padding: 2rem 0; }\n\n  /* bigger touch targets & comfy spacing */\n  .feature-box {\n    padding: 1rem 0;\n    min-height: 0;\n  }\n  .feature-box i { font-size: 2rem; }\n  .feature-label { font-size: .95rem; }\n\n  /* thin horizontal divider between stacked items */\n  .feature-strip .col-12 + .col-12 .feature-box {\n    border-top: 1px solid #1b314a;\n    margin-top: .75rem;\n    padding-top: 1.25rem;\n  }\n}\n\n\n\n\n\n\n.whatsapp-float:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.3);\n}\n\n.whatsapp-float i {\n  color: white;\n  transition: color 0.3s ease;\n}\n\n.whatsapp-float:hover i {\n  color: white;\n}\n\n\n/* Root Variables */\n:root {\n  \n  --primary-bg: #111827;           /* Darkest background */\n  --secondary-bg: #1F2937;         /* Slightly lighter background */\n  --accent-color: #2596be;         /* Brand blue */\n  --text-color: #ffffff;           /* Primary text (white) */\n  --secondary-text: #9ca3af;       /* Muted text */\n\n  --font-family: 'Poppins', sans-serif;\n\n  /* Optional enhancements */\n  --button-radius: 22px;\n  --button-hover-bg: #ffffff;\n  --button-hover-text: #111827;\n\n  --border-color: rgba(255, 255, 255, 0.1);\n  --shadow-md: 0 4px 12px rgba(0, 0, 0, 0.15);\n  --shadow-lg: 0 6px 20px rgba(0, 0, 0, 0.2);\n\n\n}\n\n/* Global Styles */\nbody {\n  background-color: var(--primary-bg);\n  color: var(--text-color);\n  font-family: var(--font-family);\n  margin: 0;\n  padding: 0;\n}\n\n/* Hero Section */\n.hero-section {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 6rem 2rem;\n  min-height: 400px;\n  /* background-image: url('../src/assets/images/webp/students_lib.webp'); adjust path if needed */\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  text-align: center;\n  color: white;\n  overflow: hidden;\n}\n\n.hero-section::before {\n  content: '';\n  position: absolute;\n  top: 0; left: 0; right: 0; bottom: 0;\n  background-color: rgba(17, 24, 39, 0.8); /* #111827 with opacity */\n  z-index: 1;\n}\n\n.hero-content {\n  position: relative;\n  z-index: 2;\n  max-width: 800px;\n}\n\n.hero-content h1 {\n  font-size: 2.5rem;\n  color: #ffffff;\n  margin-bottom: 1rem;\n}\n\n.hero-content p {\n  font-size: 1.1rem;\n  color: #ffffff;\n  margin-bottom: 2rem;\n}\n\n.hero-btn {\n  background-color: transparent;\n  border: 2px solid #ffffff;\n  color: #ffffff;\n  padding: 0.75rem 1.5rem;\n  border-radius: 999px;\n  font-weight: 600;\n  text-decoration: none;\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\n.hero-btn:hover {\n  background-color: #ffffff;\n  color: #111827;\n}\n\n/* OPTIONAL: Remove this if you no longer use the direct image */\n.hero-image img {\n  display: none;\n}\n\n/* Recent Articles */\n.recent-articles {\n  background-color: var(--secondary-bg);\n  padding: 4rem 2rem;\n}\n\n.recent-articles h2 {\n  font-size: 2rem;\n  text-align: center;\n  margin-bottom: 2rem;\n  color: var(--text-color);\n}\n\n.articles-wrapper {\n  display: flex;\n  gap: 2rem;\n  overflow-x: auto;\n  padding-bottom: 1rem;\n}\n\n.article-card {\n  background-color: var(--primary-bg);\n  padding: 1.5rem;\n  border-radius: 12px;\n  min-width: 300px;\n  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.1);\n  color: var(--text-color);\n}\n\n.article-card h3 {\n  margin: 0.5rem 0;\n}\n\n.article-card p {\n  font-size: 0.95rem;\n  color: var(--secondary-text);\n}\n\n.article-btn {\n  display: inline-block;\n  margin-top: 1rem;\n  color: var(--accent-color);\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.article-btn:hover {\n  text-decoration: underline;\n}\n\n/* Blog Grid */\n.blog-section {\n  padding: 4rem 2rem;\n  background-color: var(--primary-bg);\n}\n\n.blog-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 2rem;\n}\n\n.blog-post-card {\n  background-color: var(--secondary-bg);\n  border-radius: 12px;\n  overflow: hidden;\n  transition: transform 0.3s ease;\n  color: var(--text-color);\n  display: flex;\n  flex-direction: column;\n}\n\n.blog-post-card:hover {\n  transform: translateY(-6px);\n}\n\n.post-card-image {\n  width: 100%;\n  height: 200px;\n  object-fit: cover;\n}\n\n.post-card-body {\n  padding: 1.5rem;\n  flex-grow: 1;\n}\n\n.post-category {\n  font-size: 0.75rem;\n  color: var(--secondary-text);\n  text-transform: uppercase;\n  margin-bottom: 0.5rem;\n}\n\n.post-title {\n  font-size: 1.25rem;\n  margin: 0.5rem 0;\n}\n\n.post-excerpt {\n  font-size: 0.95rem;\n  color: var(--secondary-text);\n}\n\n.read-more-btn {\n  display: inline-block;\n  margin-top: 1rem;\n  color: var(--accent-color);\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.read-more-btn:hover {\n  text-decoration: underline;\n}\n\n/* Footer */\n.footer {\n  background-color: var(--secondary-bg);\n  color: var(--text-color);\n  padding: 2rem;\n  text-align: center;\n}\n\n.footer a {\n  color: var(--accent-color);\n  text-decoration: none;\n  margin: 0 0.5rem;\n}\n\n.footer a:hover {\n  text-decoration: underline;\n}\n/* Main Admin Container */\n.blog-wrapper {\n  padding: 40px 20px;\n  background-color: #ffffff;\n  min-height: 100vh;\n  font-family: 'Poppins', sans-serif;\n  color: #1f272b;\n}\n\n/* Heading */\n.blog-wrapper h1 {\n  font-size: 32px;\n  margin-bottom: 30px;\n  font-weight: 700;\n  color: #2c3e50;\n}\n\n/* Create Button */\n.blog-btn {\n  display: inline-block;\n  background-color: #2596be;\n  color: #ffffff;\n  padding: 10px 20px;\n  border-radius: 25px;\n  text-decoration: none;\n  font-weight: 600;\n  margin-bottom: 20px;\n  transition: background 0.3s ease;\n}\n\n.blog-btn:hover {\n  background-color: #20789c;\n}\n\n/* Each Post Entry */\n.blog-admin-post {\n  background: #f9f9f9;\n  border: 1px solid #eee;\n  border-radius: 12px;\n  padding: 20px;\n  margin-bottom: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n/* Post Title + Category */\n.blog-admin-post h3 {\n  font-size: 20px;\n  margin-bottom: 8px;\n  color:#fff;\n}\n\n.blog-admin-post p {\n  font-size: 14px;\n  color: #555;\n  margin: 0;\n}\n\n/* Button Group on Right */\n.blog-admin-post .blog-btn {\n  margin-left: 10px;\n  font-size: 14px;\n  padding: 8px 16px;\n}\n\n/* Optional: style Draft label */\n.blog-admin-post h3 span {\n  font-size: 14px;\n  color: #f39c12;\n  margin-left: 10px;\n}\n\n/* Admin Dashboard Wrapper */\n.blog-custom-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  min-height: 100vh;\n  padding: 40px 20px;\n  background-color: #111827; /* Matches your dark theme */\n  color: #ffffff;\n  font-family: 'Poppins', sans-serif;\n}\n\n/* Heading */\n.blog-custom-container h1 {\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin-bottom: 30px;\n  color: #ffffff;\n}\n\n/* Create New Post Button */\n.blog-btn {\n  display: inline-block;\n  background-color: #2596be;\n  color: #ffffff;\n  padding: 10px 20px;\n  border-radius: 25px;\n  font-weight: 600;\n  text-decoration: none;\n  margin: 10px 5px;\n  transition: background-color 0.3s ease;\n}\n\n.blog-btn:hover {\n  background-color: #20789c;\n}\n\n/* Admin Post Container */\n.blog-admin-post {\n  width: 100%;\n  max-width: 800px;\n  background-color: #1f2937;\n  border: 1px solid #374151;\n  border-radius: 12px;\n  padding: 20px;\n  margin-bottom: 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color: #ffffff;\n}\n\n/* Post title */\n.blog-admin-post h3 {\n  font-size: 20px;\n  margin-bottom: 5px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n/* Post category */\n.blog-admin-post p {\n  font-size: 14px;\n  color: #d1d5db;\n  margin: 0;\n}\n\n/* Optional: style Draft label */\n.blog-admin-post h3 span {\n  font-size: 14px;\n  color: #f59e0b; /* orange */\n}\n\n/* Make it responsive */\n@media (max-width: 768px) {\n  .blog-admin-post {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .blog-admin-post > div:last-child {\n    margin-top: 10px;\n  }\n\n  .blog-btn {\n    width: 100%;\n    text-align: center;\n  }\n}\n\n.blog-admin-login-container {\n  background-color: #111827;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  color: #ffffff;\n  padding: 2rem;\n}\n\n.blog-admin-login-container h1 {\n  font-size: 2rem;\n  margin-bottom: 1.5rem;\n  color: #ffffff;\n}\n\n.blog-admin-login-form {\n  background-color: #1F2937;\n  padding: 2rem;\n  border-radius: 12px;\n  width: 100%;\n  max-width: 400px;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);\n}\n\n.blog-admin-login-form input {\n  width: 100%;\n  padding: 12px 15px;\n  margin-bottom: 1rem;\n  border-radius: 8px;\n  border: 1px solid #374151;\n  background-color: #111827;\n  color: #ffffff;\n  font-size: 16px;\n}\n\n.blog-admin-login-form input::placeholder {\n  color: #9CA3AF;\n}\n\n.blog-error-message {\n  color: #f87171;\n  margin-top: 0.5rem;\n  font-size: 14px;\n}\n\n\n\n\n.blog-container {\n  background-color: #111827;\n  min-height: 100vh;\n  padding: 40px 20px;\n  color: #ffffff;\n  font-family: 'Poppins', sans-serif;\n}\n\n.blog-container h1 {\n  font-size: 2rem;\n  margin-bottom: 1.5rem;\n  color: #ffffff;\n  text-align: center;\n}\n\n.blog-form {\n  background-color: #1F2937;\n  padding: 2rem;\n  border-radius: 12px;\n  max-width: 800px;\n  margin: 0 auto;\n  box-shadow: 0 0 12px rgba(0, 0, 0, 0.4);\n}\n\n.blog-form input[type=\"text\"],\n.blog-form input[type=\"file\"] {\n  width: 100%;\n  padding: 0.75rem;\n  margin-bottom: 1rem;\n  background-color: #111827;\n  color: #ffffff;\n  border: 1px solid #374151;\n  border-radius: 8px;\n  font-size: 16px;\n}\n\n.blog-form input::placeholder {\n  color: #9CA3AF;\n}\n\n.ql-toolbar,\n.ql-container {\n  background-color: #1F2937;\n  color: #ffffff;\n  border-color: #374151;\n}\n\n.form-actions {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-top: 1.5rem;\n}\n\n.form-actions button {\n  background-color: #2596be;\n  color: #ffffff;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 8px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.form-actions button:hover {\n  background-color: #1e7ea5;\n}\n\n\n\n\n\n\n\n\n\n\n\n\n/* Layout & Dark Mode Fix */\n.blog-post-layout {\n  display: flex;\n  flex-direction: column;\n  background-color: #111827;\n  color: white;\n  padding-top: 80px;\n}\n\n.blog-main {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 2rem;\n  color: white;\n}\n\n.single-post-hero {\n  margin-bottom: 2rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid #333;\n  text-align: center;\n}\n\n.post-title {\n  font-size: 2.5rem;\n  font-weight: bold;\n  margin-bottom: 0.5rem;\n  color: white;\n}\n\n.post-date,\n.post-author {\n  font-size: 0.95rem;\n  color: #ccc;\n  margin-bottom: 0.2rem;\n}\n\n\n/* Media Styling */\n.blog-post-media {\n  max-width: 100%;\n  height: auto;\n  border-radius: 10px;\n  margin: 2rem 0;\n}\n\n/* Post Content - Rich Text White */\n.post-content,\n.post-content p,\n.post-content span,\n.post-content li,\n.post-content ul,\n.post-content h1,\n.post-content h2,\n.post-content h3 {\n  color: white !important;\n  font-size: 1.1rem;\n  line-height: 1.8;\n}\n\n/* === Full Box for Enquiry Section === */\n.enquiry-box-container {\n  background-color: #1f2937;\n  border: 2px solid #2bb8dd;\n  border-radius: 12px;\n  padding: 2.5rem;\n  margin: 3rem auto;\n  max-width: 800px;\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.25);\n  color: white;\n  text-align: center;\n}\n\n/* === Section Heading === */\n.enquiry-title {\n  font-size: 1.75rem;\n  margin-bottom: 2rem;\n  color: white;\n}\n\n/* === Input Fields === */\n.enquiry-form input,\n.enquiry-form textarea {\n  width: 100%;\n  padding: 14px 20px;\n  margin-bottom: 1rem;\n  border-radius: 25px;\n  background-color: #111827;\n  border: 1px solid #2bb8dd;\n  color: white;\n  font-size: 1rem;\n  display: block;\n}\n\n.enquiry-form input::placeholder,\n.enquiry-form textarea::placeholder {\n  color: #aaa;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.enquiry-form textarea {\n  resize: none;\n  border-radius: 20px;\n}\n\n/* === Submit Button === */\n.blog-btn.send-message {\n  padding: 12px 28px;\n  border-radius: 25px;\n  background-color: #2bb8dd;\n  color: white;\n  font-size: 1rem;\n  font-weight: bold;\n  cursor: pointer;\n  border: none;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);\n  transition: background-color 0.3s ease, transform 0.2s ease;\n  margin-top: 1.5rem;\n}\n\n.blog-btn.send-message:hover {\n  background-color: #2399ba;\n  transform: translateY(-2px);\n}\n\n/* === Responsive Padding for Mobile === */\n@media (max-width: 768px) {\n  .enquiry-box-container {\n    padding: 2rem 1rem;\n  }\n}\n\n\n\n\n\n\n\n\n\n/* Journey Ad */\n.start-journey-ad {\n  border: 2px solid #2bb8dd;\n  border-radius: 10px;\n  padding: 2rem;\n  background-color: #1f2937;\n  color: white;\n  text-align: center;\n}\n\n.start-journey-ad h4 {\n  font-size: 1.5rem;\n  margin-bottom: 0.5rem;\n  color: white;\n}\n\n.start-journey-ad p {\n  color: white;\n}\n\n/* Responsive Fix */\n@media (max-width: 768px) {\n  .phone-group {\n    flex-direction: column;\n  }\n}\n\n\n\n\n\n\n\n\n\n.comment-section {\n  display: flex;\n  justify-content: center;\n  padding: 3rem 1rem;\n  background: transparent;\n}\n\n.comment-box {\n  background-color: #1f2937;\n  border: 2px solid #2bb8dd;\n  border-radius: 12px;\n  padding: 2.5rem;\n  width: 100%;\n  max-width: 800px;\n  color: white;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);\n  transition: box-shadow 0.3s ease;\n}\n\n.comment-box h2 {\n  font-size: 1.75rem;\n  margin-bottom: 1.5rem;\n  text-align: center;\n  color: white;\n}\n\n/* Inputs and textarea */\n.comment-box input,\n.comment-box textarea {\n  width: 100%;\n  padding: 12px 14px;\n  margin-bottom: 1.2rem;\n  border: 1px solid #2bb8dd;\n  border-radius: 8px;\n  background-color: #111827;\n  color: white;\n  font-size: 1rem;\n  transition: border-color 0.3s, background-color 0.3s;\n}\n\n.comment-box input:focus,\n.comment-box textarea:focus {\n  outline: none;\n  border-color: #40d9ff;\n  background-color: #1e293b;\n}\n\n/* Submit Button */\n.comment-box button {\n  background-color: #2bb8dd;\n  color: white;\n  padding: 10px 22px;\n  font-size: 1rem;\n  border: none;\n  border-radius: 25px;\n  cursor: pointer;\n  font-weight: bold;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);\n  transition: background-color 0.3s ease, transform 0.2s ease;\n  display: block;\n  margin: 0 auto; /* ✅ Center the button */\n}\n\n.comment-box button:hover {\n  background-color: #2399ba;\n  transform: translateY(-2px);\n}\n\n\n\n\n\n\n\n\n\n\n\n/* Section container */\n.recent-articles {\n  background-color: #1f2937;\n  border: 2px solid #2bb8dd;\n  border-radius: 10px;\n  padding: 2rem;\n  margin-top: 3rem;\n  text-align: center;\n  position: relative;\n}\n\n/* Title */\n.recent-articles h2 {\n  font-size: 2rem;\n  margin-bottom: 1.5rem;\n  color: white;\n}\n\n/* Article scroll wrapper */\n.articles-wrapper {\n  display: flex;\n  gap: 1rem;\n  overflow-x: auto;\n  scroll-behavior: smooth;\n  padding: 1rem 0;\n  scrollbar-width: none;\n}\n\n.articles-wrapper::-webkit-scrollbar {\n  display: none;\n}\n\n/* Article card */\n.article-card {\n  flex: 0 0 250px;\n  background-color: #111827;\n  border-radius: 10px;\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.25);\n  padding: 1.2rem;\n  color: white;\n  text-align: left;\n  transition: transform 0.3s ease;\n}\n\n.article-card:hover {\n  transform: translateY(-5px);\n}\n\n.article-btn {\n  display: inline-block;\n  margin-top: 1rem;\n  color: #2bb8dd;\n  font-weight: bold;\n  text-decoration: none;\n}\n\n/* Carousel controls */\n.carousel-controls {\n  display: flex;\n  justify-content: center;\n  margin-top: 1.5rem;\n  gap: 1rem;\n}\n\n.carousel-controls button {\n  background-color: #2bb8dd;\n  color: white;\n  padding: 10px 16px;\n  font-size: 1.1rem;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.3);\n  transition: background-color 0.2s ease;\n}\n\n.carousel-controls button:hover {\n  background-color: #2399ba;\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* 🔷 Featured Blog Section */\n.featured-blog {\n  background-color: #1f2937;\n  padding: 3rem 2rem;\n  color: white !important;\n  text-align: center;\n}\n\n.featured-blog h2 {\n  font-size: 2rem;\n  margin-bottom: 2rem;\n  color: white;\n}\n\n.featured-blog .article-card {\n  max-width: 700px;\n  margin: 0 auto;\n  background-color: #111827 !important;\n  border-radius: 12px;\n  padding: 2rem;\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);\n  text-align: left;\n}\n\n.featured-blog .article-card h3 {\n  font-size: 1.5rem;\n  color: white;\n  margin-bottom: 0.5rem;\n}\n\n.featured-blog .article-card p {\n  color: white !important;\n  font-size: 1rem;\n  line-height: 1.6;\n}\n\n\n/* Optional: fading effect if clipped */\n.featured-blog .article-card p::after {\n  content: '';\n  display: block;\n  height: 1rem;\n  background: linear-gradient(to bottom, rgba(17,24,39,0) 0%, rgba(17,24,39,1) 100%);\n  margin-top: -1rem;\n}\n\n/* Button */\n.featured-blog .article-btn {\n  margin-top: 1rem;\n  display: inline-block;\n  background-color: #2bb8dd;\n  color: white;\n  padding: 10px 20px;\n  border-radius: 25px;\n  font-weight: bold;\n  text-decoration: none;\n}\n\n.featured-blog .article-btn:hover {\n  background-color: #2399ba;\n}\n\n/* 🔷 Recent Articles Section */\n.recent-articles {\n  background-color: #1f2937;\n  border: 2px solid #2bb8dd;\n  border-radius: 10px;\n  padding: 2rem;\n  margin: 3rem auto;\n  text-align: center;\n  position: relative;\n  max-width: 1100px;\n}\n\n.recent-articles h2 {\n  font-size: 2rem;\n  margin-bottom: 1.5rem;\n  color: white;\n}\n\n.articles-wrapper {\n  display: flex;\n  gap: 1rem;\n  overflow-x: auto;\n  scroll-snap-type: x mandatory;\n  scroll-behavior: smooth;\n  padding: 1rem 0;\n  scrollbar-width: none;\n}\n\n.articles-wrapper::-webkit-scrollbar {\n  display: none;\n}\n\n.article-card {\n  flex: 0 0 300px;\n  scroll-snap-align: start;\n  background-color: #111827;\n  border-radius: 10px;\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.25);\n  padding: 1.5rem;\n  color: white;\n  text-align: left;\n  transition: transform 0.3s ease;\n  min-width: 250px; /* important for slider feel */\n}\n\n.article-card:hover {\n  transform: translateY(-5px);\n}\n\n\n.article-card h3 {\n  font-size: 1.3rem;\n  margin-bottom: 0.5rem;\n  color: white;\n}\n\n.article-card p {\n  color: #ccc;\n  font-size: 0.95rem;\n  line-height: 1.5;\n}\n\n.article-btn {\n  display: inline-block;\n  margin-top: 1rem;\n  color: #2bb8dd;\n  font-weight: bold;\n  text-decoration: none;\n}\n\n/* Responsive tweaks */\n@media screen and (max-width: 768px) {\n  .articles-wrapper {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .featured-blog .article-card {\n    padding: 1.5rem;\n  }\n}\n.featured-blog, \n.featured-blog * {\n  color: white !important;\n}\n\n.featured-blog p {\n  margin-bottom: 1rem;\n}\n\n/* 🌐 Responsive blog main layout */\n@media screen and (max-width: 768px) {\n  .blog-main {\n    padding: 1.5rem 1rem;\n  }\n\n  .post-title {\n    font-size: 1.8rem;\n  }\n\n  .single-post-hero {\n    padding-bottom: 0.5rem;\n  }\n\n  .post-date,\n  .post-author {\n    font-size: 0.85rem;\n  }\n}\n\n/* 📦 Featured Blog responsive layout */\n@media screen and (max-width: 768px) {\n  .featured-blog {\n    padding: 2rem 1rem;\n  }\n\n  .featured-blog .article-card {\n    padding: 1.5rem;\n  }\n\n  .featured-blog h2 {\n    font-size: 1.6rem;\n  }\n}\n\n/* 📝 Enquiry form responsiveness */\n@media screen and (max-width: 768px) {\n  .enquiry-form input,\n  .enquiry-form textarea {\n    padding: 12px 16px;\n    font-size: 0.95rem;\n  }\n\n  .blog-btn.send-message {\n    font-size: 0.95rem;\n    padding: 10px 20px;\n  }\n}\n\n\n@media screen and (max-width: 768px) {\n  .comment-box {\n    padding: 2rem 1rem;\n  }\n\n  .comment-box h2 {\n    font-size: 1.5rem;\n  }\n\n  .comment-box input,\n  .comment-box textarea {\n    font-size: 0.95rem;\n    padding: 10px 12px;\n  }\n\n  .comment-box button {\n    font-size: 0.95rem;\n    padding: 10px 18px;\n  }\n}\n\n\n@media screen and (max-width: 768px) {\n  .carousel-controls {\n    gap: 0.5rem;\n    margin-top: 1rem;\n  }\n\n  .carousel-controls button {\n    font-size: 1rem;\n    padding: 8px 14px;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .articles-wrapper {\n    flex-wrap: nowrap;\n  }\n\n  .article-card {\n    flex: 0 0 80%;\n    max-width: 80%;\n  }\n\n  .carousel-controls {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n\n  .carousel-controls button {\n    font-size: 0.9rem;\n    padding: 8px 12px;\n    width: 48%;\n    margin: 0 auto;\n  }\n}\n\n@media screen and (max-width: 500px) {\n  .article-card {\n    flex: 0 0 90%;\n    max-width: 90%;\n  }\n}\n/* Hide carousel buttons on small screens */\n@media screen and (max-width: 768px) {\n  .carousel-controls {\n    display: none;\n  }\n}\n@media screen and (min-width: 769px) {\n  .carousel-controls {\n    display: flex;\n    justify-content: center;\n    gap: 1rem;\n    margin-top: 1.5rem;\n  }\n\n  .carousel-controls button {\n    background-color: #2bb8dd;\n    color: white;\n    padding: 10px 16px;\n    font-size: 1.1rem;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    box-shadow: 0 3px 8px rgba(0, 0, 0, 0.3);\n    transition: background-color 0.2s ease;\n  }\n\n  .carousel-controls button:hover {\n    background-color: #2399ba;\n  }\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.ql-editor,\n.ql-editor * {\n  color: #ffffff !important;\n  background-color: #1f2937 !important;\n}\n\n\n.ql-editor.ql-blank::before {\n  color: #aaa !important;\n}\n\n/* Toolbar styling */\n.ql-toolbar {\n  background-color: #111827 !important;\n  border-color: #2bb8dd !important;\n}\n\n.ql-toolbar button {\n  color: #ccc !important;\n  border: none !important;\n  box-shadow: none !important;\n}\n\n.ql-toolbar button:hover,\n.ql-toolbar button.ql-active {\n  color: #2bb8dd !important;\n}\n\n\n\n\n.blog-form input,\n.blog-form button {\n  width: 100%;\n  padding: 12px 18px;\n  margin: 0.8rem 0;\n  font-size: 1rem;\n  border-radius: 8px;\n  background: #111827;\n  color: white;\n  border: 1px solid #2bb8dd;\n}\n\n.blog-form button {\n  background: #2bb8dd;\n  color: white;\n  font-weight: bold;\n  cursor: pointer;\n  border: none !important;\n  box-shadow: none !important;\n}\n\n.blog-form button:hover {\n  background-color: #2399ba;\n}\n\n\n/* ========================= */\n/* 🛠️ ADMIN PANEL POST LIST  */\n/* ========================= */\n\n.blog-custom-container {\n  background-color: #111827;\n  min-height: 100vh;\n  padding: 2rem;\n  color: white;\n}\n\n.blog-admin-post {\n  border: 1px solid #2bb8dd;\n  border-radius: 10px;\n  padding: 1rem;\n  margin-top: 1rem;\n  display: flex;\n  justify-content: space-between;\n  background-color: #1f2937;\n  color: white;\n  flex-wrap: wrap;\n}\n\n/* ✅ Edit & Delete buttons in admin panel */\n.blog-admin-post button,\n.blog-admin-post .blog-btn {\n  background-color: #2bb8dd;\n  color: white;\n  font-weight: bold;\n  padding: 10px 18px;\n  border-radius: 20px;\n  border: none !important;\n  box-shadow: none !important;\n  margin: 0.3rem;\n  cursor: pointer;\n}\n\n.blog-admin-post button:hover,\n.blog-admin-post .blog-btn:hover {\n  background-color: #2399ba;\n}\n\n/* =============== Responsive Breakpoints =============== */\n\n/* Tablets */\n@media screen and (max-width: 1024px) {\n  .blog-post-layout,\n  .blog-main,\n  .enquiry-box-container,\n  .comment-box,\n  .featured-blog .article-card,\n  .blog-custom-container {\n    padding: 1.5rem;\n  }\n\n  .blog-form input,\n  .blog-form button,\n  .ql-editor {\n    font-size: 1rem;\n  }\n}\n\n/* Mobile */\n@media screen and (max-width: 768px) {\n  .hero-content h1 {\n    font-size: 1.5rem;\n  }\n\n  .hero-content p {\n    font-size: 1rem;\n  }\n\n  .featured-blog,\n  .recent-articles,\n  .blog-custom-container {\n    padding: 1.5rem 1rem;\n  }\n\n  .article-card {\n    flex: 0 0 100%;\n  }\n\n  .carousel-controls {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n\n  .blog-admin-post {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .blog-form input,\n  .blog-form button {\n    font-size: 0.95rem;\n    padding: 10px 14px;\n  }\n\n  .form-actions {\n    display: flex;\n    flex-direction: column;\n    gap: 0.8rem;\n  }\n\n  .ql-editor {\n    font-size: 1rem;\n  }\n}\n\n/* Extra Small Devices */\n@media screen and (max-width: 480px) {\n  .blog-btn,\n  .article-btn,\n  .carousel-controls button {\n    width: 100%;\n    font-size: 0.95rem;\n    padding: 10px;\n  }\n\n  .post-title {\n    font-size: 1.8rem;\n  }\n\n  .comment-box,\n  .enquiry-box-container {\n    padding: 1.2rem;\n  }\n\n  .article-card {\n    padding: 1rem;\n  }\n\n  .ql-toolbar {\n    flex-wrap: wrap;\n  }\n\n  .blog-custom-container {\n    padding: 1rem;\n  }\n\n  .editor-heading {\n    font-size: 1.5rem;\n  }\n}\n\n\n\n\n.form-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: space-between;\n  margin-top: 1rem;\n}\n\n@media screen and (max-width: 768px) {\n  .form-actions {\n    flex-direction: column;\n  }\n\n  .form-actions button {\n    width: 100%;\n  }\n}\n\n\n/* Blog Content Styling - Consistent between Blog and Single Post */\n.featured-body,\n.post-content {\n  text-align: left;\n  color: white !important;\n  font-size: 1.1rem;\n  line-height: 1.8;\n  margin-bottom: 2rem;\n}\n\n.featured-body p,\n.post-content p {\n  margin-bottom: 1.5rem;\n  color: #e5e7eb !important;\n  font-size: 1.1rem;\n  line-height: 1.8;\n}\n\n.featured-body h1, \n.featured-body h2, \n.featured-body h3, \n.featured-body h4,\n.post-content h1,\n.post-content h2,\n.post-content h3,\n.post-content h4 {\n  color: white !important;\n  margin: 1.5rem 0 1rem 0;\n  font-weight: 700;\n}\n\n.featured-body h1,\n.post-content h1 {\n  font-size: 2.2rem;\n}\n\n.featured-body h2,\n.post-content h2 {\n  font-size: 1.8rem;\n}\n\n.featured-body h3,\n.post-content h3 {\n  font-size: 1.5rem;\n}\n\n.featured-body h4,\n.post-content h4 {\n  font-size: 1.3rem;\n}\n\n.featured-body ul, \n.featured-body ol,\n.post-content ul,\n.post-content ol {\n  margin-left: 1.5rem;\n  margin-bottom: 1.5rem;\n  padding-left: 1rem;\n}\n\n.featured-body li,\n.post-content li {\n  margin-bottom: 0.5rem;\n  color: #e5e7eb !important;\n}\n\n.featured-body a,\n.post-content a {\n  color: #2bb8dd !important;\n  text-decoration: underline;\n}\n\n.featured-body blockquote,\n.post-content blockquote {\n  border-left: 4px solid #2bb8dd;\n  padding-left: 1rem;\n  margin-left: 0;\n  margin-right: 0;\n  font-style: italic;\n  color: #d1d5db !important;\n}\n\n.featured-body pre,\n.post-content pre {\n  background-color: #1a1e2d;\n  padding: 1rem;\n  border-radius: 5px;\n  overflow-x: auto;\n  margin-bottom: 1.5rem;\n}\n\n.featured-body code,\n.post-content code {\n  font-family: monospace;\n  background-color: #1a1e2d;\n  padding: 0.2rem 0.4rem;\n  border-radius: 3px;\n  font-size: 0.9em;\n}\n\n.featured-body img,\n.post-content img {\n  max-width: 100%;\n  height: auto;\n  border-radius: 8px;\n  margin: 1.5rem 0;\n}\n\n.featured-body table,\n.post-content table {\n  width: 100%;\n  border-collapse: collapse;\n  margin: 1.5rem 0;\n}\n\n.featured-body th, \n.featured-body td,\n.post-content th,\n.post-content td {\n  border: 1px solid #374151;\n  padding: 0.75rem;\n  text-align: left;\n}\n\n.featured-body th,\n.post-content th {\n  background-color: #1f2937;\n}\n\n/* Article cards in recent posts */\n.article-card p {\n  color: #e5e7eb !important;\n  font-size: 1rem;\n  line-height: 1.6;\n  margin-bottom: 1rem;\n}\n\n/* Make sure all content is properly visible */\n.featured-blog, \n.featured-blog * {\n  color: white !important;\n}\n\n.featured-blog p {\n  margin-bottom: 1rem;\n}\n\n/* 🌐 Responsive blog main layout */\n@media screen and (max-width: 768px) {\n  .blog-main {\n    padding: 1.5rem 1rem;\n  }\n\n  .post-title {\n    font-size: 1.8rem;\n  }\n\n  .single-post-hero {\n    padding-bottom: 0.5rem;\n  }\n\n  .post-date,\n  .post-author {\n    font-size: 0.85rem;\n  }\n  \n  .featured-body,\n  .post-content {\n    font-size: 1rem;\n  }\n  \n  .featured-body h1,\n  .post-content h1 {\n    font-size: 1.8rem;\n  }\n  \n  .featured-body h2,\n  .post-content h2 {\n    font-size: 1.5rem;\n  }\n}\n/* Blog Hero Section */\n.blog-hero-section {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  min-height: 60vh;\n  display: flex;\n  align-items: center;\n  position: relative;\n  overflow: hidden;\n}\n\n.blog-hero-section::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.3);\n  z-index: 1;\n}\n\n.blog-hero-overlay {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n.blog-hero-content {\n  text-align: center;\n  color: white;\n}\n\n.blog-hero-title {\n  font-size: 3.5rem;\n  font-weight: 700;\n  margin-bottom: 1.5rem;\n  line-height: 1.2;\n}\n\n.blog-hero-subtitle {\n  font-size: 1.25rem;\n  margin-bottom: 2rem;\n  opacity: 0.9;\n  max-width: 600px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.blog-hero-btn {\n  display: inline-block !important;\n  background: linear-gradient(90deg, #2596be, #3fb6e0) !important;\n  color: var(--text-color) !important;\n  padding: 14px 32px !important;\n  border-radius: 30px !important;\n  font-family: var(--font-family) !important;\n  font-weight: 600 !important;\n  font-size: 14px !important;\n  text-decoration: none !important;\n  transition: all 0.3s ease !important;\n  box-shadow: 0 4px 15px rgba(37, 150, 190, 0.3) !important;\n  border: none !important;\n}\n\n.blog-hero-btn:hover {\n  background: linear-gradient(90deg, #3fb6e0, #2596be) !important;\n  transform: translateY(-3px) !important;\n  box-shadow: 0 6px 22px rgba(37, 150, 190, 0.45) !important;\n  color: var(--text-color) !important;\n  text-decoration: none !important;\n}\n\n\n/* Blog Container */\n.blog-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n/* Loading */\n.blog-loading-container {\n  text-align: center;\n  padding: 4rem 0;\n}\n\n.blog-loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #3fb6e0;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 0 auto 1rem;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Featured Section */\n.blog-featured-section {\n  padding: 4rem 0;\n  background: #f8f9fa;\n  margin: 2rem 0;\n  border-radius: 20px;\n}\n\n.blog-featured-container {\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: 0 2rem;\n}\n\n.blog-featured-content {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 3rem;\n  align-items: center;\n}\n\n.blog-featured-meta {\n  margin-bottom: 1.5rem;\n}\n\n.blog-featured-badge {\n  background: linear-gradient(90deg, #2596be, #3fb6e0) !important;\n  color: white;\n  padding: 8px 16px;\n  border-radius: 20px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  display: inline-block;\n  margin-bottom: 1rem;\n}\n\n.blog-meta-info {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n  font-size: 0.875rem;\n  color: #666;\n}\n\n.blog-featured-title {\n  font-size: 2.5rem;\n  font-weight: 700;\n  line-height: 1.2;\n  margin-bottom: 1.5rem;\n  color: #2d3748;\n}\n\n.blog-featured-excerpt {\n  font-size: 1.125rem;\n  line-height: 1.6;\n  color: #4a5568;\n  margin-bottom: 2rem;\n}\n\n.blog-read-more-btn {\n  display: inline-flex !important;\n  align-items: center !important;\n  gap: 0.5rem !important;\n  background: #3fb6e0 !important;\n  color: white !important;\n  padding: 12px 24px !important;\n  border-radius: 8px !important;\n  text-decoration: none !important;\n  font-weight: 600 !important;\n  transition: all 0.3s ease !important;\n}\n\n.blog-read-more-btn:hover {\n  background: #3fb6e0 !important;\n  transform: translateY(-2px) !important;\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3) !important;\n  color: white !important;\n  text-decoration: none !important;\n}\n\n\n.blog-btn-arrow {\n  transition: transform 0.3s ease;\n}\n\n.blog-read-more-btn:hover .blog-btn-arrow {\n  transform: translateX(4px);\n}\n\n/* Featured Image */\n.blog-featured-image {\n  position: relative;\n}\n\n.blog-featured-img,\n.blog-featured-video {\n  width: 100%;\n  height: 300px;\n  object-fit: cover;\n  border-radius: 12px;\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\n  transition: transform 0.3s ease;\n}\n\n.blog-featured-img:hover,\n.blog-featured-video:hover {\n  transform: scale(1.02);\n}\n\n.blog-featured-placeholder {\n  width: 100%;\n  height: 300px;\n  background: linear-gradient(135deg, #e2e8f0, #cbd5e0);\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\n}\n\n.blog-placeholder-content {\n  text-align: center;\n  color: #718096;\n}\n\n.blog-placeholder-icon {\n  font-size: 3rem;\n  display: block;\n  margin-bottom: 0.5rem;\n}\n\n/* Recent Articles Section */\n.blog-recent-section {\n  padding: 4rem 0;\n}\n\n.blog-section-header {\n  text-align: center;\n  margin-bottom: 3rem;\n}\n\n.blog-section-title {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: #2d3748;\n  margin-bottom: 1rem;\n}\n\n.blog-section-subtitle {\n  font-size: 1.125rem;\n  color: #718096;\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.blog-articles-container {\n  position: relative;\n}\n\n.blog-articles-wrapper {\n  display: flex;\n  gap: 2rem;\n  overflow-x: auto;\n  scroll-behavior: smooth;\n  padding: 1rem 0;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.blog-articles-wrapper::-webkit-scrollbar {\n  display: none;\n}\n\n/* Article Cards */\n.blog-article-card {\n  flex: 0 0 350px;\n  background: white;\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  transition: all 0.3s ease;\n  border: 1px solid #e2e8f0;\n}\n\n.blog-article-card:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);\n}\n\n.blog-card-image {\n  position: relative;\n  height: 200px;\n  overflow: hidden;\n}\n\n.blog-card-img,\n.blog-card-video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.3s ease;\n}\n\n.blog-article-card:hover .blog-card-img,\n.blog-article-card:hover .blog-card-video {\n  transform: scale(1.05);\n}\n\n.blog-card-placeholder {\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(135deg, #f7fafc, #edf2f7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #a0aec0;\n}\n\n.blog-card-placeholder .blog-placeholder-icon {\n  font-size: 2.5rem;\n}\n\n.blog-card-content {\n  padding: 1.5rem;\n}\n\n.blog-card-meta {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n  font-size: 0.875rem;\n  color: #718096;\n}\n\n.blog-card-date {\n  font-weight: 500;\n}\n\n.blog-card-reading-time {\n  background: #edf2f7;\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 0.75rem;\n}\n\n.blog-card-title {\n  font-size: 1.25rem;\n  font-weight: 700;\n  line-height: 1.3;\n  margin-bottom: 0.75rem;\n  color: #2d3748;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.blog-card-category {\n  display: inline-block;\n  background: #3fb6e0;\n  color: white;\n  padding: 4px 12px;\n  border-radius: 16px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  margin-bottom: 1rem;\n}\n\n.blog-card-excerpt {\n  color: #4a5568;\n  line-height: 1.5;\n  margin-bottom: 1.5rem;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.blog-card-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: #3fb6e0;\n  text-decoration: none;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  padding: 8px 0;\n}\n\n.blog-card-btn:hover {\n  color: #5a67d8;\n  text-decoration: none;\n}\n\n.blog-card-btn:hover .blog-btn-arrow {\n  transform: translateX(4px);\n}\n\n/* Carousel Controls */\n.blog-carousel-controls {\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n  margin-top: 2rem;\n}\n\n.blog-carousel-btn {\n  width: 50px;\n  height: 50px;\n  border: none;\n  border-radius: 50%;\n  background: #3fb6e0;\n  color: white;\n  font-size: 1.25rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n}\n\n.blog-carousel-btn:hover {\n  background: #5a67d8;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);\n}\n\n.blog-carousel-btn:active {\n  transform: translateY(0);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .blog-hero-title {\n    font-size: 2.5rem;\n  }\n  \n  .blog-hero-subtitle {\n    font-size: 1rem;\n  }\n  \n  .blog-featured-content {\n    grid-template-columns: 1fr;\n    gap: 2rem;\n  }\n  \n  .blog-featured-title {\n    font-size: 2rem;\n  }\n  \n  .blog-section-title {\n    font-size: 2rem;\n  }\n  \n  .blog-article-card {\n    flex: 0 0 280px;\n  }\n  \n  .blog-container {\n    padding: 0 15px;\n  }\n}\n\n@media (max-width: 480px) {\n  .blog-hero-title {\n    font-size: 2rem;\n  }\n  \n  .blog-featured-title {\n    font-size: 1.75rem;\n  }\n  \n  .blog-section-title {\n    font-size: 1.75rem;\n  }\n  \n  .blog-article-card {\n    flex: 0 0 250px;\n  }\n  \n  .blog-featured-container {\n    padding: 0 1rem;\n  }\n}\n\n/* Additional Animations */\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.blog-article-card {\n  animation: fadeInUp 0.6s ease forwards;\n}\n\n.blog-article-card:nth-child(2) {\n  animation-delay: 0.1s;\n}\n\n.blog-article-card:nth-child(3) {\n  animation-delay: 0.2s;\n}\n\n.blog-article-card:nth-child(4) {\n  animation-delay: 0.3s;\n}\n\n/* Smooth scrolling for the entire page */\nhtml {\n  scroll-behavior: smooth;\n}\n\n/* Focus states for accessibility */\n.blog-hero-btn:focus,\n.blog-read-more-btn:focus,\n.blog-card-btn:focus,\n.blog-carousel-btn:focus {\n  outline: 2px solid #3fb6e0;\n  outline-offset: 2px;\n}\n/* Blog Hero Section */\n.blog-hero-section {\n  background: linear-gradient(135deg, #1a202c 0%, #2d3748 100%);\n  min-height: 60vh;\n  display: flex;\n  align-items: center;\n  position: relative;\n  overflow: hidden;\n}\n\n.blog-hero-section::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 1;\n}\n\n.blog-hero-overlay {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n.blog-hero-content {\n  text-align: center;\n  color: white;\n}\n\n.blog-hero-title {\n  font-size: 3.5rem;\n  font-weight: 700;\n  margin-bottom: 1.5rem;\n  line-height: 1.2;\n  color: #ffffff;\n}\n\n.blog-hero-subtitle {\n  font-size: 1.25rem;\n  margin-bottom: 2rem;\n  opacity: 0.9;\n  max-width: 600px;\n  margin-left: auto;\n  margin-right: auto;\n  color: #e2e8f0;\n}\n\n.blog-hero-btn {\n  display: inline-block;\n  background: #3fb6e0;\n  color: white;\n  padding: 15px 30px;\n  border-radius: 50px;\n  text-decoration: none;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);\n}\n\n.blog-hero-btn:hover {\n  background: #5a67d8;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);\n  color: white;\n  text-decoration: none;\n}\n\n/* Blog Container */\n.blog-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n  background: #111827;\n  min-height: 100vh;\n}\n\n/* Loading */\n.blog-loading-container {\n  text-align: center;\n  padding: 4rem 0;\n  color: #e2e8f0;\n}\n\n.blog-loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #374151;\n  border-top: 4px solid #3fb6e0;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 0 auto 1rem;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Featured Section */\n.blog-featured-section {\n  padding: 4rem 0;\n  background: #1f2937;\n  margin: 2rem 0;\n  border-radius: 20px;\n  border: 1px solid #374151;\n}\n\n.blog-featured-container {\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: 0 2rem;\n}\n\n.blog-featured-content {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 3rem;\n  align-items: center;\n}\n\n.blog-featured-meta {\n  margin-bottom: 1.5rem;\n}\n\n.blog-featured-badge {\n  background: linear-gradient(135deg, #667eea, #764ba2);\n  color: white;\n  padding: 8px 16px;\n  border-radius: 20px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  display: inline-block;\n  margin-bottom: 1rem;\n}\n\n.blog-meta-info {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n  font-size: 0.875rem;\n  color: #9ca3af;\n}\n\n.blog-featured-title {\n  font-size: 2.5rem;\n  font-weight: 700;\n  line-height: 1.2;\n  margin-bottom: 1.5rem;\n  color: #ffffff;\n}\n\n.blog-featured-excerpt {\n  font-size: 1.125rem;\n  line-height: 1.6;\n  color: #d1d5db;\n  margin-bottom: 2rem;\n}\n\n.blog-read-more-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  background: #3fb6e0;\n  color: white;\n  padding: 12px 24px;\n  border-radius: 8px;\n  text-decoration: none;\n  font-weight: 600;\n  transition: all 0.3s ease;\n}\n\n.blog-read-more-btn:hover {\n  background: #5a67d8;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\n  color: white;\n  text-decoration: none;\n}\n\n.blog-btn-arrow {\n  transition: transform 0.3s ease;\n}\n\n.blog-read-more-btn:hover .blog-btn-arrow {\n  transform: translateX(4px);\n}\n\n/* Featured Image */\n.blog-featured-image {\n  position: relative;\n}\n\n.blog-featured-img,\n.blog-featured-video {\n  width: 100%;\n  height: 300px;\n  object-fit: cover;\n  border-radius: 12px;\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);\n  transition: transform 0.3s ease;\n  border: 1px solid #374151;\n}\n\n.blog-featured-img:hover,\n.blog-featured-video:hover {\n  transform: scale(1.02);\n}\n\n.blog-featured-placeholder {\n  width: 100%;\n  height: 300px;\n  background: linear-gradient(135deg, #374151, #4b5563);\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);\n  border: 1px solid #6b7280;\n}\n\n.blog-placeholder-content {\n  text-align: center;\n  color: #9ca3af;\n}\n\n.blog-placeholder-icon {\n  font-size: 3rem;\n  display: block;\n  margin-bottom: 0.5rem;\n}\n\n/* Recent Articles Section */\n.blog-recent-section {\n  padding: 4rem 0;\n}\n\n.blog-section-header {\n  text-align: center;\n  margin-bottom: 3rem;\n}\n\n.blog-section-title {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: #ffffff;\n  margin-bottom: 1rem;\n}\n\n.blog-section-subtitle {\n  font-size: 1.125rem;\n  color: #9ca3af;\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.blog-articles-container {\n  position: relative;\n}\n\n.blog-articles-wrapper {\n  display: flex;\n  gap: 2rem;\n  overflow-x: auto;\n  scroll-behavior: smooth;\n  padding: 1rem 0;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.blog-articles-wrapper::-webkit-scrollbar {\n  display: none;\n}\n\n/* Article Cards - Black Theme */\n.blog-article-card {\n  flex: 0 0 350px;\n  background: #1f2937;\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\n  transition: all 0.3s ease;\n  border: 1px solid #374151;\n}\n\n.blog-article-card:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.5);\n  border-color: #3fb6e0;\n}\n\n.blog-card-image {\n  position: relative;\n  height: 200px;\n  overflow: hidden;\n}\n\n.blog-card-img,\n.blog-card-video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.3s ease;\n}\n\n.blog-article-card:hover .blog-card-img,\n.blog-article-card:hover .blog-card-video {\n  transform: scale(1.05);\n}\n\n.blog-card-placeholder {\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(135deg, #374151, #4b5563);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #9ca3af;\n}\n\n.blog-card-placeholder .blog-placeholder-icon {\n  font-size: 2.5rem;\n}\n\n.blog-card-content {\n  padding: 1.5rem;\n  background: #1f2937;\n}\n\n.blog-card-meta {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n  font-size: 0.875rem;\n  color: #9ca3af;\n}\n\n.blog-card-date {\n  font-weight: 500;\n  color: #d1d5db;\n}\n\n.blog-card-reading-time {\n  background: #374151;\n  color: #e5e7eb;\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 0.75rem;\n}\n\n.blog-card-title {\n  font-size: 1.25rem;\n  font-weight: 700;\n  line-height: 1.3;\n  margin-bottom: 0.75rem;\n  color: #ffffff;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.blog-card-category {\n  display: inline-block;\n  background: #3fb6e0;\n  color: white;\n  padding: 4px 12px;\n  border-radius: 16px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  margin-bottom: 1rem;\n}\n\n.blog-card-excerpt {\n  color: #d1d5db;\n  line-height: 1.5;\n  margin-bottom: 1.5rem;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.blog-card-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: #3fb6e0;\n  text-decoration: none;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  padding: 8px 0;\n}\n\n.blog-card-btn:hover {\n  color: #818cf8;\n  text-decoration: none;\n}\n\n.blog-card-btn:hover .blog-btn-arrow {\n  transform: translateX(4px);\n}\n\n/* Carousel Controls */\n.blog-carousel-controls {\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n  margin-top: 2rem;\n}\n\n.blog-carousel-btn {\n  width: 50px;\n  height: 50px;\n  border: none;\n  border-radius: 50%;\n  background: #374151;\n  color: #e5e7eb;\n  font-size: 1.25rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n  border: 1px solid #4b5563;\n}\n\n.blog-carousel-btn:hover {\n  background: #3fb6e0;\n  color: white;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);\n  border-color: #3fb6e0;\n}\n\n.blog-carousel-btn:active {\n  transform: translateY(0);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .blog-hero-title {\n    font-size: 2.5rem;\n  }\n  \n  .blog-hero-subtitle {\n    font-size: 1rem;\n  }\n  \n  .blog-featured-content {\n    grid-template-columns: 1fr;\n    gap: 2rem;\n  }\n  \n  .blog-featured-title {\n    font-size: 2rem;\n  }\n  \n  .blog-section-title {\n    font-size: 2rem;\n  }\n  \n  .blog-article-card {\n    flex: 0 0 280px;\n  }\n  \n  .blog-container {\n    padding: 0 15px;\n  }\n}\n\n@media (max-width: 480px) {\n  .blog-hero-title {\n    font-size: 2rem;\n  }\n  \n  .blog-featured-title {\n    font-size: 1.75rem;\n  }\n  \n  .blog-section-title {\n    font-size: 1.75rem;\n  }\n  \n  .blog-article-card {\n    flex: 0 0 250px;\n  }\n  \n  .blog-featured-container {\n    padding: 0 1rem;\n  }\n}\n\n/* Additional Animations */\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.blog-article-card {\n  animation: fadeInUp 0.6s ease forwards;\n}\n\n.blog-article-card:nth-child(2) {\n  animation-delay: 0.1s;\n}\n\n.blog-article-card:nth-child(3) {\n  animation-delay: 0.2s;\n}\n\n.blog-article-card:nth-child(4) {\n  animation-delay: 0.3s;\n}\n\n/* Smooth scrolling for the entire page */\nhtml {\n  scroll-behavior: smooth;\n}\n\n/* Focus states for accessibility */\n.blog-hero-btn:focus,\n.blog-read-more-btn:focus,\n.blog-card-btn:focus,\n.blog-carousel-btn:focus {\n  outline: 2px solid #3fb6e0;\n  outline-offset: 2px;\n}\n\n/* Additional Black Theme Enhancements */\n\n/* Ensure the entire blog page has dark background */\n.blog-page-wrapper {\n  background-color: #111827;\n  min-height: 100vh;\n}\n\n/* Dark theme for text selections */\n::selection {\n  background-color: #3fb6e0;\n  color: white;\n}\n\n::-moz-selection {\n  background-color: #3fb6e0;\n  color: white;\n}\n\n/* Enhanced card hover effects for dark theme */\n.blog-article-card:hover {\n  background: #374151;\n  border-color: #3fb6e0;\n  box-shadow: 0 12px 40px rgba(102, 126, 234, 0.2);\n}\n\n/* Dark theme scrollbar for webkit browsers */\n.blog-articles-wrapper::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n.blog-articles-wrapper::-webkit-scrollbar-track {\n  background: #1f2937;\n  border-radius: 4px;\n}\n\n.blog-articles-wrapper::-webkit-scrollbar-thumb {\n  background: #4b5563;\n  border-radius: 4px;\n}\n\n.blog-articles-wrapper::-webkit-scrollbar-thumb:hover {\n  background: #6b7280;\n}\n\n/* Enhanced gradient for featured section */\n.blog-featured-section {\n  background: linear-gradient(135deg, #1f2937 0%, #111827 100%);\n  border: 1px solid #374151;\n  position: relative;\n}\n\n.blog-featured-section::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: radial-gradient(circle at 50% 50%, rgba(102, 126, 234, 0.05) 0%, transparent 70%);\n  pointer-events: none;\n}\n\n/* Enhanced button styles for dark theme */\n.blog-hero-btn,\n.blog-read-more-btn {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);\n}\n\n.blog-hero-btn:hover,\n.blog-read-more-btn:hover {\n  background: linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%);\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);\n}\n\n/* Dark theme for date and meta information */\n.blog-date,\n.blog-reading-time,\n.blog-category {\n  color: #9ca3af;\n}\n\n.blog-category {\n  background: #374151;\n  color: #e5e7eb;\n  border: 1px solid #4b5563;\n}\n\n/* Enhanced placeholder styles */\n.blog-featured-placeholder,\n.blog-card-placeholder {\n  background: linear-gradient(135deg, #374151 0%, #1f2937 100%);\n  border: 2px dashed #4b5563;\n}\n\n.blog-placeholder-content p {\n  color: #6b7280;\n  font-weight: 500;\n}\n\n/* Loading spinner dark theme */\n.blog-loading-container {\n  background: #111827;\n}\n\n.blog-loading-container p {\n  color: #9ca3af;\n  font-size: 1.1rem;\n}\n\n/* Enhanced typography for dark theme */\n.blog-hero-title {\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.blog-section-title {\n  background: linear-gradient(135deg, #ffffff 0%, #e5e7eb 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n/* Card content enhancements */\n.blog-card-content {\n  position: relative;\n}\n\n.blog-card-content::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background: linear-gradient(90deg, transparent 0%, #4b5563 50%, transparent 100%);\n}\n\n/* Enhanced meta information styling */\n.blog-meta-info span {\n  padding: 4px 8px;\n  background: #374151;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  border: 1px solid #4b5563;\n}\n\n.blog-card-meta {\n  border-bottom: 1px solid #374151;\n  padding-bottom: 0.75rem;\n  margin-bottom: 1rem;\n}\n\n/* Improved accessibility and contrast */\n.blog-card-title:hover {\n  color: #f3f4f6;\n}\n\n.blog-featured-title:hover {\n  color: #f9fafb;\n}\n\n/* Enhanced animation for cards */\n@keyframes cardGlow {\n  0% {\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\n  }\n  50% {\n    box-shadow: 0 8px 30px rgba(102, 126, 234, 0.2);\n  }\n  100% {\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\n  }\n}\n\n.blog-article-card:hover {\n  animation: cardGlow 2s ease-in-out infinite;\n}\n\n/* Dark theme for form elements if any */\n\n\n\n/* Enhanced mobile responsiveness for dark theme */\n@media (max-width: 768px) {\n  .blog-container {\n    background: #111827;\n  }\n  \n  .blog-featured-section {\n    margin: 1rem 0;\n    border-radius: 12px;\n  }\n  \n  .blog-article-card {\n    background: #1f2937;\n    border: 1px solid #374151;\n  }\n}\n\n@media (max-width: 480px) {\n  .blog-hero-section {\n    background: linear-gradient(135deg, #111827 0%, #1f2937 100%);\n  }\n  \n  .blog-carousel-controls {\n    gap: 0.5rem;\n  }\n  \n  .blog-carousel-btn {\n    width: 40px;\n    height: 40px;\n    font-size: 1rem;\n  }\n}\n\n/* Print styles for dark theme */\n@media print {\n  .blog-container,\n  .blog-article-card,\n  .blog-featured-section {\n    background: white !important;\n    color: black !important;\n    border: 1px solid #ccc !important;\n  }\n  \n  .blog-carousel-controls {\n    display: none;\n  }\n}\n/* Add this to your existing App.css file */\n\n/* Professional Comments Section Styling */\n.comment-section {\n  display: flex;\n  justify-content: center;\n  padding: 3rem 1rem;\n  background: transparent;\n}\n\n.comment-box {\n  background-color: #1f2937;\n  border: 2px solid #2bb8dd;\n  border-radius: 16px;\n  padding: 2.5rem;\n  width: 100%;\n  max-width: 900px;\n  color: white;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n  transition: box-shadow 0.3s ease;\n}\n\n.comment-box:hover {\n  box-shadow: 0 15px 40px rgba(43, 184, 221, 0.2);\n}\n\n.comment-box h3 {\n  font-size: 1.8rem;\n  margin-bottom: 2rem;\n  text-align: center;\n  color: white;\n  font-weight: 700;\n  position: relative;\n}\n\n.comment-box h3::after {\n  content: '';\n  position: absolute;\n  bottom: -10px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 60px;\n  height: 3px;\n  background: linear-gradient(90deg, #2bb8dd, #667eea);\n  border-radius: 2px;\n}\n\n/* Comment Form Styling */\n.comment-form {\n  margin-bottom: 3rem;\n  padding-bottom: 2rem;\n  border-bottom: 1px solid #374151;\n}\n\n.comment-form input,\n.comment-form textarea {\n  width: 100%;\n  padding: 14px 18px;\n  margin-bottom: 1.2rem;\n  border: 1px solid #374151;\n  border-radius: 12px;\n  background-color: #111827;\n  color: white;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n  font-family: 'Poppins', sans-serif;\n}\n\n.comment-form input:focus,\n.comment-form textarea:focus {\n  outline: none;\n  border-color: #2bb8dd;\n  background-color: #1e293b;\n  box-shadow: 0 0 0 3px rgba(43, 184, 221, 0.1);\n}\n\n.comment-form input::placeholder,\n.comment-form textarea::placeholder {\n  color: #9ca3af;\n}\n\n.comment-form textarea {\n  min-height: 120px;\n  resize: vertical;\n}\n\n.comment-form button {\n  background: linear-gradient(135deg, #2bb8dd 0%, #667eea 100%);\n  color: white;\n  padding: 12px 30px;\n  font-size: 1rem;\n  border: none;\n  border-radius: 25px;\n  cursor: pointer;\n  font-weight: 600;\n  box-shadow: 0 4px 15px rgba(43, 184, 221, 0.3);\n  transition: all 0.3s ease;\n  display: block;\n  margin: 0 auto;\n  min-width: 140px;\n}\n\n.comment-form button:hover:not(:disabled) {\n  background: linear-gradient(135deg, #2399ba 0%, #5a67d8 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(43, 184, 221, 0.4);\n}\n\n.comment-form button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Comments List Styling */\n.comments-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.comment-item {\n  background: linear-gradient(135deg, #111827 0%, #1e293b 100%);\n  border: 1px solid #374151;\n  border-radius: 16px;\n  padding: 1.8rem;\n  margin-bottom: 1.5rem;\n  position: relative;\n  transition: all 0.3s ease;\n  overflow: hidden;\n}\n\n.comment-item::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 4px;\n  height: 100%;\n  background: linear-gradient(180deg, #2bb8dd 0%, #667eea 100%);\n  border-radius: 0 2px 2px 0;\n}\n\n.comment-item:hover {\n  border-color: #2bb8dd;\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(43, 184, 221, 0.15);\n}\n\n.comment-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.comment-author {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.comment-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #2bb8dd 0%, #667eea 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  font-size: 1.1rem;\n  color: white;\n  text-transform: uppercase;\n  box-shadow: 0 3px 10px rgba(43, 184, 221, 0.3);\n}\n\n.comment-author-info {\n  display: flex;\n  flex-direction: column;\n}\n\n.comment-author-name {\n  font-weight: 600;\n  color: #ffffff;\n  font-size: 1.1rem;\n  margin: 0;\n}\n\n.comment-author-email {\n  font-size: 0.85rem;\n  color: #9ca3af;\n  margin: 0;\n}\n\n.comment-meta {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.comment-date {\n  font-size: 0.85rem;\n  color: #6b7280;\n  background: #374151;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-weight: 500;\n}\n\n.comment-badge {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  color: white;\n  padding: 4px 10px;\n  border-radius: 12px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n/* Update existing comment content font size */\n.comment-content {\n  color: #e5e7eb;\n  line-height: 1.7;\n  font-size: 1.5rem !important; /* Increased from 1rem */\n  margin: 0;\n  word-wrap: break-word;\n  font-weight: 400;\n}\n\n\n.comment-actions {\n  margin-top: 1.2rem;\n  padding-top: 1rem;\n  border-top: 1px solid #374151;\n  display: flex;\n  gap: 1rem;\n}\n\n.comment-action-btn {\n  background: transparent;\n  border: 1px solid #4b5563;\n  color: #9ca3af;\n  padding: 6px 14px;\n  border-radius: 20px;\n  font-size: 0.85rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.comment-action-btn:hover {\n  border-color: #2bb8dd;\n  color: #2bb8dd;\n  background: rgba(43, 184, 221, 0.1);\n}\n\n/* Empty State */\n.comments-empty {\n  text-align: center;\n  padding: 3rem 1rem;\n  color: #6b7280;\n}\n\n.comments-empty-icon {\n  font-size: 3rem;\n  margin-bottom: 1rem;\n  opacity: 0.5;\n}\n\n.comments-empty-text {\n  font-size: 1.1rem;\n  margin-bottom: 0.5rem;\n}\n\n.comments-empty-subtext {\n  font-size: 0.9rem;\n  opacity: 0.7;\n}\n\n/* Error Message Styling */\n.error-message {\n  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);\n  color: white;\n  padding: 12px 18px;\n  border-radius: 10px;\n  margin-bottom: 1.5rem;\n  font-weight: 500;\n  border: 1px solid #f87171;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.error-message::before {\n  content: '⚠️';\n  font-size: 1.2rem;\n}\n\n/* Success Message */\n.success-message {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  color: white;\n  padding: 12px 18px;\n  border-radius: 10px;\n  margin-bottom: 1.5rem;\n  font-weight: 500;\n  border: 1px solid #34d399;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.success-message::before {\n  content: '✅';\n  font-size: 1.2rem;\n}\n\n/* Login Prompt Styling */\n.login-prompt {\n  text-align: center;\n  padding: 3rem 2rem;\n  background: linear-gradient(135deg, #374151 0%, #1f2937 100%);\n  border-radius: 16px;\n  border: 2px dashed #4b5563;\n}\n\n.login-prompt-icon {\n  font-size: 3rem;\n  margin-bottom: 1rem;\n  color: #6b7280;\n}\n\n.login-prompt-text {\n  font-size: 1.2rem;\n  color: #d1d5db;\n  margin-bottom: 1rem;\n}\n\n.login-prompt a {\n  color: #2bb8dd;\n  text-decoration: none;\n  font-weight: 600;\n  padding: 10px 20px;\n  border: 2px solid #2bb8dd;\n  border-radius: 25px;\n  transition: all 0.3s ease;\n  display: inline-block;\n  margin-top: 1rem;\n}\n\n.login-prompt a:hover {\n  background: #2bb8dd;\n  color: white;\n  transform: translateY(-2px);\n  box-shadow: 0 5px 15px rgba(43, 184, 221, 0.3);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .comment-box {\n    padding: 1.5rem;\n    margin: 1rem;\n  }\n\n  .comment-box h3 {\n    font-size: 1.5rem;\n  }\n\n  .comment-item {\n    padding: 1.2rem;\n  }\n\n  .comment-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.75rem;\n  }\n\n  .comment-meta {\n    align-self: stretch;\n    justify-content: space-between;\n  }\n\n  .comment-avatar {\n    width: 35px;\n    height: 35px;\n    font-size: 1rem;\n  }\n\n  .comment-actions {\n    flex-wrap: wrap;\n  }\n\n  .comment-form input,\n  .comment-form textarea {\n    font-size: 0.95rem;\n    padding: 12px 16px;\n  }\n\n  .comment-form button {\n    width: 100%;\n    padding: 14px;\n  }\n}\n\n@media (max-width: 480px) {\n  .comment-box {\n    padding: 1rem;\n    border-radius: 12px;\n  }\n\n  .comment-item {\n    padding: 1rem;\n    border-radius: 12px;\n  }\n\n  .comment-author {\n    gap: 0.5rem;\n  }\n\n  .comment-avatar {\n    width: 32px;\n    height: 32px;\n    font-size: 0.9rem;\n  }\n\n  .comment-author-name {\n    font-size: 1rem;\n  }\n\n  .comment-content {\n    font-size: 0.95rem;\n  }\n}\n\n/* Animation for new comments */\n@keyframes slideInComment {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.comment-item.new-comment {\n  animation: slideInComment 0.5s ease-out;\n}\n\n/* Loading state for comments */\n.comments-loading {\n  text-align: center;\n  padding: 2rem;\n  color: #6b7280;\n}\n\n.comments-loading-spinner {\n  width: 30px;\n  height: 30px;\n  border: 3px solid #374151;\n  border-top: 3px solid #2bb8dd;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 0 auto 1rem;\n}\n/* Reply and Edit Form Styles */\n.reply-form, .edit-form {\n  margin-top: 1rem;\n  padding: 1rem;\n  background: #0f172a;\n  border-radius: 12px;\n  border: 1px solid #334155;\n}\n\n.reply-textarea, .edit-textarea {\n  width: 100%;\n  min-height: 80px;\n  padding: 12px;\n  border: 1px solid #374151;\n  border-radius: 8px;\n  background-color: #111827;\n  color: white;\n  font-size: 0.9rem;\n  resize: vertical;\n  margin-bottom: 0.75rem;\n}\n\n.reply-textarea:focus, .edit-textarea:focus {\n  outline: none;\n  border-color: #2bb8dd;\n  box-shadow: 0 0 0 2px rgba(43, 184, 221, 0.1);\n}\n\n.reply-actions, .edit-actions {\n  display: flex;\n  gap: 0.75rem;\n}\n\n.reply-btn, .save-btn {\n  background: linear-gradient(135deg, #2bb8dd 0%, #667eea 100%);\n  color: white;\n  padding: 8px 16px;\n  border: none;\n  border-radius: 6px;\n  font-size: 0.85rem;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.reply-btn:hover, .save-btn:hover {\n  background: linear-gradient(135deg, #2399ba 0%, #5a67d8 100%);\n}\n\n.cancel-btn {\n  background: transparent;\n  color: #9ca3af;\n  padding: 8px 16px;\n  border: 1px solid #4b5563;\n  border-radius: 6px;\n  font-size: 0.85rem;\n  cursor: pointer;\n}\n\n.cancel-btn:hover {\n  background: #374151;\n  color: white;\n}\n\n.reply-comment {\n  margin-left: 2rem;\n  border-left: 3px solid #2bb8dd;\n  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);\n}\n\n.reply-indicator {\n  color: #2bb8dd;\n  font-size: 0.8rem;\n  margin-left: 0.5rem;\n  font-weight: 500;\n}\n\n@media (max-width: 768px) {\n  .reply-comment {\n    margin-left: 1rem;\n  }\n  \n  .reply-actions, .edit-actions {\n    flex-direction: column;\n  }\n  \n  .reply-btn, .save-btn, .cancel-btn {\n    width: 100%;\n  }\n}\n.comment-action-btn.liked {\n  color: #ef4444;\n  border-color: #ef4444;\n  background: rgba(239, 68, 68, 0.1);\n}\n\n.comment-action-btn.delete-btn {\n  color: #ef4444;\n  border-color: #ef4444;\n}\n\n.comment-action-btn.delete-btn:hover {\n  background: rgba(239, 68, 68, 0.1);\n  color: #ef4444;\n}\n\n.comment-action-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Replies Container Styling */\n.replies-container {\n  margin-top: 1.5rem;\n  padding-left: 1rem;\n  border-left: 3px solid #2bb8dd;\n  background: linear-gradient(135deg, rgba(15, 23, 42, 0.5) 0%, rgba(30, 41, 59, 0.3) 100%);\n  border-radius: 0 12px 12px 0;\n  padding: 1rem 0 1rem 1.5rem;\n}\n\n.replies-header {\n  margin-bottom: 1rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid #334155;\n}\n\n.replies-count {\n  color: #2bb8dd;\n  font-weight: 600;\n  font-size: 0.9rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.replies-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.reply-item {\n  background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);\n  border: 1px solid #334155;\n  border-radius: 12px;\n  padding: 1.2rem;\n  margin-bottom: 1rem;\n  position: relative;\n  transition: all 0.3s ease;\n}\n\n.reply-item::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 3px;\n  height: 100%;\n  background: linear-gradient(180deg, #10b981 0%, #059669 100%);\n  border-radius: 0 2px 2px 0;\n}\n\n.reply-item:hover {\n  border-color: #10b981;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 15px rgba(16, 185, 129, 0.15);\n}\n\n.reply-avatar {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;\n  width: 35px !important;\n  height: 35px !important;\n  font-size: 0.9rem !important;\n}\n\n.reply-indicator {\n  color: #10b981;\n  font-size: 0.8rem;\n  margin-left: 0.5rem;\n  font-weight: 500;\n}\n\n/* Update form font sizes */\n.comment-form input,\n.comment-form textarea,\n.reply-textarea,\n.edit-textarea {\n  font-size: 1rem; /* Increased from 0.9rem */\n}\n\n.comment-form textarea {\n  font-size: 1rem; /* Increased */\n}\n\n/* Update author name font size */\n.comment-author-name {\n  font-weight: 600;\n  color: #ffffff;\n  font-size: 1.15rem; /* Increased from 1.1rem */\n  margin: 0;\n}\n\n.comment-author-email {\n  font-size: 0.9rem; /* Increased from 0.85rem */\n  color: #9ca3af;\n  margin: 0;\n}\n\n/* Update action buttons font size */\n.comment-action-btn {\n  font-size: 0.9rem; /* Increased from 0.85rem */\n}\n\n/* Update date font size */\n.comment-date {\n  font-size: 0.9rem; /* Increased from 0.85rem */\n  color: #6b7280;\n  background: #374151;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-weight: 500;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .replies-container {\n    padding-left: 0.75rem;\n    margin-left: 0.5rem;\n  }\n  \n  .reply-item {\n    padding: 1rem;\n  }\n  \n  .comment-content {\n    font-size: 1rem;\n  }\n  \n  .comment-author-name {\n    font-size: 1.05rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .replies-container {\n    padding-left: 0.5rem;\n    margin-left: 0.25rem;\n  }\n  \n  .comment-content {\n    font-size: 0.95rem;\n  }\n  \n  .comment-author-name {\n    font-size: 1rem;\n  }\n}\n/* Single Post Page Styling */\n.blog-post-layout {\n  background: #000000;\n  min-height: 100vh;\n  color: #ffffff;\n}\n\n.blog-main {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0;\n}\n\n/* Loading State */\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  background: #000000;\n  color: #ffffff;\n}\n\n.loading-spinner {\n  width: 50px;\n  height: 50px;\n  border: 4px solid #1a1a1a;\n  border-top: 4px solid #2bb8dd;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 1rem;\n}\n\n.loading-text {\n  font-size: 1.1rem;\n  color: #9ca3af;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Hero Section */\n.single-post-hero {\n  position: relative;\n  padding: 4rem 2rem 3rem;\n  background: linear-gradient(135deg, #000000 0%, #1a1a1a 50%, #000000 100%);\n  text-align: center;\n  overflow: hidden;\n}\n\n.hero-content {\n  position: relative;\n  z-index: 2;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.post-category {\n  margin-bottom: 1.5rem;\n}\n\n.category-badge {\n  background: linear-gradient(135deg, #2bb8dd 0%, #667eea 100%);\n  color: white;\n  padding: 8px 20px;\n  border-radius: 25px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  box-shadow: 0 4px 15px rgba(43, 184, 221, 0.3);\n}\n\n.post-title {\n  font-size: clamp(2rem, 5vw, 3.5rem);\n  font-weight: 800;\n  line-height: 1.2;\n  margin: 1.5rem 0;\n  background: linear-gradient(135deg, #ffffff 0%, #e5e7eb 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.post-meta {\n  display: flex;\n  justify-content: center;\n  gap: 2rem;\n  margin-top: 2rem;\n  flex-wrap: wrap;\n}\n\n.meta-item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: #9ca3af;\n  font-size: 0.95rem;\n}\n\n.meta-icon {\n  font-size: 1.1rem;\n}\n\n.hero-gradient {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: radial-gradient(circle at center, rgba(43, 184, 221, 0.1) 0%, transparent 70%);\n  pointer-events: none;\n}\n\n/* Media Section */\n.post-media-container {\n  position: relative;\n  margin: 2rem auto;\n  max-width: 1000px;\n  border-radius: 20px;\n  overflow: hidden;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);\n}\n\n.blog-post-media {\n  width: 100%;\n  height: auto;\n  max-height: 500px;\n  object-fit: cover;\n  display: block;\n  transition: transform 0.3s ease;\n}\n\n.blog-post-media:hover {\n  transform: scale(1.02);\n}\n\n.media-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(45deg, rgba(43, 184, 221, 0.1) 0%, rgba(102, 126, 234, 0.1) 100%);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.post-media-container:hover .media-overlay {\n  opacity: 1;\n}\n\n/* Content Section */\n.post-content-wrapper {\n  padding: 3rem 2rem;\n  background: linear-gradient(180deg, #000000 0%, #0a0a0a 100%);\n}\n\n.post-content-container {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.post-content {\n  font-size: 1.15rem;\n  line-height: 1.8;\n  color: #e5e7eb;\n  margin-bottom: 3rem;\n}\n\n.post-content h1,\n.post-content h2,\n.post-content h3,\n.post-content h4,\n.post-content h5,\n.post-content h6 {\n  color: #ffffff;\n  margin: 2rem 0 1rem;\n  font-weight: 700;\n}\n\n.post-content h2 {\n  font-size: 1.8rem;\n  border-bottom: 2px solid #2bb8dd;\n  padding-bottom: 0.5rem;\n}\n\n.post-content h3 {\n  font-size: 1.5rem;\n  color: #2bb8dd;\n}\n\n.post-content p {\n  margin-bottom: 1.5rem;\n}\n\n.post-content a {\n  color: #2bb8dd;\n  text-decoration: none;\n  border-bottom: 1px solid transparent;\n  transition: border-color 0.3s ease;\n}\n\n.post-content a:hover {\n  border-bottom-color: #2bb8dd;\n}\n\n.post-content ul,\n.post-content ol {\n  margin: 1.5rem 0;\n  padding-left: 2rem;\n}\n\n.post-content li {\n  margin-bottom: 0.5rem;\n}\n\n.post-content blockquote {\n  border-left: 4px solid #2bb8dd;\n  padding: 1rem 1.5rem;\n  margin: 2rem 0;\n  background: #1a1a1a;\n  border-radius: 0 8px 8px 0;\n  font-style: italic;\n}\n\n.post-content code {\n  background: #1a1a1a;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-family: 'Courier New', monospace;\n  color: #2bb8dd;\n}\n\n.post-content pre {\n  background: #1a1a1a;\n  padding: 1.5rem;\n  border-radius: 8px;\n  overflow-x: auto;\n  margin: 1.5rem 0;\n}\n\n/* Social Share */\n.social-share {\n  padding: 2rem 0;\n  border-top: 1px solid #333333;\n  text-align: center;\n}\n\n.social-share h4 {\n  color: #ffffff;\n  margin-bottom: 1.5rem;\n  font-size: 1.2rem;\n}\n\n.share-buttons {\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.share-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 10px 20px;\n  border: 1px solid #333333;\n  background: transparent;\n  color: #9ca3af;\n  border-radius: 25px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 0.9rem;\n}\n\n.share-btn:hover {\n  border-color: #2bb8dd;\n  color: #2bb8dd;\n  background: rgba(43, 184, 221, 0.1);\n  transform: translateY(-2px);\n}\n\n.share-btn.twitter:hover {\n  border-color: #1da1f2;\n  color: #1da1f2;\n  background: rgba(29, 161, 242, 0.1);\n}\n\n.share-btn.facebook:hover {\n  border-color: #4267b2;\n  color: #4267b2;\n  background: rgba(66, 103, 178, 0.1);\n}\n\n.share-btn.linkedin:hover {\n  border-color: #0077b5;\n  color: #0077b5;\n  background: rgba(0, 119, 181, 0.1);\n}\n\n.share-btn.copy:hover {\n  border-color: #10b981;\n  color: #10b981;\n  background: rgba(16, 185, 129, 0.1);\n}\n\n/* Comment Section Styling */\n.comment-section {\n  margin: 4rem 2rem 2rem;\n  max-width: 1000px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.comment-box {\n  background: linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 100%);\n  border-radius: 20px;\n  padding: 2.5rem;\n  border: 1px solid #333333;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n}\n\n.comment-box h3 {\n  font-size: 2rem;\n  font-weight: 700;\n  margin-bottom: 2rem;\n  color: #ffffff;\n  text-align: center;\n  background: linear-gradient(135deg, #2bb8dd 0%, #667eea 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n/* Comment Form */\n.comment-form {\n  background: linear-gradient(135deg, #111111 0%, #1f1f1f 100%);\n  padding: 2rem;\n  border-radius: 15px;\n  margin-bottom: 3rem;\n  border: 1px solid #2a2a2a;\n}\n\n.comment-form input,\n.comment-form textarea {\n  width: 100%;\n  padding: 15px 20px;\n  margin-bottom: 1.5rem;\n  background: #000000;\n  border: 2px solid #333333;\n  border-radius: 12px;\n  color: #ffffff;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n  font-family: inherit;\n}\n\n.comment-form input:focus,\n.comment-form textarea:focus {\n  outline: none;\n  border-color: #2bb8dd;\n  box-shadow: 0 0 0 3px rgba(43, 184, 221, 0.1);\n  background: #0a0a0a;\n}\n\n.comment-form textarea {\n  min-height: 120px;\n  resize: vertical;\n}\n\n.comment-form button {\n  background: linear-gradient(135deg, #2bb8dd 0%, #667eea 100%);\n  color: white;\n  padding: 15px 30px;\n  border: none;\n  border-radius: 12px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  box-shadow: 0 4px 15px rgba(43, 184, 221, 0.3);\n}\n\n.comment-form button:hover {\n  background: linear-gradient(135deg, #2399ba 0%, #5a67d8 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(43, 184, 221, 0.4);\n}\n\n.comment-form button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Comments List */\n.comments-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.comment-item {\n  background: linear-gradient(135deg, #0f0f0f 0%, #1a1a1a 100%);\n  border: 1px solid #2a2a2a;\n  border-radius: 15px;\n  padding: 2rem;\n  margin-bottom: 2rem;\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.comment-item::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 4px;\n  height: 100%;\n  background: linear-gradient(180deg, #2bb8dd 0%, #667eea 100%);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.comment-item:hover {\n  border-color: #2bb8dd;\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(43, 184, 221, 0.15);\n}\n\n.comment-item:hover::before {\n  opacity: 1;\n}\n\n.comment-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 1.5rem;\n}\n\n.comment-author {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.comment-avatar {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #2bb8dd 0%, #667eea 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-weight: 700;\n  font-size: 1.2rem;\n  box-shadow: 0 4px 15px rgba(43, 184, 221, 0.3);\n}\n\n.comment-author-info {\n  flex: 1;\n}\n\n.comment-author-name {\n  font-weight: 700;\n  color: #ffffff;\n  font-size: 1.2rem;\n  margin-bottom: 0.25rem;\n}\n\n.comment-author-email {\n  font-size: 0.9rem;\n  color: #9ca3af;\n}\n\n.comment-meta {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.comment-date {\n  font-size: 0.85rem;\n  color: #6b7280;\n  background: #2a2a2a;\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-weight: 500;\n}\n\n.comment-badge {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  color: white;\n  padding: 4px 12px;\n  border-radius: 15px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.comment-content {\n  color: #e5e7eb;\n  line-height: 1.7;\n  font-size: 1.1rem;\n  margin-bottom: 1.5rem;\n  word-wrap: break-word;\n}\n\n.comment-actions {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.comment-action-btn {\n  background: transparent;\n  border: 1px solid #333333;\n  color: #9ca3af;\n  padding: 8px 16px;\n  border-radius: 20px;\n  cursor: pointer;\n  font-size: 0.85rem;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.comment-action-btn:hover {\n  border-color: #2bb8dd;\n  color: #2bb8dd;\n  background: rgba(43, 184, 221, 0.1);\n  transform: translateY(-1px);\n}\n\n.comment-action-btn.liked {\n  color: #ef4444;\n  border-color: #ef4444;\n  background: rgba(239, 68, 68, 0.1);\n}\n\n.comment-action-btn.delete-btn {\n  color: #ef4444;\n  border-color: #ef4444;\n}\n\n.comment-action-btn.delete-btn:hover {\n  background: rgba(239, 68, 68, 0.1);\n  color: #ef4444;\n}\n\n/* Recent Articles Section */\n.recent-articles {\n  padding: 4rem 2rem;\n  background: linear-gradient(180deg, #000000 0%, #0a0a0a 100%);\n}\n\n.section-header {\n  text-align: center;\n  margin-bottom: 3rem;\n  max-width: 600px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.section-header h2 {\n  font-size: 2.5rem;\n  font-weight: 800;\n  margin-bottom: 1rem;\n  background: linear-gradient(135deg, #ffffff 0%, #2bb8dd 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.section-header p {\n  font-size: 1.1rem;\n  color: #9ca3af;\n  line-height: 1.6;\n}\n\n.articles-container {\n  position: relative;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.articles-wrapper {\n  display: flex;\n  gap: 2rem;\n  overflow-x: auto;\n  scroll-behavior: smooth;\n  padding: 1rem 0 2rem;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.articles-wrapper::-webkit-scrollbar {\n  display: none;\n}\n\n.article-card {\n  flex: 0 0 350px;\n  background: linear-gradient(135deg, #0f0f0f 0%, #1a1a1a 100%);\n  border-radius: 20px;\n  overflow: hidden;\n  border: 1px solid #2a2a2a;\n  transition: all 0.3s ease;\n  position: relative;\n  cursor: pointer;\n}\n\n.article-card:hover {\n  transform: translateY(-8px);\n  border-color: #2bb8dd;\n  box-shadow: 0 15px 40px rgba(43, 184, 221, 0.2);\n}\n\n.card-content {\n  padding: 2rem;\n  position: relative;\n  z-index: 2;\n}\n\n.card-header {\n  margin-bottom: 1rem;\n}\n\n.card-date {\n  background: linear-gradient(135deg, #2bb8dd 0%, #667eea 100%);\n  color: white;\n  padding: 6px 12px;\n  border-radius: 15px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.card-title {\n  font-size: 1.4rem;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 1rem 0;\n  line-height: 1.3;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.card-excerpt {\n  color: #9ca3af;\n  line-height: 1.6;\n  margin-bottom: 1.5rem;\n  font-size: 0.95rem;\n}\n\n.article-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: #2bb8dd;\n  text-decoration: none;\n  font-weight: 600;\n  font-size: 0.9rem;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.article-btn:hover {\n  color: #ffffff;\n  gap: 1rem;\n}\n\n.btn-arrow {\n  transition: transform 0.3s ease;\n}\n\n.article-btn:hover .btn-arrow {\n  transform: translateX(4px);\n}\n\n.card-gradient {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(45deg, rgba(43, 184, 221, 0.05) 0%, rgba(102, 126, 234, 0.05) 100%);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.article-card:hover .card-gradient {\n  opacity: 1;\n}\n\n/* Carousel Controls */\n.carousel-controls {\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n  margin-top: 2rem;\n}\n\n.carousel-btn {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #1a1a1a 0%, #2a2a2a 100%);\n  border: 1px solid #333333;\n  color: #9ca3af;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.2rem;\n}\n\n.carousel-btn:hover {\n  background: linear-gradient(135deg, #2bb8dd 0%, #667eea 100%);\n  color: white;\n  border-color: #2bb8dd;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(43, 184, 221, 0.3);\n}\n\n/* Login Prompt */\n.login-prompt {\n  text-align: center;\n  padding: 3rem 2rem;\n  background: linear-gradient(135deg, #0f0f0f 0%, #1a1a1a 100%);\n  border-radius: 20px;\n  border: 1px solid #2a2a2a;\n}\n\n.login-prompt-icon {\n  font-size: 3rem;\n  margin-bottom: 1rem;\n}\n\n.login-prompt-text {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #ffffff;\n  margin-bottom: 1rem;\n}\n\n.login-prompt p {\n  color: #9ca3af;\n  margin-bottom: 2rem;\n  font-size: 1.1rem;\n}\n\n.login-prompt p {\n  color: #9ca3af;\n  margin-bottom: 2rem;\n  font-size: 1.1rem;\n}\n\n.login-prompt a {\n  display: inline-block;\n  background: linear-gradient(135deg, #2bb8dd 0%, #667eea 100%);\n  color: white;\n  padding: 12px 30px;\n  border-radius: 25px;\n  text-decoration: none;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  box-shadow: 0 4px 15px rgba(43, 184, 221, 0.3);\n}\n\n.login-prompt a:hover {\n  background: linear-gradient(135deg, #2399ba 0%, #5a67d8 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(43, 184, 221, 0.4);\n}\n\n/* Comments Empty State */\n.comments-empty {\n  text-align: center;\n  padding: 4rem 2rem;\n  background: linear-gradient(135deg, #0f0f0f 0%, #1a1a1a 100%);\n  border-radius: 20px;\n  border: 1px solid #2a2a2a;\n}\n\n.comments-empty-icon {\n  font-size: 4rem;\n  margin-bottom: 1.5rem;\n  opacity: 0.7;\n}\n\n.comments-empty-text {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #ffffff;\n  margin-bottom: 0.5rem;\n}\n\n.comments-empty-subtext {\n  color: #9ca3af;\n  font-size: 1rem;\n}\n\n/* Error and Success Messages */\n.error-message {\n  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);\n  color: white;\n  padding: 1rem 1.5rem;\n  border-radius: 12px;\n  margin-bottom: 1.5rem;\n  font-weight: 500;\n  box-shadow: 0 4px 15px rgba(220, 38, 38, 0.3);\n}\n\n.success-message {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  color: white;\n  padding: 1rem 1.5rem;\n  border-radius: 12px;\n  margin-bottom: 1.5rem;\n  font-weight: 500;\n  box-shadow: 0 4px 15px rgba(16, 185, 129, 0.3);\n}\n\n/* Comments Loading State */\n.comments-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 3rem 2rem;\n  background: linear-gradient(135deg, #0f0f0f 0%, #1a1a1a 100%);\n  border-radius: 20px;\n  border: 1px solid #2a2a2a;\n}\n\n.comments-loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid #2a2a2a;\n  border-top: 3px solid #2bb8dd;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 1rem;\n}\n\n.comments-loading p {\n  color: #9ca3af;\n  font-size: 1rem;\n  margin: 0;\n}\n\n/* Replies Container Enhanced */\n.replies-container {\n  margin-top: 2rem;\n  padding: 1.5rem;\n  background: linear-gradient(135deg, rgba(15, 23, 42, 0.3) 0%, rgba(30, 41, 59, 0.2) 100%);\n  border-left: 4px solid #2bb8dd;\n  border-radius: 0 15px 15px 0;\n  position: relative;\n}\n\n.replies-container::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -4px;\n  width: 4px;\n  height: 100%;\n  background: linear-gradient(180deg, #2bb8dd 0%, #10b981 100%);\n}\n\n.replies-header {\n  margin-bottom: 1.5rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid #334155;\n}\n\n.replies-count {\n  color: #2bb8dd;\n  font-weight: 700;\n  font-size: 0.9rem;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  background: rgba(43, 184, 221, 0.1);\n  padding: 6px 12px;\n  border-radius: 15px;\n  display: inline-block;\n}\n\n.replies-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.reply-item {\n  background: linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 100%);\n  border: 1px solid #2a2a2a;\n  border-radius: 15px;\n  padding: 1.5rem;\n  margin-bottom: 1.5rem;\n  position: relative;\n  transition: all 0.3s ease;\n}\n\n.reply-item::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 3px;\n  height: 100%;\n  background: linear-gradient(180deg, #10b981 0%, #059669 100%);\n  border-radius: 0 2px 2px 0;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.reply-item:hover {\n  border-color: #10b981;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.15);\n}\n\n.reply-item:hover::before {\n  opacity: 1;\n}\n\n.reply-avatar {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;\n  width: 40px !important;\n  height: 40px !important;\n  font-size: 1rem !important;\n}\n\n.reply-indicator {\n  color: #10b981;\n  font-size: 0.8rem;\n  margin-left: 0.5rem;\n  font-weight: 600;\n  background: rgba(16, 185, 129, 0.1);\n  padding: 2px 8px;\n  border-radius: 10px;\n}\n\n/* Form Enhancements */\n.reply-form, .edit-form {\n  margin-top: 1.5rem;\n  padding: 1.5rem;\n  background: linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 100%);\n  border-radius: 15px;\n  border: 1px solid #2a2a2a;\n}\n\n.reply-textarea, .edit-textarea {\n  width: 100%;\n  min-height: 100px;\n  padding: 15px;\n  border: 2px solid #333333;\n  border-radius: 12px;\n  background-color: #000000;\n  color: white;\n  font-size: 1rem;\n  resize: vertical;\n  margin-bottom: 1rem;\n  font-family: inherit;\n  transition: all 0.3s ease;\n}\n\n.reply-textarea:focus, .edit-textarea:focus {\n  outline: none;\n  border-color: #2bb8dd;\n  box-shadow: 0 0 0 3px rgba(43, 184, 221, 0.1);\n  background-color: #0a0a0a;\n}\n\n.reply-actions, .edit-actions {\n  display: flex;\n  gap: 1rem;\n}\n\n.reply-btn, .save-btn {\n  background: linear-gradient(135deg, #2bb8dd 0%, #667eea 100%);\n  color: white;\n  padding: 12px 24px;\n  border: none;\n  border-radius: 10px;\n  font-size: 0.9rem;\n  cursor: pointer;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.reply-btn:hover, .save-btn:hover {\n  background: linear-gradient(135deg, #2399ba 0%, #5a67d8 100%);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 15px rgba(43, 184, 221, 0.3);\n}\n\n.cancel-btn {\n  background: transparent;\n  color: #9ca3af;\n  padding: 12px 24px;\n  border: 1px solid #4b5563;\n  border-radius: 10px;\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-weight: 500;\n}\n\n.cancel-btn:hover {\n  background: #374151;\n  color: white;\n  border-color: #6b7280;\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .post-meta {\n    gap: 1.5rem;\n  }\n  \n  .articles-wrapper {\n    gap: 1.5rem;\n  }\n  \n  .article-card {\n    flex: 0 0 300px;\n  }\n}\n\n@media (max-width: 768px) {\n  .single-post-hero {\n    padding: 3rem 1.5rem 2rem;\n  }\n  \n  .post-title {\n    font-size: 2rem;\n  }\n  \n  .post-meta {\n    flex-direction: column;\n    gap: 1rem;\n  }\n  \n  .post-content-wrapper {\n    padding: 2rem 1.5rem;\n  }\n  \n  .comment-box {\n    padding: 2rem 1.5rem;\n  }\n  \n  .comment-form {\n    padding: 1.5rem;\n  }\n  \n  .comment-item {\n    padding: 1.5rem;\n  }\n  \n  .comment-header {\n    flex-direction: column;\n    gap: 1rem;\n  }\n  \n  .comment-meta {\n    align-self: flex-start;\n  }\n  \n  .replies-container {\n    padding: 1rem;\n    margin-left: 0.5rem;\n  }\n  \n  .reply-item {\n    padding: 1.25rem;\n  }\n  \n  .articles-wrapper {\n    gap: 1rem;\n  }\n  \n  .article-card {\n    flex: 0 0 280px;\n  }\n  \n  .card-content {\n    padding: 1.5rem;\n  }\n  \n  .share-buttons {\n    flex-direction: column;\n    align-items: center;\n  }\n  \n  .share-btn {\n    width: 200px;\n    justify-content: center;\n  }\n}\n\n@media (max-width: 480px) {\n  .single-post-hero {\n    padding: 2rem 1rem;\n  }\n  \n  .post-title {\n    font-size: 1.75rem;\n  }\n  \n  .section-header h2 {\n    font-size: 2rem;\n  }\n  \n  .comment-box {\n    padding: 1.5rem 1rem;\n  }\n  \n  .comment-form {\n    padding: 1rem;\n  }\n  \n  .comment-item {\n    padding: 1rem;\n  }\n  \n  .comment-avatar {\n    width: 40px;\n    height: 40px;\n    font-size: 1rem;\n  }\n  \n  .reply-actions, .edit-actions {\n    flex-direction: column;\n  }\n  \n  .reply-btn, .save-btn, .cancel-btn {\n    width: 100%;\n  }\n  \n  .article-card {\n    flex: 0 0 250px;\n  }\n  \n  .carousel-controls {\n    gap: 0.5rem;\n  }\n  \n  .carousel-btn {\n    width: 40px;\n    height: 40px;\n    font-size: 1rem;\n  }\n}\n\n/* Animation for new comments */\n.new-comment {\n  animation: slideInFromTop 0.5s ease-out;\n}\n\n@keyframes slideInFromTop {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Smooth transitions for all interactive elements */\n* {\n  transition: color 0.3s ease, background-color 0.3s ease, border-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease;\n}\n/* Enhanced Share Button Styles */\n.share-btn.success {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  color: white;\n  border-color: #10b981;\n  transform: scale(1.05);\n}\n\n.share-btn.native {\n  background: linear-gradient(135deg, #3fb6e0 0%, #7c3aed 100%);\n  color: white;\n  border-color: #3fb6e0;\n}\n\n.share-btn.native:hover {\n  background: linear-gradient(135deg, #3fb6e0 0%, #6d28d9 100%);\n  border-color: #7c3aed;\n}\n\n.share-stats {\n  margin-top: 1.5rem;\n  text-align: center;\n  padding-top: 1rem;\n  border-top: 1px solid #333333;\n}\n\n.share-stats p {\n  color: #9ca3af;\n  font-size: 0.9rem;\n  margin: 0;\n  font-style: italic;\n}\n\n/* Animation for copy success */\n.share-btn.copy.success {\n  animation: copySuccess 0.3s ease-in-out;\n}\n\n@keyframes copySuccess {\n  0% { transform: scale(1); }\n  50% { transform: scale(1.1); }\n  100% { transform: scale(1.05); }\n}\n\n/* Responsive share buttons */\n@media (max-width: 768px) {\n  .share-buttons {\n    grid-template-columns: repeat(2, 1fr);\n    display: grid;\n    gap: 1rem;\n  }\n  \n  .share-btn {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n@media (max-width: 480px) {\n  .share-buttons {\n    grid-template-columns: 1fr;\n  }\n}\n/* ===== GLOBAL DESIGN SYSTEM ===== */\n:root {\n  /* Colors */\n  --primary-color: #1a73e8;\n  --primary-dark: #1557b0;\n  --primary-light: #4285f4;\n  --secondary-color: #34a853;\n  --accent-color: #fbbc04;\n  --danger-color: #ea4335;\n  --warning-color: #ff9800;\n  \n  /* Neutrals */\n  --white: #ffffff;\n  --gray-50: #f8f9fa;\n  --gray-100: #f1f3f4;\n  --gray-200: #e8eaed;\n  --gray-300: #dadce0;\n  --gray-400: #bdc1c6;\n  --gray-500: #9aa0a6;\n  --gray-600: #80868b;\n  --gray-700: #5f6368;\n  --gray-800: #3c4043;\n  --gray-900: #202124;\n  \n  /* Gradients */\n  --gradient-primary: linear-gradient(135deg, #1a73e8 0%, #4285f4 100%);\n  --gradient-secondary: linear-gradient(135deg, #34a853 0%, #0f9d58 100%);\n  --gradient-hero: linear-gradient(135deg, #1a73e8 0%, #4285f4 50%, #34a853 100%);\n  --gradient-card: linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%);\n  \n  /* Shadows */\n  --shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.1);\n  --shadow-md: 0 4px 12px rgba(0, 0, 0, 0.1);\n  --shadow-lg: 0 8px 25px rgba(0, 0, 0, 0.15);\n  --shadow-xl: 0 20px 40px rgba(0, 0, 0, 0.1);\n  \n  /* Typography */\n  --font-primary: 'Inter', 'Segoe UI', 'Roboto', sans-serif;\n  --font-secondary: 'Poppins', 'Inter', sans-serif;\n  \n  /* Spacing */\n  --spacing-xs: 0.25rem;\n  --spacing-sm: 0.5rem;\n  --spacing-md: 1rem;\n  --spacing-lg: 1.5rem;\n  --spacing-xl: 2rem;\n  --spacing-2xl: 3rem;\n  --spacing-3xl: 4rem;\n  \n  /* Border Radius */\n  --radius-sm: 6px;\n  --radius-md: 12px;\n  --radius-lg: 16px;\n  --radius-xl: 24px;\n  \n  /* Transitions */\n  --transition-fast: 0.15s ease-in-out;\n  --transition-normal: 0.3s ease-in-out;\n  --transition-slow: 0.5s ease-in-out;\n}\n\n/* Global Reset */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: var(--font-primary);\n  line-height: 1.6;\n  color: var(--gray-800);\n  background: var(--gray-50);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* Typography */\nh1, h2, h3, h4, h5, h6 {\n  font-family: var(--font-secondary);\n  font-weight: 600;\n  line-height: 1.3;\n  color: var(--gray-900);\n  margin-bottom: var(--spacing-md);\n}\n\nh1 { font-size: 2.5rem; }\nh2 { font-size: 2rem; }\nh3 { font-size: 1.5rem; }\nh4 { font-size: 1.25rem; }\nh5 { font-size: 1.125rem; }\nh6 { font-size: 1rem; }\n\np {\n  margin-bottom: var(--spacing-md);\n  color: var(--gray-700);\n}\n\n/* Buttons */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-sm);\n  padding: var(--spacing-md) var(--spacing-xl);\n  border: none;\n  border-radius: var(--radius-md);\n  font-family: var(--font-primary);\n  font-weight: 500;\n  font-size: 0.95rem;\n  text-decoration: none;\n  cursor: pointer;\n  transition: all var(--transition-normal);\n  position: relative;\n  overflow: hidden;\n}\n\n.btn-primary {\n  background: var(--gradient-primary);\n  color: var(--white);\n  box-shadow: var(--shadow-md);\n}\n\n.btn-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-lg);\n}\n\n.btn-secondary {\n  background: var(--white);\n  color: var(--primary-color);\n  border: 2px solid var(--primary-color);\n}\n\n.btn-secondary:hover {\n  background: var(--primary-color);\n  color: var(--white);\n}\n\n.btn-danger {\n  background: var(--danger-color);\n  color: var(--white);\n}\n\n.btn-success {\n  background: var(--secondary-color);\n  color: var(--white);\n}\n\n/* Cards */\n.card {\n  background: var(--white);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-md);\n  padding: var(--spacing-xl);\n  transition: all var(--transition-normal);\n  border: 1px solid var(--gray-200);\n}\n\n.card:hover {\n  transform: translateY(-4px);\n  box-shadow: var(--shadow-lg);\n}\n\n.card-header {\n  margin-bottom: var(--spacing-lg);\n  padding-bottom: var(--spacing-lg);\n  border-bottom: 2px solid var(--gray-100);\n}\n\n.card-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: var(--gray-900);\n  margin-bottom: var(--spacing-sm);\n}\n\n.card-subtitle {\n  color: var(--gray-600);\n  font-size: 0.95rem;\n}\n\n/* Forms */\n.form-group {\n  margin-bottom: var(--spacing-lg);\n}\n\n.form-label {\n  display: block;\n  font-weight: 500;\n  color: var(--gray-800);\n  margin-bottom: var(--spacing-sm);\n  font-size: 0.95rem;\n}\n\n.form-input,\n.form-select,\n.form-textarea {\n  width: 100%;\n  padding: var(--spacing-md);\n  border: 2px solid var(--gray-300);\n  border-radius: var(--radius-md);\n  font-family: var(--font-primary);\n  font-size: 0.95rem;\n  transition: all var(--transition-normal);\n  background: var(--white);\n}\n\n.form-input:focus,\n.form-select:focus,\n.form-textarea:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.1);\n}\n\n/* Utilities */\n.text-center { text-align: center; }\n.text-left { text-align: left; }\n.text-right { text-align: right; }\n\n.mb-sm { margin-bottom: var(--spacing-sm); }\n.mb-md { margin-bottom: var(--spacing-md); }\n.mb-lg { margin-bottom: var(--spacing-lg); }\n.mb-xl { margin-bottom: var(--spacing-xl); }\n\n.mt-sm { margin-top: var(--spacing-sm); }\n.mt-md { margin-top: var(--spacing-md); }\n.mt-lg { margin-top: var(--spacing-lg); }\n.mt-xl { margin-top: var(--spacing-xl); }\n\n.p-sm { padding: var(--spacing-sm); }\n.p-md { padding: var(--spacing-md); }\n.p-lg { padding: var(--spacing-lg); }\n.p-xl { padding: var(--spacing-xl); }\n\n/* Animations */\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes slideInRight {\n  from {\n    opacity: 0;\n    transform: translateX(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n.animate-fade-in-up {\n  animation: fadeInUp 0.6s ease-out;\n}\n\n.animate-slide-in-right {\n  animation: slideInRight 0.6s ease-out;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  h1 { font-size: 2rem; }\n  h2 { font-size: 1.75rem; }\n  h3 { font-size: 1.25rem; }\n  \n  .btn {\n    padding: var(--spacing-sm) var(--spacing-lg);\n    font-size: 0.9rem;\n  }\n  \n  .card {\n    padding: var(--spacing-lg);\n  }\n}\n\n/* Loading States */\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid var(--gray-200);\n  border-top: 4px solid var(--primary-color);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin: 0 auto;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: var(--spacing-3xl);\n  gap: var(--spacing-lg);\n}\n\n.loading-text {\n  color: var(--gray-600);\n  font-weight: 500;\n}\n/* FINAL OVERRIDE - Add this at the very end of App.css */\n@media screen and (max-width: 768px) {\n  .dashboard-container .sidebar {\n    display: flex !important;\n    visibility: visible !important;\n    opacity: 1 !important;\n    width: 100% !important;\n    height: 70px !important;\n    position: relative !important;\n    top: 0 !important;\n    left: 0 !important;\n    transform: none !important;\n    background: #2c3e50 !important;\n    border-right: none !important;\n    border-bottom: 2px solid #5a5a5a !important;\n    flex-direction: row !important;\n    z-index: 1000 !important;\n  }\n  \n  .dashboard-container .sidebar ul {\n    display: flex !important;\n    flex-direction: row !important;\n    overflow-x: auto !important;\n    overflow-y: hidden !important;\n    padding: 5px 10px !important;\n    margin: 0 !important;\n    height: 100% !important;\n    align-items: center !important;\n    width: 100% !important;\n  }\n  \n  .dashboard-container .sidebar ul li {\n    display: flex !important;\n    flex-direction: column !important;\n    align-items: center !important;\n    justify-content: center !important;\n    flex: 0 0 auto !important;\n    margin: 0 5px !important;\n    padding: 5px 8px !important;\n    min-width: 150px !important;\n    max-width: 80px !important;\n    height: 55px !important;\n    text-align: center !important;\n    border-radius: 8px !important;\n    white-space: nowrap !important;\n    font-size: 10px !important;\n  }\n  \n  .dashboard-container .sidebar ul li i {\n    font-size: 16px !important;\n    margin-bottom: 2px !important;\n  }\n  \n  .dashboard-container .sidebar ul li span {\n    font-size: 9px !important;\n    line-height: 1 !important;\n  }\n  \n  .dashboard-container .content {\n    margin-left: 0 !important;\n    width: 100% !important;\n    padding: 15px !important;\n  }\n  .dashboard-container .sidebar .sidebar-header {\n    display: none !important;\n  }\n}\n.section-bordered {\n  border-top: 2px solid;\n  border-bottom: 2px solid;\n  border-image: linear-gradient(to right, #2596be, #3b82f6) 1;\n  border-left: none;\n  border-right: none;\n}\n.post-editor-quill {\n  min-height: 200px;\n  margin-bottom: 20px;\n}\n.footer-logo-img {\n  max-width: 35px;\n  height: auto;\n}\n\n.hero-students-image {\n  max-height: 600px;\n  object-fit: cover;\n  min-height: 400px;\n}\n\n.featured-universities-title {\n  color: #ffffff;\n  text-align: center;\n}\n\n.university-card-styled {\n  margin: 15px;\n  background-color: #1e88e5;\n  border-radius: 20px;\n  padding: 35px;\n  box-shadow: 0 15px 30px rgba(0,0,0,0.08);\n  transition: all 0.4s ease;\n  cursor: pointer;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  border: 1px solid rgba(0,0,0,0.05);\n}\n\n.university-card-styled:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 20px 40px rgba(0,0,0,0.12);\n}\n\n.university-icon-centered {\n  display: flex;\n  justify-content: center;\n}\n\n.university-icon-image {\n  border-radius: 50%;\n  width: 75px;\n  object-fit: contain;\n  box-shadow: 0 8px 16px rgba(30,136,229,0.2);\n}\n\n.university-content-centered {\n  text-align: center;\n}\n\n.university-card-title {\n  color: #2bb8dd;\n  font-size: 25px;\n  font-weight: 600;\n  margin-bottom: 18px;\n  letter-spacing: 0.5px;\n}\n\n.university-card-description {\n  color: #ffffff;\n  font-size: 16px;\n  line-height: 1.8;\n  margin-bottom: 0;\n}\n\n.howitworks-title {\n  color: #ffffff;\n  font-size: 22px;\n  font-weight: 600;\n  margin-bottom: 18px;\n  letter-spacing: 0.5px;\n}\n\n.howitworks-description {\n  color: #ffffff;\n}\n\n.footer-logo-image {\n  max-width: 35px;\n}\n/* Prevent the page from scrolling when popup is open */\nbody.popup-open {\n  overflow: hidden;\n}\n\n/* The dark translucent backdrop, full-screen */\n.popup-overlay {\n  animation: fadeIn 0.3s ease-out;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999; /* Corrected here */\n  animation: fadeIn 0.2s ease-out;\n}\n\n/* The white \"card\" in the center */\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes scaleIn {\n  from { \n    opacity: 0;\n    transform: scale(0.95);\n  }\n  to { \n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.popup-content {\n  animation: scaleIn 0.3s ease-out;\n  position: relative;\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);\n  width: 90%; /* shrink on phones */\n  max-width: 480px; /* cap on desktop */\n  max-height: 90%; /* ensures popup doesn't overflow screen */\n  padding: 1.5rem;\n  /* Remove forced internal scroll for most popups; handle overflow in .popup-body.\n     When .popup-content has .image-only we remove padding and allow image to fill. */\n  overflow: visible;\n  animation: scaleUp 0.2s ease-out;\n  z-index: 10000; /* added extra to ensure it's above everything else */\n}\n\n/* Close \"×\" button */\n.popup-close {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  background: none;\n  border: none;\n  font-size: 1.8rem;\n  line-height: 1;\n  cursor: pointer;\n  color: #444;\n  transition: color 0.2s;\n}\n\n.popup-close:hover {\n  color: #000;\n}\n\n/* Responsive media within popup */\n.popup-body img,\n.popup-body video {\n  max-width: 100%;\n  height: auto;\n  display: block;\n  margin: 0 auto;\n}\n\n/* When the popup is image-only (we add this class via JS), remove scroll and padding\n   so the image fills nicely across screen sizes. */\n.popup-content.image-only {\n  padding: 0;\n}\n.popup-content.image-only .popup-body {\n  display:flex;\n  align-items:center;\n  justify-content:center;\n  overflow: visible;\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes scaleUp {\n  from {\n    transform: scale(0.85);\n    opacity: 0;\n  }\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n\n\n\n\n\n\n\n\n\n\n\n/* Student Success Stories Section - Dark Theme */\n.student-success-stories {\n  padding: 60px 0;\n  background-color: #121828; /* matching your navbar background */\n  color: #ffffff;\n}\n\n/* Section Heading */\n.student-success-stories .section-heading h2 {\n  text-align: center;\n  font-size: 2.5rem;\n  margin-bottom: 40px;\n  color: #fff;\n  font-weight: 600;\n}\n\n/* Success Story Card */\n.success-story-card {\n  background: #1e253a; /* slightly lighter than background */\n  border-radius: 12px;\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);\n  padding: 20px;\n  margin: 10px;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.success-story-card:hover {\n  transform: translateY(-10px);\n  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.4);\n}\n\n/* Success Story Image */\n.success-story-image {\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n  overflow: hidden;\n  margin: 0 auto 15px;\n  border: 3px solid #3c7cff; /* Accent color matching theme */\n}\n\n.success-story-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n/* Student Name */\n.student-name {\n  font-size: 1.4rem;\n  color: #ffffff;\n  text-align: center;\n  margin-bottom: 5px;\n  font-weight: 600;\n}\n\n/* University Name */\n.student-university {\n  font-size: 1rem;\n  color: #a0a8b5;\n  text-align: center;\n  margin-bottom: 15px;\n}\n\n/* Student Testimonial */\n.student-testimonial {\n  font-size: 0.95rem;\n  color: #bfc5cf;\n  font-style: italic;\n  text-align: center;\n}\n\n/* Slider Dots matching your theme */\n.slick-dots {\n  bottom: -35px;\n}\n\n.slick-dots li button {\n  background-color: #46516c;\n}\n\n.slick-dots li.slick-active button {\n  background-color: #3c7cff;\n}\n\n\n\n\n\n\n\n\n\n\n\n/* Meet Our Team Section - Dark Theme */\n.meet-our-team {\n  padding: 60px 0;\n  background-color: #121828;\n  color: #ffffff;\n}\n\n.meet-our-team .section-heading h2 {\n  text-align: center;\n  font-size: 2.5rem;\n  margin-bottom: 40px;\n  font-weight: 600;\n}\n\n.meet-our-team .section-intro {\n  max-width: 800px;\n  margin: 0 auto 50px;\n  font-size: 1.1rem;\n  color: #bfc5cf;\n  text-align: center;\n  line-height: 1.6;\n}\n\n/* Grid */\n.meet-our-team .team-grid {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 20px;\n}\n\n.team-member-card {\n  background: #1e253a;\n  border-radius: 12px;\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);\n  padding: 30px 20px;\n  text-align: center;\n  flex: 1 1 calc(45% - 20px);\n  max-width: calc(45% - 20px);\n  /* add a transparent border for the glow */\n  border: 2px solid transparent;\n  transition:\n    border-color 0.3s ease,\n    box-shadow 0.3s ease,\n    transform 0.3s ease;\n}\n\n.team-member-card:hover {\n  /* keep the original dark fill */\n  background-color: #1e253a;\n  /* show a crisp blue outline */\n  border-color: white;\n  /* add a soft outer glow */\n  box-shadow:\n    0 6px 12px rgba(0, 0, 0, 0.3),\n    0 0 10px rgba(60, 124, 255, 0.8);\n  /* slight lift */\n  transform: translateY(-6px);\n}\n\n\n/* Avatar */\n.team-member-image {\n  width: 120px;\n  height: 120px;\n  border-radius: 50%;\n  overflow: hidden;\n  margin: 0 auto 20px;\n  border: 3px solid #3c7cff;\n}\n.team-member-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n/* Text */\n.team-member-name {\n  font-size: 1.6rem;\n  color: #ffffff;\n  margin-bottom: 8px;\n  font-weight: 600;\n}\n.team-member-role {\n  font-size: 1rem;\n  color: #a0a8b5;\n  margin-bottom: 15px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n.team-member-description {\n  font-size: 0.95rem;\n  color: #bfc5cf;\n  line-height: 1.5;\n}\n\n/* Dots if using slick */\n.meet-our-team .slick-dots {\n  bottom: -30px;\n}\n.meet-our-team .slick-dots li button {\n  background-color: #46516c;\n}\n.meet-our-team .slick-dots li.slick-active button {\n  background-color: #3c7cff;\n}\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n  .meet-our-team .team-grid {\n    flex-direction: column;\n    gap: 30px;\n  }\n  .team-member-card {\n    flex: 1 1 100%;\n    max-width: 100%;\n  }\n}\n\n\n\n\n\n\n\n\n\n\n\n.team-member-country {\n  display: inline-block;\n  margin-top: -25px;\n  font-size: 0.9rem;\n  font-weight: 600;\n  padding: 2px 8px;\n  border: 1px solid rgba(255,255,255,0.25);\n  border-radius: 999px;\n  opacity: 0.9;\n}\n\n/* Section base */\n#ourservices {\n  background: var(--section-bg);\n    background-color: ffffff;\n\n  padding: 4rem 0;\n}\n\n/* Make sure text inside isn’t forced to white by global classes */\n#ourservices h1,\n#ourservices h2,\n#ourservices h3,\n#ourservices p,\n#ourservices li,\n#ourservices .desc {\n  color: var(--section-text) !important; \n  \n}\n\n/* Card surfaces + their text */\n#ourservices .item {\n  background: #fff;                /* readable on light bg */\n  color: #111;                     /* ensure body text shows */\n  border-radius: 12px;\n  padding: 20px;\n  transition: transform .2s ease, box-shadow .2s ease;\n    background-color: fffff;\n\n}\n\n[data-theme=\"dark\"] #ourservices .item {\n  background: #161b22;             /* dark card */\n  color: #e6edf3;\n}\n\n#ourservices .item:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 10px 24px rgba(0,0,0,.12);\n}\n\n/* Icon color so it doesn’t inherit white */\n#ourservices .item .social-icon i {\n  margin-bottom: 12px;\n  color: var(--brand-500);\n}\n.contact-map {\n  width: 100%;\n  /* Use a responsive height with a sensible min so the map isn't cropped into a thin strip */\n  height: 100%;\n  min-height: 220px;\n  max-height: 720px;\n  border-radius: 12px;\n  overflow: hidden;\n  display: block;\n  background: transparent !important;\n}\n@media (min-width: 768px) {\n  .contact-map { height: 320px; }\n}\n@media (min-width: 992px) {\n  .contact-map { min-height: 360px; }\n}\n\n/* Ensure inner Google map canvas expands to fill the container */\n.contact-map > * { width:100% !important; height:100% !important; display:block; }\n\n/* Force right column containing the map to let the map stretch: make the parent flow adapt */\n.right-info { display: flex; flex-direction: column; }\n.right-info #contactMap { flex: 1 1 auto; width:100%; height:100%; min-height: 280px; }\n\n/* Make sure small embedded map controls don't show a blank band: allow the map to cover the full box */\n.contact-map .gm-style, .contact-map .gm-style > div { width:100% !important; height:100% !important; }\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
